require("core-js/modules/es.regexp.flags.js");
/*! For license information please see okta-auth-js.umd.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.OktaAuth = t() : e.OktaAuth = t();
}(self, function () {
  return function () {
    var e = {
        6419: function (e, t, n) {
          e.exports = n(7698);
        },
        1511: function (e, t, n) {
          e.exports = n(3363);
        },
        7766: function (e, t, n) {
          e.exports = n(8065);
        },
        116: function (e, t, n) {
          e.exports = n(1955);
        },
        4473: function (e, t, n) {
          e.exports = n(1577);
        },
        8914: function (e, t, n) {
          e.exports = n(6279);
        },
        1643: function (e, t, n) {
          e.exports = n(9373);
        },
        2991: function (e, t, n) {
          e.exports = n(1798);
        },
        3649: function (e, t, n) {
          e.exports = n(2073);
        },
        9340: function (e, t, n) {
          e.exports = n(8933);
        },
        368: function (e, t, n) {
          e.exports = n(7396);
        },
        3978: function (e, t, n) {
          e.exports = n(1910);
        },
        6295: function (e, t, n) {
          e.exports = n(6209);
        },
        1306: function (e, t, n) {
          e.exports = n(3402);
        },
        4074: function (e, t, n) {
          e.exports = n(9427);
        },
        9649: function (e, t, n) {
          e.exports = n(2857);
        },
        4310: function (e, t, n) {
          e.exports = n(9534);
        },
        6902: function (e, t, n) {
          e.exports = n(3059);
        },
        3476: function (e, t, n) {
          e.exports = n(7460);
        },
        5420: function (e, t, n) {
          e.exports = n(2547);
        },
        9969: function (e, t, n) {
          e.exports = n(7641);
        },
        3592: function (e, t, n) {
          e.exports = n(7385);
        },
        8363: function (e, t, n) {
          e.exports = n(1522);
        },
        9996: function (e, t, n) {
          e.exports = n(2209);
        },
        6976: function (e, t, n) {
          e.exports = n(1258);
        },
        5683: function (e, t, n) {
          e.exports = n(9447);
        },
        5238: function (e, t, n) {
          e.exports = n(1493);
        },
        4341: function (e, t, n) {
          e.exports = n(3685);
        },
        3263: function (e, t, n) {
          e.exports = n(4710);
        },
        9356: function (e, t, n) {
          e.exports = n(3799);
        },
        9798: function (e, t, n) {
          e.exports = n(9531);
        },
        1446: function (e, t, n) {
          e.exports = n(6600);
        },
        3882: function (e, t, n) {
          e.exports = n(9759);
        },
        4243: function (e) {
          e.exports = function (e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        7726: function (e, t, n) {
          var r = n(8363);
          e.exports = function (e) {
            if (r(e)) return e;
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        6868: function (e, t, n) {
          var r = n(8363),
            o = n(4243);
          e.exports = function (e) {
            if (r(e)) return o(e);
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        1161: function (e, t, n) {
          var r = n(9798);
          function o(e, t, n, o, i, a, u) {
            try {
              var s = e[a](u),
                c = s.value;
            } catch (e) {
              return void n(e);
            }
            s.done ? t(c) : r.resolve(c).then(o, i);
          }
          e.exports = function (e) {
            return function () {
              var t = this,
                n = arguments;
              return new r(function (r, i) {
                var a = e.apply(t, n);
                function u(e) {
                  o(a, r, i, u, s, "next", e);
                }
                function s(e) {
                  o(a, r, i, u, s, "throw", e);
                }
                u(void 0);
              });
            };
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        7672: function (e, t, n) {
          var r = n(4341);
          e.exports = function (e, t, n) {
            return t in e ? r(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        530: function (e) {
          e.exports = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        5400: function (e, t, n) {
          var r = n(1446),
            o = n(9996),
            i = n(3592);
          e.exports = function (e) {
            if (void 0 !== r && null != o(e) || null != e["@@iterator"]) return i(e);
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        5056: function (e, t, n) {
          var r = n(1446),
            o = n(9996);
          e.exports = function (e, t) {
            var n = null == e ? null : void 0 !== r && o(e) || e["@@iterator"];
            if (null != n) {
              var i,
                a,
                u = [],
                s = !0,
                c = !1;
              try {
                for (n = n.call(e); !(s = (i = n.next()).done) && (u.push(i.value), !t || u.length !== t); s = !0);
              } catch (e) {
                c = !0, a = e;
              } finally {
                try {
                  s || null == n.return || n.return();
                } finally {
                  if (c) throw a;
                }
              }
              return u;
            }
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        9736: function (e) {
          e.exports = function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        6670: function (e) {
          e.exports = function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        122: function (e, t, n) {
          var r = n(3263),
            o = n(5683),
            i = n(4590);
          e.exports = function (e, t) {
            if (null == e) return {};
            var n,
              a,
              u = i(e, t);
            if (r) {
              var s = r(e);
              for (a = 0; a < s.length; a++) n = s[a], o(t).call(t, n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
            }
            return u;
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        4590: function (e, t, n) {
          var r = n(9356),
            o = n(5683);
          e.exports = function (e, t) {
            if (null == e) return {};
            var n,
              i,
              a = {},
              u = r(e);
            for (i = 0; i < u.length; i++) n = u[i], o(t).call(t, n) >= 0 || (a[n] = e[n]);
            return a;
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        8777: function (e, t, n) {
          var r = n(7726),
            o = n(5056),
            i = n(9299),
            a = n(9736);
          e.exports = function (e, t) {
            return r(e) || o(e, t) || i(e, t) || a();
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        9036: function (e, t, n) {
          var r = n(6868),
            o = n(5400),
            i = n(9299),
            a = n(6670);
          e.exports = function (e) {
            return r(e) || o(e) || i(e) || a();
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        3765: function (e, t, n) {
          var r = n(1446),
            o = n(3882);
          function i(t) {
            return "function" == typeof r && "symbol" == typeof o ? (e.exports = i = function (e) {
              return typeof e;
            }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = i = function (e) {
              return e && "function" == typeof r && e.constructor === r && e !== r.prototype ? "symbol" : typeof e;
            }, e.exports.default = e.exports, e.exports.__esModule = !0), i(t);
          }
          e.exports = i, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        9299: function (e, t, n) {
          var r = n(5238),
            o = n(3592),
            i = n(4243);
          e.exports = function (e, t) {
            var n;
            if (e) {
              if ("string" == typeof e) return i(e, t);
              var a = r(n = Object.prototype.toString.call(e)).call(n, 8, -1);
              return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? o(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? i(e, t) : void 0;
            }
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        3109: function (e, t, n) {
          e.exports = n(5666);
        },
        1506: function (e) {
          e.exports = function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        4575: function (e) {
          e.exports = function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        9100: function (e, t, n) {
          var r = n(9489),
            o = n(7067);
          function i(t, n, a) {
            return o() ? (e.exports = i = Reflect.construct, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = i = function (e, t, n) {
              var o = [null];
              o.push.apply(o, t);
              var i = new (Function.bind.apply(e, o))();
              return n && r(i, n.prototype), i;
            }, e.exports.default = e.exports, e.exports.__esModule = !0), i.apply(null, arguments);
          }
          e.exports = i, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        3913: function (e) {
          function t(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }
          e.exports = function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        9754: function (e) {
          function t(n) {
            return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }, e.exports.default = e.exports, e.exports.__esModule = !0, t(n);
          }
          e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        2205: function (e, t, n) {
          var r = n(9489);
          e.exports = function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && r(e, t);
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        430: function (e) {
          e.exports = function (e) {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        7067: function (e) {
          e.exports = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        8585: function (e, t, n) {
          var r = n(8).default,
            o = n(1506);
          e.exports = function (e, t) {
            return !t || "object" !== r(t) && "function" != typeof t ? o(e) : t;
          }, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        9489: function (e) {
          function t(n, r) {
            return e.exports = t = Object.setPrototypeOf || function (e, t) {
              return e.__proto__ = t, e;
            }, e.exports.default = e.exports, e.exports.__esModule = !0, t(n, r);
          }
          e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        8: function (e) {
          function t(n) {
            return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? (e.exports = t = function (e) {
              return typeof e;
            }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = t = function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, e.exports.default = e.exports, e.exports.__esModule = !0), t(n);
          }
          e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        5957: function (e, t, n) {
          var r = n(9754),
            o = n(9489),
            i = n(430),
            a = n(9100);
          function u(t) {
            var n = "function" == typeof Map ? new Map() : void 0;
            return e.exports = u = function (e) {
              if (null === e || !i(e)) return e;
              if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
              if (void 0 !== n) {
                if (n.has(e)) return n.get(e);
                n.set(e, t);
              }
              function t() {
                return a(e, arguments, r(this).constructor);
              }
              return t.prototype = Object.create(e.prototype, {
                constructor: {
                  value: t,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), o(t, e);
            }, e.exports.default = e.exports, e.exports.__esModule = !0, u(t);
          }
          e.exports = u, e.exports.default = e.exports, e.exports.__esModule = !0;
        },
        7757: function (e, t, n) {
          e.exports = n(5666);
        },
        7320: function (e, t, n) {
          "use strict";

          var r = n(3978),
            o = n(530);
          r(t, "__esModule", {
            value: !0
          }), t.default = void 0;
          var i = o(n(3109));
          n(9600);
          var a = o(n(8777)),
            u = o(n(1161)),
            s = o(n(3476)),
            c = o(n(2991)),
            f = o(n(6295)),
            l = o(n(7766)),
            p = n(1032),
            h = function (e) {
              return e.json().then(function (e) {
                return s.default.reject(e);
              });
            },
            d = function () {
              var e = (0, u.default)(i.default.mark(function e(t) {
                var n, r, o, u, s, d, v, g, y, m, b, k, w, x;
                return i.default.wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return r = t.clientId, o = t.baseUrl, u = t.scopes, s = void 0 === u ? ["openid", "email"] : u, d = t.redirectUri, v = t.codeChallenge, g = t.codeChallengeMethod, y = t.state, m = t.activationToken, b = "".concat(o, "/v1/interact"), k = {
                        client_id: r,
                        scope: s.join(" "),
                        redirect_uri: d,
                        code_challenge: v,
                        code_challenge_method: g,
                        state: y
                      }, m && (k.activation_token = m), w = (0, c.default)(n = (0, f.default)(k)).call(n, function (e) {
                        var t,
                          n = (0, a.default)(e, 2),
                          r = n[0],
                          o = n[1];
                        return (0, l.default)(t = "".concat(r, "=")).call(t, encodeURIComponent(o));
                      }).join("&"), x = {
                        "content-type": "application/x-www-form-urlencoded"
                      }, e.abrupt("return", (0, p.request)(b, {
                        headers: x,
                        body: w
                      }).then(function (e) {
                        return e.ok ? e.json() : h(e);
                      }).then(function (e) {
                        return e.interaction_handle;
                      }));
                    case 7:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t) {
                return e.apply(this, arguments);
              };
            }(),
            v = d;
          t.default = v;
        },
        1032: function (e, t, n) {
          "use strict";

          var r = n(6902),
            o = n(4310),
            i = n(116),
            a = n(4074),
            u = n(8914),
            s = n(9649),
            c = n(368),
            f = n(3978),
            l = n(530);
          f(t, "__esModule", {
            value: !0
          }), t.request = t.HttpClient = void 0;
          var p = l(n(3109)),
            h = l(n(8914)),
            d = l(n(7672)),
            v = l(n(1161)),
            g = l(n(4098)),
            y = n(8082);
          function m(e, t) {
            var n = r(e);
            if (o) {
              var u = o(e);
              t && (u = i(u).call(u, function (t) {
                return a(e, t).enumerable;
              })), n.push.apply(n, u);
            }
            return n;
          }
          function b(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n,
                r = null != arguments[t] ? arguments[t] : {};
              if (t % 2) u(n = m(Object(r), !0)).call(n, function (t) {
                (0, d.default)(e, t, r[t]);
              });else if (s) c(e, s(r));else {
                var o;
                u(o = m(Object(r))).call(o, function (t) {
                  f(e, t, a(r, t));
                });
              }
            }
            return e;
          }
          var k = {
            interceptors: {
              request: new function () {
                this.handlers = [], this.use = function (e) {
                  this.handlers.push({
                    before: e
                  });
                }, this.clear = function () {
                  this.handlers = [];
                };
              }()
            }
          };
          t.HttpClient = k;
          var w = function () {
            var e = (0, v.default)(p.default.mark(function e(t, n) {
              var r, o, i, a, u, s, c, f, l, d;
              return p.default.wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return r = n.method, o = void 0 === r ? "POST" : r, i = n.headers, a = void 0 === i ? {} : i, u = n.credentials, s = void 0 === u ? "include" : u, c = n.body, f = {
                      url: t,
                      method: o,
                      headers: b(b({}, (0, y.userAgentHeaders)()), a),
                      credentials: s,
                      body: c
                    }, k.interceptors && (0, h.default)(l = k.interceptors.request.handlers).call(l, function (e) {
                      e.before(f);
                    }), d = f.url, delete f.url, e.abrupt("return", (0, g.default)(d, f));
                  case 6:
                  case "end":
                    return e.stop();
                }
              }, e);
            }));
            return function (t, n) {
              return e.apply(this, arguments);
            };
          }();
          t.request = w;
        },
        6760: function (e, t, n) {
          "use strict";

          var r = n(3978),
            o = n(530);
          r(t, "__esModule", {
            value: !0
          }), t.default = void 0;
          var i = o(n(3109)),
            a = o(n(1643)),
            u = o(n(3476)),
            s = o(n(9969));
          n(5306), n(4916);
          var c = o(n(1161)),
            f = o(n(5284)),
            l = o(n(7320)),
            p = o(n(3584)),
            h = n(1032),
            d = "1.0.0",
            v = function () {
              var e = (0, c.default)(i.default.mark(function e(t) {
                var n, r, o, c, h, d, v, g, y, m, b, k, w, x, S, T, O, A, E, _, R, P, j;
                return i.default.wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (o = t.clientId, c = t.domain, h = t.issuer, d = t.stateHandle, v = t.interactionHandle, g = t.version, y = t.redirectUri, m = t.state, b = t.scopes, k = t.codeChallenge, w = t.codeChallengeMethod, x = t.stateTokenExternalId, S = t.activationToken, h = null === (n = h) || void 0 === n ? void 0 : n.replace(/\/+$/, ""), T = (null === (r = h) || void 0 === r ? void 0 : (0, a.default)(r).call(r, "/oauth2")) > 0 ? h : h + "/oauth2", O = {
                        baseUrl: T,
                        clientId: o,
                        state: m
                      }, c || h) {
                        e.next = 6;
                        break;
                      }
                      return e.abrupt("return", u.default.reject({
                        error: "issuer is required"
                      }));
                    case 6:
                      if (d || o) {
                        e.next = 8;
                        break;
                      }
                      return e.abrupt("return", u.default.reject({
                        error: "clientId is required"
                      }));
                    case 8:
                      if (d || y) {
                        e.next = 10;
                        break;
                      }
                      return e.abrupt("return", u.default.reject({
                        error: "redirectUri is required"
                      }));
                    case 10:
                      if (d || k && w) {
                        e.next = 12;
                        break;
                      }
                      return e.abrupt("return", u.default.reject({
                        error: "PKCE params (codeChallenge, codeChallengeMethod) are required"
                      }));
                    case 12:
                      if (c || (c = new s.default(h).origin), g) {
                        e.next = 15;
                        break;
                      }
                      return e.abrupt("return", u.default.reject({
                        error: "version is required"
                      }));
                    case 15:
                      if ((null != g ? g : "").replace(/[^0-9a-zA-Z._-]/, "") === g && g) {
                        e.next = 18;
                        break;
                      }
                      return e.abrupt("return", u.default.reject({
                        error: "invalid version supplied - version is required and uses semver syntax"
                      }));
                    case 18:
                      if (d || v) {
                        e.next = 31;
                        break;
                      }
                      return e.prev = 19, A = {
                        clientId: o,
                        baseUrl: T,
                        scopes: b,
                        redirectUri: y,
                        codeChallenge: k,
                        codeChallengeMethod: w,
                        state: m,
                        activationToken: S
                      }, e.next = 23, (0, l.default)(A);
                    case 23:
                      E = e.sent, v = E, O.interactionHandle = v, e.next = 31;
                      break;
                    case 28:
                      return e.prev = 28, e.t0 = e.catch(19), e.abrupt("return", u.default.reject({
                        error: e.t0
                      }));
                    case 31:
                      return e.prev = 31, _ = (0, p.default)(g), R = _.makeIdxState, e.next = 35, (0, f.default)({
                        domain: c,
                        interactionHandle: v,
                        stateHandle: d,
                        version: g,
                        stateTokenExternalId: x
                      }).catch(function (e) {
                        return u.default.reject({
                          error: "introspect call failed",
                          details: R(e, O)
                        });
                      });
                    case 35:
                      return P = e.sent, j = R(P, O), e.abrupt("return", j);
                    case 40:
                      return e.prev = 40, e.t1 = e.catch(31), e.abrupt("return", u.default.reject({
                        error: e.t1
                      }));
                    case 43:
                    case "end":
                      return e.stop();
                  }
                }, e, null, [[19, 28], [31, 40]]);
              }));
              return function (t) {
                return e.apply(this, arguments);
              };
            }(),
            g = (0, p.default)(d).makeIdxState,
            y = {
              start: v,
              introspect: f.default,
              interact: l.default,
              makeIdxState: g,
              client: h.HttpClient,
              LATEST_SUPPORTED_IDX_API_VERSION: d
            };
          t.default = y;
        },
        5284: function (e, t, n) {
          "use strict";

          var r = n(3978),
            o = n(530);
          r(t, "__esModule", {
            value: !0
          }), t.default = void 0;
          var i = o(n(3109)),
            a = o(n(1161)),
            u = o(n(3476)),
            s = o(n(9340)),
            c = n(1032),
            f = function (e) {
              return e.json().then(function (e) {
                return u.default.reject(e);
              });
            },
            l = function () {
              var e = (0, a.default)(i.default.mark(function e(t) {
                var n, r, o, a, u, l, p, h;
                return i.default.wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return n = t.domain, r = t.interactionHandle, o = t.stateHandle, a = t.version, u = t.stateTokenExternalId, l = "".concat(n, "/idp/idx/introspect"), p = o ? {
                        stateToken: o
                      } : {
                        interactionHandle: r
                      }, u && (p.stateTokenExternalId = u), h = {
                        "content-type": "application/ion+json; okta-version=".concat(a),
                        accept: "application/ion+json; okta-version=".concat(a)
                      }, e.abrupt("return", (0, c.request)(l, {
                        headers: h,
                        body: (0, s.default)(p)
                      }).then(function (e) {
                        return e.ok ? e.json() : f(e);
                      }));
                    case 6:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t) {
                return e.apply(this, arguments);
              };
            }(),
            p = l;
          t.default = p;
        },
        3584: function (e, t, n) {
          "use strict";

          var r = n(3978),
            o = n(530);
          r(t, "__esModule", {
            value: !0
          }), t.default = void 0;
          var i = o(n(2080));
          t.default = function (e) {
            switch (e) {
              case "1.0.0":
                return i.default;
              case void 0:
              case null:
                throw new Error("Api version is required");
              default:
                throw new Error("Unknown api version: ".concat(e, ".  Use an exact semver version."));
            }
          };
        },
        8082: function (e, t, n) {
          "use strict";

          n(3978)(t, "__esModule", {
            value: !0
          }), t.userAgentHeaders = t.getUserAgent = void 0;
          var r = function () {
            return "okta-idx-js/".concat("0.23.0");
          };
          t.getUserAgent = r, t.userAgentHeaders = function () {
            return {
              "X-Okta-User-Agent-Extended": r()
            };
          };
        },
        35: function (e, t, n) {
          "use strict";

          n(1539);
          var r = n(3649),
            o = n(6419),
            i = n(5420),
            a = n(9996),
            u = n(1511),
            s = n(6976),
            c = n(3978),
            f = n(530);
          c(t, "__esModule", {
            value: !0
          }), t.divideActionParamsByMutability = void 0;
          var l = f(n(1511));
          function p(e, t) {
            var n;
            if (void 0 === i || null == a(e)) {
              if (u(e) || (n = function (e, t) {
                var n;
                if (e) {
                  if ("string" == typeof e) return h(e, t);
                  var i = r(n = Object.prototype.toString.call(e)).call(n, 8, -1);
                  return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? o(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? h(e, t) : void 0;
                }
              }(e)) || t && e && "number" == typeof e.length) {
                n && (e = n);
                var c = 0,
                  f = function () {};
                return {
                  s: f,
                  n: function () {
                    return c >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[c++]
                    };
                  },
                  e: function (e) {
                    throw e;
                  },
                  f: f
                };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var l,
              p = !0,
              d = !1;
            return {
              s: function () {
                n = s(e);
              },
              n: function () {
                var e = n.next();
                return p = e.done, e;
              },
              e: function (e) {
                d = !0, l = e;
              },
              f: function () {
                try {
                  p || null == n.return || n.return();
                } finally {
                  if (d) throw l;
                }
              }
            };
          }
          function h(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          n(8309);
          var d = function (e) {
              return !1 !== e.mutable;
            },
            v = function (e) {
              var t = {},
                n = [],
                r = {};
              if (!e.value) return n.push(e), {
                defaultParamsForAction: t,
                neededParamsForAction: n,
                immutableParamsForAction: r
              };
              var o,
                i = p(e.value);
              try {
                for (i.s(); !(o = i.n()).done;) {
                  var a,
                    u,
                    s = o.value;
                  d(s) ? (n.push(s), null !== (a = s.value) && void 0 !== a && a && (t[s.name] = s.value)) : r[s.name] = null !== (u = s.value) && void 0 !== u ? u : "";
                }
              } catch (e) {
                i.e(e);
              } finally {
                i.f();
              }
              return {
                defaultParamsForAction: t,
                neededParamsForAction: n,
                immutableParamsForAction: r
              };
            };
          t.divideActionParamsByMutability = function (e) {
            var t,
              n = [],
              r = {},
              o = {},
              i = p(e = (0, l.default)(e) ? e : [e]);
            try {
              for (i.s(); !(t = i.n()).done;) {
                var a = t.value,
                  u = v(a),
                  s = u.defaultParamsForAction,
                  c = u.neededParamsForAction,
                  f = u.immutableParamsForAction;
                n.push(c), r[a.name] = s, o[a.name] = f;
              }
            } catch (e) {
              i.e(e);
            } finally {
              i.f();
            }
            return {
              defaultParams: r,
              neededParams: n,
              immutableParams: o
            };
          };
        },
        7700: function (e, t, n) {
          "use strict";

          var r = n(6902),
            o = n(4310),
            i = n(116),
            a = n(4074),
            u = n(8914),
            s = n(9649),
            c = n(368),
            f = n(3978),
            l = n(530);
          f(t, "__esModule", {
            value: !0
          }), t.default = void 0, n(8309);
          var p = l(n(3109)),
            h = l(n(9340)),
            d = l(n(3476)),
            v = l(n(7672)),
            g = l(n(1161)),
            y = n(1032),
            m = n(35),
            b = l(n(4807));
          function k(e, t) {
            var n = r(e);
            if (o) {
              var u = o(e);
              t && (u = i(u).call(u, function (t) {
                return a(e, t).enumerable;
              })), n.push.apply(n, u);
            }
            return n;
          }
          function w(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n,
                r = null != arguments[t] ? arguments[t] : {};
              if (t % 2) u(n = k(Object(r), !0)).call(n, function (t) {
                (0, v.default)(e, t, r[t]);
              });else if (s) c(e, s(r));else {
                var o;
                u(o = k(Object(r))).call(o, function (t) {
                  f(e, t, a(r, t));
                });
              }
            }
            return e;
          }
          var x = function (e) {
            var t = e.actionDefinition,
              n = e.defaultParamsForAction,
              r = void 0 === n ? {} : n,
              o = e.immutableParamsForAction,
              i = void 0 === o ? {} : o,
              a = e.toPersist,
              u = t.href;
            return function () {
              var e = (0, g.default)(p.default.mark(function e(n) {
                var o, s;
                return p.default.wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = {
                        "content-type": "application/json",
                        accept: t.accepts || "application/ion+json"
                      }, s = (0, h.default)(w(w(w({}, r), n), i)), e.abrupt("return", (0, y.request)(u, {
                        method: t.method,
                        headers: o,
                        body: s
                      }).then(function (e) {
                        var t = e.json();
                        return e.ok ? t : 401 === e.status && 'Oktadevicejwt realm="Okta Device"' === e.headers.get("WWW-Authenticate") ? t.then(function (e) {
                          var t = (0, b.default)(e, a);
                          return t.stepUp = !0, d.default.reject(t);
                        }) : t.then(function (e) {
                          return d.default.reject((0, b.default)(e, a));
                        });
                      }).then(function (e) {
                        return (0, b.default)(e, a);
                      }));
                    case 3:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t) {
                return e.apply(this, arguments);
              };
            }();
          };
          t.default = function (e, t) {
            var n = x,
              r = (0, m.divideActionParamsByMutability)(e),
              o = r.defaultParams,
              i = r.neededParams,
              a = r.immutableParams,
              u = n({
                actionDefinition: e,
                defaultParamsForAction: o[e.name],
                immutableParamsForAction: a[e.name],
                toPersist: t
              });
            return u.neededParams = i, u;
          };
        },
        8440: function (e, t, n) {
          "use strict";

          var r = n(6902),
            o = n(4310),
            i = n(116),
            a = n(4074),
            u = n(8914),
            s = n(9649),
            c = n(368),
            f = n(3978),
            l = n(530);
          f(t, "__esModule", {
            value: !0
          }), t.parseIdxResponse = t.parseNonRemediations = void 0, n(8309);
          var p,
            h = l(n(8777)),
            d = l(n(7672)),
            v = l(n(122)),
            g = l(n(3765)),
            y = l(n(1306)),
            m = l(n(2991)),
            b = l(n(8914)),
            k = l(n(116)),
            w = l(n(6902)),
            x = l(n(6295)),
            S = l(n(7766)),
            T = l(n(1511)),
            O = n(7689),
            A = l(n(7700)),
            E = n(5653);
          function _(e, t) {
            var n = r(e);
            if (o) {
              var u = o(e);
              t && (u = i(u).call(u, function (t) {
                return a(e, t).enumerable;
              })), n.push.apply(n, u);
            }
            return n;
          }
          function R(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n,
                r = null != arguments[t] ? arguments[t] : {};
              if (t % 2) u(n = _(Object(r), !0)).call(n, function (t) {
                (0, d.default)(e, t, r[t]);
              });else if (s) c(e, s(r));else {
                var o;
                u(o = _(Object(r))).call(o, function (t) {
                  f(e, t, a(r, t));
                });
              }
            }
            return e;
          }
          var P = (0, y.default)((0, m.default)(p = ["remediation", "context"]).call(p, function (e) {
              return [e, !0];
            })),
            j = function (e) {
              var t,
                n,
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                o = {},
                i = {};
              return (0, b.default)(t = (0, k.default)(n = (0, w.default)(e)).call(n, function (e) {
                return !P[e];
              })).call(t, function (t) {
                var n;
                if ("object" === (0, g.default)(e[t]) && e[t]) {
                  if (e[t].rel) o[e[t].name] = (0, A.default)(e[t], r);else {
                    var a = e[t],
                      u = a.value,
                      s = a.type,
                      c = (0, v.default)(a, ["value", "type"]);
                    i[t] = R({
                      type: s
                    }, c), "object" === s ? (i[t].value = {}, (0, b.default)(n = (0, x.default)(u)).call(n, function (e) {
                      var n,
                        a = (0, h.default)(e, 2),
                        u = a[0],
                        s = a[1];
                      s.rel ? o[(0, S.default)(n = "".concat(t, "-")).call(n, u.name || u)] = (0, A.default)(s, r) : i[t].value[u] = s;
                    })) : i[t].value = u;
                  }
                } else i[t] = e[t];
              }), {
                context: i,
                actions: o
              };
            };
          t.parseNonRemediations = j;
          var I = function e(t, n) {
              var r;
              (0, b.default)(r = (0, w.default)(n)).call(r, function (r) {
                if ("relatesTo" === r) {
                  var o = (0, T.default)(n[r]) ? n[r][0] : n[r];
                  if ("string" == typeof o) {
                    var i = (0, E.JSONPath)({
                      path: o,
                      json: t
                    })[0];
                    if (i) return void (n[r] = i);
                  }
                }
                var a;
                (0, T.default)(n[r]) && (0, b.default)(a = n[r]).call(a, function (n) {
                  return e(t, n);
                });
              });
            },
            C = function (e, t) {
              var n = (0, O.generateRemediationFunctions)([e], t)[e.name];
              return R(R({}, e), {}, {
                action: n
              });
            };
          t.parseIdxResponse = function (e) {
            var t,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = (null === (t = e.remediation) || void 0 === t ? void 0 : t.value) || [];
            (0, b.default)(r).call(r, function (t) {
              return I(e, t);
            });
            var o = (0, m.default)(r).call(r, function (e) {
                return C(e, n);
              }),
              i = j(e, n),
              a = i.context,
              u = i.actions;
            return {
              remediations: o,
              context: a,
              actions: u
            };
          };
        },
        4807: function (e, t, n) {
          "use strict";

          var r = n(3978),
            o = n(530);
          r(t, "__esModule", {
            value: !0
          }), t.default = void 0;
          var i = o(n(3109));
          n(8309);
          var a = o(n(4473)),
            u = o(n(3476)),
            s = o(n(1161)),
            c = o(n(9036)),
            f = n(8440);
          t.default = function (e, t) {
            var n,
              r,
              o = e,
              l = (0, f.parseIdxResponse)(e, t),
              p = l.remediations,
              h = l.context,
              d = l.actions,
              v = (0, c.default)(p),
              g = function () {
                var e = (0, s.default)(i.default.mark(function e(t) {
                  var n,
                    r,
                    o = arguments;
                  return i.default.wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, a.default)(p).call(p, function (e) {
                          return e.name === t;
                        })) {
                          e.next = 4;
                          break;
                        }
                        return e.abrupt("return", u.default.reject("Unknown remediation choice: [".concat(t, "]")));
                      case 4:
                        return e.abrupt("return", r.action(n));
                      case 5:
                      case "end":
                        return e.stop();
                    }
                  }, e);
                }));
                return function (t) {
                  return e.apply(this, arguments);
                };
              }(),
              y = null === (n = o.successWithInteractionCode) || void 0 === n ? void 0 : (0, a.default)(r = n.value).call(r, function (e) {
                return "interaction_code" === e.name;
              }).value;
            return {
              proceed: g,
              neededToProceed: v,
              actions: d,
              context: h,
              rawIdxState: o,
              hasInteractionCode: function () {
                return !!o.successWithInteractionCode;
              },
              interactionCode: y,
              toPersist: t
            };
          };
        },
        2080: function (e, t, n) {
          "use strict";

          var r = n(3978),
            o = n(530);
          r(t, "__esModule", {
            value: !0
          }), t.default = void 0;
          var i = {
            makeIdxState: o(n(4807)).default
          };
          t.default = i;
        },
        7689: function (e, t, n) {
          "use strict";

          var r = n(3978),
            o = n(530);
          r(t, "__esModule", {
            value: !0
          }), t.generateRemediationFunctions = void 0, n(8309);
          var i = o(n(1306)),
            a = o(n(2991)),
            u = o(n(7700));
          t.generateRemediationFunctions = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return (0, i.default)((0, a.default)(e).call(e, function (e) {
              return [e.name, (0, u.default)(e, t)];
            }));
          };
        },
        3615: function (e, t, n) {
          "use strict";

          var r = n(4575),
            o = n(3913),
            i = n(2205),
            a = n(8585),
            u = n(9754);
          function s(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          var c = function (e) {
              i(c, e);
              var t,
                n,
                s = (t = c, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = u(t);
                  if (n) {
                    var o = u(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return a(this, e);
                });
              function c(e) {
                var t;
                return r(this, c), (t = s.call(this, e || "Promise was canceled")).name = "CancelError", t;
              }
              return o(c, [{
                key: "isCanceled",
                get: function () {
                  return !0;
                }
              }]), c;
            }(n(5957)(Error)),
            f = function () {
              function e(t) {
                var n = this;
                r(this, e), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function (e, r) {
                  n._reject = r;
                  var o = function (e) {
                    if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
                    n._cancelHandlers.push(e);
                  };
                  return Object.defineProperties(o, {
                    shouldReject: {
                      get: function () {
                        return n._rejectOnCancel;
                      },
                      set: function (e) {
                        n._rejectOnCancel = e;
                      }
                    }
                  }), t(function (t) {
                    n._isCanceled && o.shouldReject || (n._isPending = !1, e(t));
                  }, function (e) {
                    n._isPending = !1, r(e);
                  }, o);
                });
              }
              return o(e, [{
                key: "then",
                value: function (e, t) {
                  return this._promise.then(e, t);
                }
              }, {
                key: "catch",
                value: function (e) {
                  return this._promise.catch(e);
                }
              }, {
                key: "finally",
                value: function (e) {
                  return this._promise.finally(e);
                }
              }, {
                key: "cancel",
                value: function (e) {
                  if (this._isPending && !this._isCanceled) {
                    if (this._isCanceled = !0, this._cancelHandlers.length > 0) try {
                      var t,
                        n = function (e, t) {
                          var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                          if (!n) {
                            if (Array.isArray(e) || (n = function (e, t) {
                              if (e) {
                                if ("string" == typeof e) return s(e, t);
                                var n = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(e, t) : void 0;
                              }
                            }(e)) || t && e && "number" == typeof e.length) {
                              n && (e = n);
                              var r = 0,
                                o = function () {};
                              return {
                                s: o,
                                n: function () {
                                  return r >= e.length ? {
                                    done: !0
                                  } : {
                                    done: !1,
                                    value: e[r++]
                                  };
                                },
                                e: function (e) {
                                  throw e;
                                },
                                f: o
                              };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                          }
                          var i,
                            a = !0,
                            u = !1;
                          return {
                            s: function () {
                              n = n.call(e);
                            },
                            n: function () {
                              var e = n.next();
                              return a = e.done, e;
                            },
                            e: function (e) {
                              u = !0, i = e;
                            },
                            f: function () {
                              try {
                                a || null == n.return || n.return();
                              } finally {
                                if (u) throw i;
                              }
                            }
                          };
                        }(this._cancelHandlers);
                      try {
                        for (n.s(); !(t = n.n()).done;) (0, t.value)();
                      } catch (e) {
                        n.e(e);
                      } finally {
                        n.f();
                      }
                    } catch (e) {
                      return void this._reject(e);
                    }
                    this._rejectOnCancel && this._reject(new c(e));
                  }
                }
              }, {
                key: "isCanceled",
                get: function () {
                  return this._isCanceled;
                }
              }], [{
                key: "fn",
                value: function (t) {
                  return function () {
                    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
                    return new e(function (e, n, o) {
                      r.push(o), t.apply(void 0, r).then(e, n);
                    });
                  };
                }
              }]), e;
            }();
          Object.setPrototypeOf(f.prototype, Promise.prototype), e.exports = f, e.exports.CancelError = c;
        },
        4493: function (e, t, n) {
          n(7971), n(3242);
          var r = n(4058);
          e.exports = r.Array.from;
        },
        4034: function (e, t, n) {
          n(2737);
          var r = n(4058);
          e.exports = r.Array.isArray;
        },
        5367: function (e, t, n) {
          n(5906);
          var r = n(5703);
          e.exports = r("Array").concat;
        },
        2383: function (e, t, n) {
          n(1501);
          var r = n(5703);
          e.exports = r("Array").filter;
        },
        7671: function (e, t, n) {
          n(833);
          var r = n(5703);
          e.exports = r("Array").find;
        },
        9324: function (e, t, n) {
          n(2437);
          var r = n(5703);
          e.exports = r("Array").forEach;
        },
        8700: function (e, t, n) {
          n(9076);
          var r = n(5703);
          e.exports = r("Array").indexOf;
        },
        3866: function (e, t, n) {
          n(8787);
          var r = n(5703);
          e.exports = r("Array").map;
        },
        4900: function (e, t, n) {
          n(186);
          var r = n(5703);
          e.exports = r("Array").slice;
        },
        6043: function (e, t, n) {
          var r = n(5367),
            o = Array.prototype;
          e.exports = function (e) {
            var t = e.concat;
            return e === o || e instanceof Array && t === o.concat ? r : t;
          };
        },
        2480: function (e, t, n) {
          var r = n(2383),
            o = Array.prototype;
          e.exports = function (e) {
            var t = e.filter;
            return e === o || e instanceof Array && t === o.filter ? r : t;
          };
        },
        2236: function (e, t, n) {
          var r = n(7671),
            o = Array.prototype;
          e.exports = function (e) {
            var t = e.find;
            return e === o || e instanceof Array && t === o.find ? r : t;
          };
        },
        4570: function (e, t, n) {
          var r = n(8700),
            o = Array.prototype;
          e.exports = function (e) {
            var t = e.indexOf;
            return e === o || e instanceof Array && t === o.indexOf ? r : t;
          };
        },
        8287: function (e, t, n) {
          var r = n(3866),
            o = Array.prototype;
          e.exports = function (e) {
            var t = e.map;
            return e === o || e instanceof Array && t === o.map ? r : t;
          };
        },
        9601: function (e, t, n) {
          var r = n(4900),
            o = Array.prototype;
          e.exports = function (e) {
            var t = e.slice;
            return e === o || e instanceof Array && t === o.slice ? r : t;
          };
        },
        4426: function (e, t, n) {
          n(2619);
          var r = n(4058);
          r.JSON || (r.JSON = {
            stringify: JSON.stringify
          }), e.exports = function (e, t, n) {
            return r.JSON.stringify.apply(null, arguments);
          };
        },
        7702: function (e, t, n) {
          n(4979);
          var r = n(4058).Object,
            o = e.exports = function (e, t) {
              return r.defineProperties(e, t);
            };
          r.defineProperties.sham && (o.sham = !0);
        },
        8171: function (e, t, n) {
          n(6450);
          var r = n(4058).Object,
            o = e.exports = function (e, t, n) {
              return r.defineProperty(e, t, n);
            };
          r.defineProperty.sham && (o.sham = !0);
        },
        3081: function (e, t, n) {
          n(1078);
          var r = n(4058);
          e.exports = r.Object.entries;
        },
        7699: function (e, t, n) {
          n(6274), n(8387);
          var r = n(4058);
          e.exports = r.Object.fromEntries;
        },
        286: function (e, t, n) {
          n(6924);
          var r = n(4058).Object,
            o = e.exports = function (e, t) {
              return r.getOwnPropertyDescriptor(e, t);
            };
          r.getOwnPropertyDescriptor.sham && (o.sham = !0);
        },
        2766: function (e, t, n) {
          n(8482);
          var r = n(4058);
          e.exports = r.Object.getOwnPropertyDescriptors;
        },
        498: function (e, t, n) {
          n(5824);
          var r = n(4058);
          e.exports = r.Object.getOwnPropertySymbols;
        },
        8494: function (e, t, n) {
          n(1724);
          var r = n(4058);
          e.exports = r.Object.keys;
        },
        2956: function (e, t, n) {
          n(7627), n(5967), n(8881), n(4560), n(7206), n(4349), n(7971), n(7634);
          var r = n(4058);
          e.exports = r.Promise;
        },
        7473: function (e, t, n) {
          n(5906), n(5967), n(5824), n(8555), n(2615), n(1732), n(5903), n(1825), n(8394), n(5915), n(1766), n(9791), n(9911), n(4315), n(3131), n(4714), n(659), n(9120), n(5327), n(1502);
          var r = n(4058);
          e.exports = r.Symbol;
        },
        4227: function (e, t, n) {
          n(1825), n(7971), n(7634);
          var r = n(1477);
          e.exports = r.f("iterator");
        },
        7385: function (e, t, n) {
          var r = n(4493);
          e.exports = r;
        },
        1522: function (e, t, n) {
          var r = n(4034);
          e.exports = r;
        },
        2209: function (e, t, n) {
          n(7634), n(7971);
          var r = n(2902);
          e.exports = r;
        },
        1258: function (e, t, n) {
          n(7634), n(7971);
          var r = n(429);
          e.exports = r;
        },
        9447: function (e, t, n) {
          var r = n(4570);
          e.exports = r;
        },
        1493: function (e, t, n) {
          var r = n(9601);
          e.exports = r;
        },
        3685: function (e, t, n) {
          var r = n(8171);
          e.exports = r;
        },
        4710: function (e, t, n) {
          var r = n(498);
          e.exports = r;
        },
        3799: function (e, t, n) {
          var r = n(8494);
          e.exports = r;
        },
        9531: function (e, t, n) {
          var r = n(2956);
          n(9731), n(5708), n(14), n(8731), e.exports = r;
        },
        6600: function (e, t, n) {
          var r = n(7473);
          n(8783), n(3975), n(5799), n(5414), n(6774), n(620), n(6172), e.exports = r;
        },
        9759: function (e, t, n) {
          var r = n(4227);
          e.exports = r;
        },
        3916: function (e) {
          e.exports = function (e) {
            if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
            return e;
          };
        },
        1851: function (e, t, n) {
          var r = n(941);
          e.exports = function (e) {
            if (!r(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
            return e;
          };
        },
        8479: function (e) {
          e.exports = function () {};
        },
        5743: function (e) {
          e.exports = function (e, t, n) {
            if (!(e instanceof t)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
            return e;
          };
        },
        6059: function (e, t, n) {
          var r = n(941);
          e.exports = function (e) {
            if (!r(e)) throw TypeError(String(e) + " is not an object");
            return e;
          };
        },
        6837: function (e, t, n) {
          "use strict";

          var r = n(3610).forEach,
            o = n(4194)("forEach");
          e.exports = o ? [].forEach : function (e) {
            return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
          };
        },
        1354: function (e, t, n) {
          "use strict";

          var r = n(6843),
            o = n(9678),
            i = n(5196),
            a = n(6782),
            u = n(3057),
            s = n(5449),
            c = n(2902);
          e.exports = function (e) {
            var t,
              n,
              f,
              l,
              p,
              h,
              d = o(e),
              v = "function" == typeof this ? this : Array,
              g = arguments.length,
              y = g > 1 ? arguments[1] : void 0,
              m = void 0 !== y,
              b = c(d),
              k = 0;
            if (m && (y = r(y, g > 2 ? arguments[2] : void 0, 2)), null == b || v == Array && a(b)) for (n = new v(t = u(d.length)); t > k; k++) h = m ? y(d[k], k) : d[k], s(n, k, h);else for (p = (l = b.call(d)).next, n = new v(); !(f = p.call(l)).done; k++) h = m ? i(l, y, [f.value, k], !0) : f.value, s(n, k, h);
            return n.length = k, n;
          };
        },
        1692: function (e, t, n) {
          var r = n(4529),
            o = n(3057),
            i = n(9413),
            a = function (e) {
              return function (t, n, a) {
                var u,
                  s = r(t),
                  c = o(s.length),
                  f = i(a, c);
                if (e && n != n) {
                  for (; c > f;) if ((u = s[f++]) != u) return !0;
                } else for (; c > f; f++) if ((e || f in s) && s[f] === n) return e || f || 0;
                return !e && -1;
              };
            };
          e.exports = {
            includes: a(!0),
            indexOf: a(!1)
          };
        },
        3610: function (e, t, n) {
          var r = n(6843),
            o = n(7026),
            i = n(9678),
            a = n(3057),
            u = n(4692),
            s = [].push,
            c = function (e) {
              var t = 1 == e,
                n = 2 == e,
                c = 3 == e,
                f = 4 == e,
                l = 6 == e,
                p = 7 == e,
                h = 5 == e || l;
              return function (d, v, g, y) {
                for (var m, b, k = i(d), w = o(k), x = r(v, g, 3), S = a(w.length), T = 0, O = y || u, A = t ? O(d, S) : n || p ? O(d, 0) : void 0; S > T; T++) if ((h || T in w) && (b = x(m = w[T], T, k), e)) if (t) A[T] = b;else if (b) switch (e) {
                  case 3:
                    return !0;
                  case 5:
                    return m;
                  case 6:
                    return T;
                  case 2:
                    s.call(A, m);
                } else switch (e) {
                  case 4:
                    return !1;
                  case 7:
                    s.call(A, m);
                }
                return l ? -1 : c || f ? f : A;
              };
            };
          e.exports = {
            forEach: c(0),
            map: c(1),
            filter: c(2),
            some: c(3),
            every: c(4),
            find: c(5),
            findIndex: c(6),
            filterOut: c(7)
          };
        },
        568: function (e, t, n) {
          var r = n(5981),
            o = n(9813),
            i = n(3385),
            a = o("species");
          e.exports = function (e) {
            return i >= 51 || !r(function () {
              var t = [];
              return (t.constructor = {})[a] = function () {
                return {
                  foo: 1
                };
              }, 1 !== t[e](Boolean).foo;
            });
          };
        },
        4194: function (e, t, n) {
          "use strict";

          var r = n(5981);
          e.exports = function (e, t) {
            var n = [][e];
            return !!n && r(function () {
              n.call(null, t || function () {
                throw 1;
              }, 1);
            });
          };
        },
        4692: function (e, t, n) {
          var r = n(941),
            o = n(1052),
            i = n(9813)("species");
          e.exports = function (e, t) {
            var n;
            return o(e) && ("function" != typeof (n = e.constructor) || n !== Array && !o(n.prototype) ? r(n) && null === (n = n[i]) && (n = void 0) : n = void 0), new (void 0 === n ? Array : n)(0 === t ? 0 : t);
          };
        },
        5196: function (e, t, n) {
          var r = n(6059),
            o = n(7609);
          e.exports = function (e, t, n, i) {
            try {
              return i ? t(r(n)[0], n[1]) : t(n);
            } catch (t) {
              throw o(e), t;
            }
          };
        },
        1385: function (e, t, n) {
          var r = n(9813)("iterator"),
            o = !1;
          try {
            var i = 0,
              a = {
                next: function () {
                  return {
                    done: !!i++
                  };
                },
                return: function () {
                  o = !0;
                }
              };
            a[r] = function () {
              return this;
            }, Array.from(a, function () {
              throw 2;
            });
          } catch (e) {}
          e.exports = function (e, t) {
            if (!t && !o) return !1;
            var n = !1;
            try {
              var i = {};
              i[r] = function () {
                return {
                  next: function () {
                    return {
                      done: n = !0
                    };
                  }
                };
              }, e(i);
            } catch (e) {}
            return n;
          };
        },
        2532: function (e) {
          var t = {}.toString;
          e.exports = function (e) {
            return t.call(e).slice(8, -1);
          };
        },
        9697: function (e, t, n) {
          var r = n(2885),
            o = n(2532),
            i = n(9813)("toStringTag"),
            a = "Arguments" == o(function () {
              return arguments;
            }());
          e.exports = r ? o : function (e) {
            var t, n, r;
            return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
              try {
                return e[t];
              } catch (e) {}
            }(t = Object(e), i)) ? n : a ? o(t) : "Object" == (r = o(t)) && "function" == typeof t.callee ? "Arguments" : r;
          };
        },
        4160: function (e, t, n) {
          var r = n(5981);
          e.exports = !r(function () {
            function e() {}
            return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
          });
        },
        1046: function (e, t, n) {
          "use strict";

          var r = n(5143).IteratorPrototype,
            o = n(9290),
            i = n(1887),
            a = n(904),
            u = n(2077),
            s = function () {
              return this;
            };
          e.exports = function (e, t, n) {
            var c = t + " Iterator";
            return e.prototype = o(r, {
              next: i(1, n)
            }), a(e, c, !1, !0), u[c] = s, e;
          };
        },
        2029: function (e, t, n) {
          var r = n(5746),
            o = n(5988),
            i = n(1887);
          e.exports = r ? function (e, t, n) {
            return o.f(e, t, i(1, n));
          } : function (e, t, n) {
            return e[t] = n, e;
          };
        },
        1887: function (e) {
          e.exports = function (e, t) {
            return {
              enumerable: !(1 & e),
              configurable: !(2 & e),
              writable: !(4 & e),
              value: t
            };
          };
        },
        5449: function (e, t, n) {
          "use strict";

          var r = n(6935),
            o = n(5988),
            i = n(1887);
          e.exports = function (e, t, n) {
            var a = r(t);
            a in e ? o.f(e, a, i(0, n)) : e[a] = n;
          };
        },
        7771: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(1046),
            i = n(249),
            a = n(8929),
            u = n(904),
            s = n(2029),
            c = n(1341),
            f = n(9813),
            l = n(2529),
            p = n(2077),
            h = n(5143),
            d = h.IteratorPrototype,
            v = h.BUGGY_SAFARI_ITERATORS,
            g = f("iterator"),
            y = "keys",
            m = "values",
            b = "entries",
            k = function () {
              return this;
            };
          e.exports = function (e, t, n, f, h, w, x) {
            o(n, t, f);
            var S,
              T,
              O,
              A = function (e) {
                if (e === h && j) return j;
                if (!v && e in R) return R[e];
                switch (e) {
                  case y:
                  case m:
                  case b:
                    return function () {
                      return new n(this, e);
                    };
                }
                return function () {
                  return new n(this);
                };
              },
              E = t + " Iterator",
              _ = !1,
              R = e.prototype,
              P = R[g] || R["@@iterator"] || h && R[h],
              j = !v && P || A(h),
              I = "Array" == t && R.entries || P;
            if (I && (S = i(I.call(new e())), d !== Object.prototype && S.next && (l || i(S) === d || (a ? a(S, d) : "function" != typeof S[g] && s(S, g, k)), u(S, E, !0, !0), l && (p[E] = k))), h == m && P && P.name !== m && (_ = !0, j = function () {
              return P.call(this);
            }), l && !x || R[g] === j || s(R, g, j), p[t] = j, h) if (T = {
              values: A(m),
              keys: w ? j : A(y),
              entries: A(b)
            }, x) for (O in T) (v || _ || !(O in R)) && c(R, O, T[O]);else r({
              target: t,
              proto: !0,
              forced: v || _
            }, T);
            return T;
          };
        },
        6349: function (e, t, n) {
          var r = n(4058),
            o = n(7457),
            i = n(1477),
            a = n(5988).f;
          e.exports = function (e) {
            var t = r.Symbol || (r.Symbol = {});
            o(t, e) || a(t, e, {
              value: i.f(e)
            });
          };
        },
        5746: function (e, t, n) {
          var r = n(5981);
          e.exports = !r(function () {
            return 7 != Object.defineProperty({}, 1, {
              get: function () {
                return 7;
              }
            })[1];
          });
        },
        1333: function (e, t, n) {
          var r = n(1899),
            o = n(941),
            i = r.document,
            a = o(i) && o(i.createElement);
          e.exports = function (e) {
            return a ? i.createElement(e) : {};
          };
        },
        3281: function (e) {
          e.exports = {
            CSSRuleList: 0,
            CSSStyleDeclaration: 0,
            CSSValueList: 0,
            ClientRectList: 0,
            DOMRectList: 0,
            DOMStringList: 0,
            DOMTokenList: 1,
            DataTransferItemList: 0,
            FileList: 0,
            HTMLAllCollection: 0,
            HTMLCollection: 0,
            HTMLFormElement: 0,
            HTMLSelectElement: 0,
            MediaList: 0,
            MimeTypeArray: 0,
            NamedNodeMap: 0,
            NodeList: 1,
            PaintRequestList: 0,
            Plugin: 0,
            PluginArray: 0,
            SVGLengthList: 0,
            SVGNumberList: 0,
            SVGPathSegList: 0,
            SVGPointList: 0,
            SVGStringList: 0,
            SVGTransformList: 0,
            SourceBufferList: 0,
            StyleSheetList: 0,
            TextTrackCueList: 0,
            TextTrackList: 0,
            TouchList: 0
          };
        },
        3321: function (e) {
          e.exports = "object" == typeof window;
        },
        2749: function (e, t, n) {
          var r = n(2861);
          e.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(r);
        },
        6049: function (e, t, n) {
          var r = n(2532),
            o = n(1899);
          e.exports = "process" == r(o.process);
        },
        8045: function (e, t, n) {
          var r = n(2861);
          e.exports = /web0s(?!.*chrome)/i.test(r);
        },
        2861: function (e, t, n) {
          var r = n(626);
          e.exports = r("navigator", "userAgent") || "";
        },
        3385: function (e, t, n) {
          var r,
            o,
            i = n(1899),
            a = n(2861),
            u = i.process,
            s = u && u.versions,
            c = s && s.v8;
          c ? o = (r = c.split("."))[0] < 4 ? 1 : r[0] + r[1] : a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = r[1]), e.exports = o && +o;
        },
        5703: function (e, t, n) {
          var r = n(4058);
          e.exports = function (e) {
            return r[e + "Prototype"];
          };
        },
        6759: function (e) {
          e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        },
        6887: function (e, t, n) {
          "use strict";

          var r = n(1899),
            o = n(9677).f,
            i = n(7252),
            a = n(4058),
            u = n(6843),
            s = n(2029),
            c = n(7457),
            f = function (e) {
              var t = function (t, n, r) {
                if (this instanceof e) {
                  switch (arguments.length) {
                    case 0:
                      return new e();
                    case 1:
                      return new e(t);
                    case 2:
                      return new e(t, n);
                  }
                  return new e(t, n, r);
                }
                return e.apply(this, arguments);
              };
              return t.prototype = e.prototype, t;
            };
          e.exports = function (e, t) {
            var n,
              l,
              p,
              h,
              d,
              v,
              g,
              y,
              m = e.target,
              b = e.global,
              k = e.stat,
              w = e.proto,
              x = b ? r : k ? r[m] : (r[m] || {}).prototype,
              S = b ? a : a[m] || (a[m] = {}),
              T = S.prototype;
            for (p in t) n = !i(b ? p : m + (k ? "." : "#") + p, e.forced) && x && c(x, p), d = S[p], n && (v = e.noTargetGet ? (y = o(x, p)) && y.value : x[p]), h = n && v ? v : t[p], n && typeof d == typeof h || (g = e.bind && n ? u(h, r) : e.wrap && n ? f(h) : w && "function" == typeof h ? u(Function.call, h) : h, (e.sham || h && h.sham || d && d.sham) && s(g, "sham", !0), S[p] = g, w && (c(a, l = m + "Prototype") || s(a, l, {}), a[l][p] = h, e.real && T && !T[p] && s(T, p, h)));
          };
        },
        5981: function (e) {
          e.exports = function (e) {
            try {
              return !!e();
            } catch (e) {
              return !0;
            }
          };
        },
        6843: function (e, t, n) {
          var r = n(3916);
          e.exports = function (e, t, n) {
            if (r(e), void 0 === t) return e;
            switch (n) {
              case 0:
                return function () {
                  return e.call(t);
                };
              case 1:
                return function (n) {
                  return e.call(t, n);
                };
              case 2:
                return function (n, r) {
                  return e.call(t, n, r);
                };
              case 3:
                return function (n, r, o) {
                  return e.call(t, n, r, o);
                };
            }
            return function () {
              return e.apply(t, arguments);
            };
          };
        },
        626: function (e, t, n) {
          var r = n(4058),
            o = n(1899),
            i = function (e) {
              return "function" == typeof e ? e : void 0;
            };
          e.exports = function (e, t) {
            return arguments.length < 2 ? i(r[e]) || i(o[e]) : r[e] && r[e][t] || o[e] && o[e][t];
          };
        },
        2902: function (e, t, n) {
          var r = n(9697),
            o = n(2077),
            i = n(9813)("iterator");
          e.exports = function (e) {
            if (null != e) return e[i] || e["@@iterator"] || o[r(e)];
          };
        },
        429: function (e, t, n) {
          var r = n(6059),
            o = n(2902);
          e.exports = function (e) {
            var t = o(e);
            if ("function" != typeof t) throw TypeError(String(e) + " is not iterable");
            return r(t.call(e));
          };
        },
        1899: function (e, t, n) {
          var r = function (e) {
            return e && e.Math == Math && e;
          };
          e.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof n.g && n.g) || function () {
            return this;
          }() || Function("return this")();
        },
        7457: function (e, t, n) {
          var r = n(9678),
            o = {}.hasOwnProperty;
          e.exports = Object.hasOwn || function (e, t) {
            return o.call(r(e), t);
          };
        },
        7748: function (e) {
          e.exports = {};
        },
        4845: function (e, t, n) {
          var r = n(1899);
          e.exports = function (e, t) {
            var n = r.console;
            n && n.error && (1 === arguments.length ? n.error(e) : n.error(e, t));
          };
        },
        5463: function (e, t, n) {
          var r = n(626);
          e.exports = r("document", "documentElement");
        },
        2840: function (e, t, n) {
          var r = n(5746),
            o = n(5981),
            i = n(1333);
          e.exports = !r && !o(function () {
            return 7 != Object.defineProperty(i("div"), "a", {
              get: function () {
                return 7;
              }
            }).a;
          });
        },
        7026: function (e, t, n) {
          var r = n(5981),
            o = n(2532),
            i = "".split;
          e.exports = r(function () {
            return !Object("z").propertyIsEnumerable(0);
          }) ? function (e) {
            return "String" == o(e) ? i.call(e, "") : Object(e);
          } : Object;
        },
        1302: function (e, t, n) {
          var r = n(3030),
            o = Function.toString;
          "function" != typeof r.inspectSource && (r.inspectSource = function (e) {
            return o.call(e);
          }), e.exports = r.inspectSource;
        },
        5402: function (e, t, n) {
          var r,
            o,
            i,
            a = n(8019),
            u = n(1899),
            s = n(941),
            c = n(2029),
            f = n(7457),
            l = n(3030),
            p = n(4262),
            h = n(7748),
            d = "Object already initialized",
            v = u.WeakMap;
          if (a || l.state) {
            var g = l.state || (l.state = new v()),
              y = g.get,
              m = g.has,
              b = g.set;
            r = function (e, t) {
              if (m.call(g, e)) throw new TypeError(d);
              return t.facade = e, b.call(g, e, t), t;
            }, o = function (e) {
              return y.call(g, e) || {};
            }, i = function (e) {
              return m.call(g, e);
            };
          } else {
            var k = p("state");
            h[k] = !0, r = function (e, t) {
              if (f(e, k)) throw new TypeError(d);
              return t.facade = e, c(e, k, t), t;
            }, o = function (e) {
              return f(e, k) ? e[k] : {};
            }, i = function (e) {
              return f(e, k);
            };
          }
          e.exports = {
            set: r,
            get: o,
            has: i,
            enforce: function (e) {
              return i(e) ? o(e) : r(e, {});
            },
            getterFor: function (e) {
              return function (t) {
                var n;
                if (!s(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
                return n;
              };
            }
          };
        },
        6782: function (e, t, n) {
          var r = n(9813),
            o = n(2077),
            i = r("iterator"),
            a = Array.prototype;
          e.exports = function (e) {
            return void 0 !== e && (o.Array === e || a[i] === e);
          };
        },
        1052: function (e, t, n) {
          var r = n(2532);
          e.exports = Array.isArray || function (e) {
            return "Array" == r(e);
          };
        },
        7252: function (e, t, n) {
          var r = n(5981),
            o = /#|\.prototype\./,
            i = function (e, t) {
              var n = u[a(e)];
              return n == c || n != s && ("function" == typeof t ? r(t) : !!t);
            },
            a = i.normalize = function (e) {
              return String(e).replace(o, ".").toLowerCase();
            },
            u = i.data = {},
            s = i.NATIVE = "N",
            c = i.POLYFILL = "P";
          e.exports = i;
        },
        941: function (e) {
          e.exports = function (e) {
            return "object" == typeof e ? null !== e : "function" == typeof e;
          };
        },
        2529: function (e) {
          e.exports = !0;
        },
        3091: function (e, t, n) {
          var r = n(6059),
            o = n(6782),
            i = n(3057),
            a = n(6843),
            u = n(2902),
            s = n(7609),
            c = function (e, t) {
              this.stopped = e, this.result = t;
            };
          e.exports = function (e, t, n) {
            var f,
              l,
              p,
              h,
              d,
              v,
              g,
              y = n && n.that,
              m = !(!n || !n.AS_ENTRIES),
              b = !(!n || !n.IS_ITERATOR),
              k = !(!n || !n.INTERRUPTED),
              w = a(t, y, 1 + m + k),
              x = function (e) {
                return f && s(f), new c(!0, e);
              },
              S = function (e) {
                return m ? (r(e), k ? w(e[0], e[1], x) : w(e[0], e[1])) : k ? w(e, x) : w(e);
              };
            if (b) f = e;else {
              if ("function" != typeof (l = u(e))) throw TypeError("Target is not iterable");
              if (o(l)) {
                for (p = 0, h = i(e.length); h > p; p++) if ((d = S(e[p])) && d instanceof c) return d;
                return new c(!1);
              }
              f = l.call(e);
            }
            for (v = f.next; !(g = v.call(f)).done;) {
              try {
                d = S(g.value);
              } catch (e) {
                throw s(f), e;
              }
              if ("object" == typeof d && d && d instanceof c) return d;
            }
            return new c(!1);
          };
        },
        7609: function (e, t, n) {
          var r = n(6059);
          e.exports = function (e) {
            var t = e.return;
            if (void 0 !== t) return r(t.call(e)).value;
          };
        },
        5143: function (e, t, n) {
          "use strict";

          var r,
            o,
            i,
            a = n(5981),
            u = n(249),
            s = n(2029),
            c = n(7457),
            f = n(9813),
            l = n(2529),
            p = f("iterator"),
            h = !1;
          [].keys && ("next" in (i = [].keys()) ? (o = u(u(i))) !== Object.prototype && (r = o) : h = !0);
          var d = null == r || a(function () {
            var e = {};
            return r[p].call(e) !== e;
          });
          d && (r = {}), l && !d || c(r, p) || s(r, p, function () {
            return this;
          }), e.exports = {
            IteratorPrototype: r,
            BUGGY_SAFARI_ITERATORS: h
          };
        },
        2077: function (e) {
          e.exports = {};
        },
        6132: function (e, t, n) {
          var r,
            o,
            i,
            a,
            u,
            s,
            c,
            f,
            l = n(1899),
            p = n(9677).f,
            h = n(2941).set,
            d = n(2749),
            v = n(8045),
            g = n(6049),
            y = l.MutationObserver || l.WebKitMutationObserver,
            m = l.document,
            b = l.process,
            k = l.Promise,
            w = p(l, "queueMicrotask"),
            x = w && w.value;
          x || (r = function () {
            var e, t;
            for (g && (e = b.domain) && e.exit(); o;) {
              t = o.fn, o = o.next;
              try {
                t();
              } catch (e) {
                throw o ? a() : i = void 0, e;
              }
            }
            i = void 0, e && e.enter();
          }, d || g || v || !y || !m ? k && k.resolve ? ((c = k.resolve(void 0)).constructor = k, f = c.then, a = function () {
            f.call(c, r);
          }) : a = g ? function () {
            b.nextTick(r);
          } : function () {
            h.call(l, r);
          } : (u = !0, s = m.createTextNode(""), new y(r).observe(s, {
            characterData: !0
          }), a = function () {
            s.data = u = !u;
          })), e.exports = x || function (e) {
            var t = {
              fn: e,
              next: void 0
            };
            i && (i.next = t), o || (o = t, a()), i = t;
          };
        },
        9297: function (e, t, n) {
          var r = n(1899);
          e.exports = r.Promise;
        },
        2497: function (e, t, n) {
          var r = n(3385),
            o = n(5981);
          e.exports = !!Object.getOwnPropertySymbols && !o(function () {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && r && r < 41;
          });
        },
        8468: function (e, t, n) {
          var r = n(5981),
            o = n(9813),
            i = n(2529),
            a = o("iterator");
          e.exports = !r(function () {
            var e = new URL("b?a=1&b=2&c=3", "http://a"),
              t = e.searchParams,
              n = "";
            return e.pathname = "c%20d", t.forEach(function (e, r) {
              t.delete("b"), n += r + e;
            }), i && !e.toJSON || !t.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[a] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== n || "x" !== new URL("http://x", void 0).host;
          });
        },
        8019: function (e, t, n) {
          var r = n(1899),
            o = n(1302),
            i = r.WeakMap;
          e.exports = "function" == typeof i && /native code/.test(o(i));
        },
        9520: function (e, t, n) {
          "use strict";

          var r = n(3916),
            o = function (e) {
              var t, n;
              this.promise = new e(function (e, r) {
                if (void 0 !== t || void 0 !== n) throw TypeError("Bad Promise constructor");
                t = e, n = r;
              }), this.resolve = r(t), this.reject = r(n);
            };
          e.exports.f = function (e) {
            return new o(e);
          };
        },
        4420: function (e, t, n) {
          "use strict";

          var r = n(5746),
            o = n(5981),
            i = n(4771),
            a = n(7857),
            u = n(8838),
            s = n(9678),
            c = n(7026),
            f = Object.assign,
            l = Object.defineProperty;
          e.exports = !f || o(function () {
            if (r && 1 !== f({
              b: 1
            }, f(l({}, "a", {
              enumerable: !0,
              get: function () {
                l(this, "b", {
                  value: 3,
                  enumerable: !1
                });
              }
            }), {
              b: 2
            })).b) return !0;
            var e = {},
              t = {},
              n = Symbol(),
              o = "abcdefghijklmnopqrst";
            return e[n] = 7, o.split("").forEach(function (e) {
              t[e] = e;
            }), 7 != f({}, e)[n] || i(f({}, t)).join("") != o;
          }) ? function (e, t) {
            for (var n = s(e), o = arguments.length, f = 1, l = a.f, p = u.f; o > f;) for (var h, d = c(arguments[f++]), v = l ? i(d).concat(l(d)) : i(d), g = v.length, y = 0; g > y;) h = v[y++], r && !p.call(d, h) || (n[h] = d[h]);
            return n;
          } : f;
        },
        9290: function (e, t, n) {
          var r,
            o = n(6059),
            i = n(9938),
            a = n(6759),
            u = n(7748),
            s = n(5463),
            c = n(1333),
            f = n(4262)("IE_PROTO"),
            l = function () {},
            p = function (e) {
              return "<script>" + e + "<\/script>";
            },
            h = function () {
              try {
                r = document.domain && new ActiveXObject("htmlfile");
              } catch (e) {}
              var e, t;
              h = r ? function (e) {
                e.write(p("")), e.close();
                var t = e.parentWindow.Object;
                return e = null, t;
              }(r) : ((t = c("iframe")).style.display = "none", s.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(p("document.F=Object")), e.close(), e.F);
              for (var n = a.length; n--;) delete h.prototype[a[n]];
              return h();
            };
          u[f] = !0, e.exports = Object.create || function (e, t) {
            var n;
            return null !== e ? (l.prototype = o(e), n = new l(), l.prototype = null, n[f] = e) : n = h(), void 0 === t ? n : i(n, t);
          };
        },
        9938: function (e, t, n) {
          var r = n(5746),
            o = n(5988),
            i = n(6059),
            a = n(4771);
          e.exports = r ? Object.defineProperties : function (e, t) {
            i(e);
            for (var n, r = a(t), u = r.length, s = 0; u > s;) o.f(e, n = r[s++], t[n]);
            return e;
          };
        },
        5988: function (e, t, n) {
          var r = n(5746),
            o = n(2840),
            i = n(6059),
            a = n(6935),
            u = Object.defineProperty;
          t.f = r ? u : function (e, t, n) {
            if (i(e), t = a(t, !0), i(n), o) try {
              return u(e, t, n);
            } catch (e) {}
            if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
            return "value" in n && (e[t] = n.value), e;
          };
        },
        9677: function (e, t, n) {
          var r = n(5746),
            o = n(8838),
            i = n(1887),
            a = n(4529),
            u = n(6935),
            s = n(7457),
            c = n(2840),
            f = Object.getOwnPropertyDescriptor;
          t.f = r ? f : function (e, t) {
            if (e = a(e), t = u(t, !0), c) try {
              return f(e, t);
            } catch (e) {}
            if (s(e, t)) return i(!o.f.call(e, t), e[t]);
          };
        },
        684: function (e, t, n) {
          var r = n(4529),
            o = n(946).f,
            i = {}.toString,
            a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
          e.exports.f = function (e) {
            return a && "[object Window]" == i.call(e) ? function (e) {
              try {
                return o(e);
              } catch (e) {
                return a.slice();
              }
            }(e) : o(r(e));
          };
        },
        946: function (e, t, n) {
          var r = n(5629),
            o = n(6759).concat("length", "prototype");
          t.f = Object.getOwnPropertyNames || function (e) {
            return r(e, o);
          };
        },
        7857: function (e, t) {
          t.f = Object.getOwnPropertySymbols;
        },
        249: function (e, t, n) {
          var r = n(7457),
            o = n(9678),
            i = n(4262),
            a = n(4160),
            u = i("IE_PROTO"),
            s = Object.prototype;
          e.exports = a ? Object.getPrototypeOf : function (e) {
            return e = o(e), r(e, u) ? e[u] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? s : null;
          };
        },
        5629: function (e, t, n) {
          var r = n(7457),
            o = n(4529),
            i = n(1692).indexOf,
            a = n(7748);
          e.exports = function (e, t) {
            var n,
              u = o(e),
              s = 0,
              c = [];
            for (n in u) !r(a, n) && r(u, n) && c.push(n);
            for (; t.length > s;) r(u, n = t[s++]) && (~i(c, n) || c.push(n));
            return c;
          };
        },
        4771: function (e, t, n) {
          var r = n(5629),
            o = n(6759);
          e.exports = Object.keys || function (e) {
            return r(e, o);
          };
        },
        8838: function (e, t) {
          "use strict";

          var n = {}.propertyIsEnumerable,
            r = Object.getOwnPropertyDescriptor,
            o = r && !n.call({
              1: 2
            }, 1);
          t.f = o ? function (e) {
            var t = r(this, e);
            return !!t && t.enumerable;
          } : n;
        },
        8929: function (e, t, n) {
          var r = n(6059),
            o = n(1851);
          e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
            var e,
              t = !1,
              n = {};
            try {
              (e = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(n, []), t = n instanceof Array;
            } catch (e) {}
            return function (n, i) {
              return r(n), o(i), t ? e.call(n, i) : n.__proto__ = i, n;
            };
          }() : void 0);
        },
        8810: function (e, t, n) {
          var r = n(5746),
            o = n(4771),
            i = n(4529),
            a = n(8838).f,
            u = function (e) {
              return function (t) {
                for (var n, u = i(t), s = o(u), c = s.length, f = 0, l = []; c > f;) n = s[f++], r && !a.call(u, n) || l.push(e ? [n, u[n]] : u[n]);
                return l;
              };
            };
          e.exports = {
            entries: u(!0),
            values: u(!1)
          };
        },
        5623: function (e, t, n) {
          "use strict";

          var r = n(2885),
            o = n(9697);
          e.exports = r ? {}.toString : function () {
            return "[object " + o(this) + "]";
          };
        },
        1136: function (e, t, n) {
          var r = n(626),
            o = n(946),
            i = n(7857),
            a = n(6059);
          e.exports = r("Reflect", "ownKeys") || function (e) {
            var t = o.f(a(e)),
              n = i.f;
            return n ? t.concat(n(e)) : t;
          };
        },
        4058: function (e) {
          e.exports = {};
        },
        2: function (e) {
          e.exports = function (e) {
            try {
              return {
                error: !1,
                value: e()
              };
            } catch (e) {
              return {
                error: !0,
                value: e
              };
            }
          };
        },
        6584: function (e, t, n) {
          var r = n(6059),
            o = n(941),
            i = n(9520);
          e.exports = function (e, t) {
            if (r(e), o(t) && t.constructor === e) return t;
            var n = i.f(e);
            return (0, n.resolve)(t), n.promise;
          };
        },
        7524: function (e, t, n) {
          var r = n(1341);
          e.exports = function (e, t, n) {
            for (var o in t) n && n.unsafe && e[o] ? e[o] = t[o] : r(e, o, t[o], n);
            return e;
          };
        },
        1341: function (e, t, n) {
          var r = n(2029);
          e.exports = function (e, t, n, o) {
            o && o.enumerable ? e[t] = n : r(e, t, n);
          };
        },
        8219: function (e) {
          e.exports = function (e) {
            if (null == e) throw TypeError("Can't call method on " + e);
            return e;
          };
        },
        4911: function (e, t, n) {
          var r = n(1899),
            o = n(2029);
          e.exports = function (e, t) {
            try {
              o(r, e, t);
            } catch (n) {
              r[e] = t;
            }
            return t;
          };
        },
        4431: function (e, t, n) {
          "use strict";

          var r = n(626),
            o = n(5988),
            i = n(9813),
            a = n(5746),
            u = i("species");
          e.exports = function (e) {
            var t = r(e),
              n = o.f;
            a && t && !t[u] && n(t, u, {
              configurable: !0,
              get: function () {
                return this;
              }
            });
          };
        },
        904: function (e, t, n) {
          var r = n(2885),
            o = n(5988).f,
            i = n(2029),
            a = n(7457),
            u = n(5623),
            s = n(9813)("toStringTag");
          e.exports = function (e, t, n, c) {
            if (e) {
              var f = n ? e : e.prototype;
              a(f, s) || o(f, s, {
                configurable: !0,
                value: t
              }), c && !r && i(f, "toString", u);
            }
          };
        },
        4262: function (e, t, n) {
          var r = n(8726),
            o = n(9418),
            i = r("keys");
          e.exports = function (e) {
            return i[e] || (i[e] = o(e));
          };
        },
        3030: function (e, t, n) {
          var r = n(1899),
            o = n(4911),
            i = "__core-js_shared__",
            a = r[i] || o(i, {});
          e.exports = a;
        },
        8726: function (e, t, n) {
          var r = n(2529),
            o = n(3030);
          (e.exports = function (e, t) {
            return o[e] || (o[e] = void 0 !== t ? t : {});
          })("versions", []).push({
            version: "3.15.1",
            mode: r ? "pure" : "global",
            copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
          });
        },
        487: function (e, t, n) {
          var r = n(6059),
            o = n(3916),
            i = n(9813)("species");
          e.exports = function (e, t) {
            var n,
              a = r(e).constructor;
            return void 0 === a || null == (n = r(a)[i]) ? t : o(n);
          };
        },
        4620: function (e, t, n) {
          var r = n(8459),
            o = n(8219),
            i = function (e) {
              return function (t, n) {
                var i,
                  a,
                  u = String(o(t)),
                  s = r(n),
                  c = u.length;
                return s < 0 || s >= c ? e ? "" : void 0 : (i = u.charCodeAt(s)) < 55296 || i > 56319 || s + 1 === c || (a = u.charCodeAt(s + 1)) < 56320 || a > 57343 ? e ? u.charAt(s) : i : e ? u.slice(s, s + 2) : a - 56320 + (i - 55296 << 10) + 65536;
              };
            };
          e.exports = {
            codeAt: i(!1),
            charAt: i(!0)
          };
        },
        3291: function (e) {
          "use strict";

          var t = 2147483647,
            n = /[^\0-\u007E]/,
            r = /[.\u3002\uFF0E\uFF61]/g,
            o = "Overflow: input needs wider integers to process",
            i = Math.floor,
            a = String.fromCharCode,
            u = function (e) {
              return e + 22 + 75 * (e < 26);
            },
            s = function (e, t, n) {
              var r = 0;
              for (e = n ? i(e / 700) : e >> 1, e += i(e / t); e > 455; r += 36) e = i(e / 35);
              return i(r + 36 * e / (e + 38));
            },
            c = function (e) {
              var n = [];
              e = function (e) {
                for (var t = [], n = 0, r = e.length; n < r;) {
                  var o = e.charCodeAt(n++);
                  if (o >= 55296 && o <= 56319 && n < r) {
                    var i = e.charCodeAt(n++);
                    56320 == (64512 & i) ? t.push(((1023 & o) << 10) + (1023 & i) + 65536) : (t.push(o), n--);
                  } else t.push(o);
                }
                return t;
              }(e);
              var r,
                c,
                f = e.length,
                l = 128,
                p = 0,
                h = 72;
              for (r = 0; r < e.length; r++) (c = e[r]) < 128 && n.push(a(c));
              var d = n.length,
                v = d;
              for (d && n.push("-"); v < f;) {
                var g = t;
                for (r = 0; r < e.length; r++) (c = e[r]) >= l && c < g && (g = c);
                var y = v + 1;
                if (g - l > i((t - p) / y)) throw RangeError(o);
                for (p += (g - l) * y, l = g, r = 0; r < e.length; r++) {
                  if ((c = e[r]) < l && ++p > t) throw RangeError(o);
                  if (c == l) {
                    for (var m = p, b = 36;; b += 36) {
                      var k = b <= h ? 1 : b >= h + 26 ? 26 : b - h;
                      if (m < k) break;
                      var w = m - k,
                        x = 36 - k;
                      n.push(a(u(k + w % x))), m = i(w / x);
                    }
                    n.push(a(u(m))), h = s(p, y, v == d), p = 0, ++v;
                  }
                }
                ++p, ++l;
              }
              return n.join("");
            };
          e.exports = function (e) {
            var t,
              o,
              i = [],
              a = e.toLowerCase().replace(r, ".").split(".");
            for (t = 0; t < a.length; t++) o = a[t], i.push(n.test(o) ? "xn--" + c(o) : o);
            return i.join(".");
          };
        },
        2941: function (e, t, n) {
          var r,
            o,
            i,
            a = n(1899),
            u = n(5981),
            s = n(6843),
            c = n(5463),
            f = n(1333),
            l = n(2749),
            p = n(6049),
            h = a.location,
            d = a.setImmediate,
            v = a.clearImmediate,
            g = a.process,
            y = a.MessageChannel,
            m = a.Dispatch,
            b = 0,
            k = {},
            w = function (e) {
              if (k.hasOwnProperty(e)) {
                var t = k[e];
                delete k[e], t();
              }
            },
            x = function (e) {
              return function () {
                w(e);
              };
            },
            S = function (e) {
              w(e.data);
            },
            T = function (e) {
              a.postMessage(e + "", h.protocol + "//" + h.host);
            };
          d && v || (d = function (e) {
            for (var t = [], n = 1; arguments.length > n;) t.push(arguments[n++]);
            return k[++b] = function () {
              ("function" == typeof e ? e : Function(e)).apply(void 0, t);
            }, r(b), b;
          }, v = function (e) {
            delete k[e];
          }, p ? r = function (e) {
            g.nextTick(x(e));
          } : m && m.now ? r = function (e) {
            m.now(x(e));
          } : y && !l ? (i = (o = new y()).port2, o.port1.onmessage = S, r = s(i.postMessage, i, 1)) : a.addEventListener && "function" == typeof postMessage && !a.importScripts && h && "file:" !== h.protocol && !u(T) ? (r = T, a.addEventListener("message", S, !1)) : r = "onreadystatechange" in f("script") ? function (e) {
            c.appendChild(f("script")).onreadystatechange = function () {
              c.removeChild(this), w(e);
            };
          } : function (e) {
            setTimeout(x(e), 0);
          }), e.exports = {
            set: d,
            clear: v
          };
        },
        9413: function (e, t, n) {
          var r = n(8459),
            o = Math.max,
            i = Math.min;
          e.exports = function (e, t) {
            var n = r(e);
            return n < 0 ? o(n + t, 0) : i(n, t);
          };
        },
        4529: function (e, t, n) {
          var r = n(7026),
            o = n(8219);
          e.exports = function (e) {
            return r(o(e));
          };
        },
        8459: function (e) {
          var t = Math.ceil,
            n = Math.floor;
          e.exports = function (e) {
            return isNaN(e = +e) ? 0 : (e > 0 ? n : t)(e);
          };
        },
        3057: function (e, t, n) {
          var r = n(8459),
            o = Math.min;
          e.exports = function (e) {
            return e > 0 ? o(r(e), 9007199254740991) : 0;
          };
        },
        9678: function (e, t, n) {
          var r = n(8219);
          e.exports = function (e) {
            return Object(r(e));
          };
        },
        6935: function (e, t, n) {
          var r = n(941);
          e.exports = function (e, t) {
            if (!r(e)) return e;
            var n, o;
            if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
            if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
            if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
            throw TypeError("Can't convert object to primitive value");
          };
        },
        2885: function (e, t, n) {
          var r = {};
          r[n(9813)("toStringTag")] = "z", e.exports = "[object z]" === String(r);
        },
        9418: function (e) {
          var t = 0,
            n = Math.random();
          e.exports = function (e) {
            return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++t + n).toString(36);
          };
        },
        2302: function (e, t, n) {
          var r = n(2497);
          e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
        },
        1477: function (e, t, n) {
          var r = n(9813);
          t.f = r;
        },
        9813: function (e, t, n) {
          var r = n(1899),
            o = n(8726),
            i = n(7457),
            a = n(9418),
            u = n(2497),
            s = n(2302),
            c = o("wks"),
            f = r.Symbol,
            l = s ? f : f && f.withoutSetter || a;
          e.exports = function (e) {
            return i(c, e) && (u || "string" == typeof c[e]) || (u && i(f, e) ? c[e] = f[e] : c[e] = l("Symbol." + e)), c[e];
          };
        },
        7627: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(249),
            i = n(8929),
            a = n(9290),
            u = n(2029),
            s = n(1887),
            c = n(3091),
            f = function (e, t) {
              var n = this;
              if (!(n instanceof f)) return new f(e, t);
              i && (n = i(new Error(void 0), o(n))), void 0 !== t && u(n, "message", String(t));
              var r = [];
              return c(e, r.push, {
                that: r
              }), u(n, "errors", r), n;
            };
          f.prototype = a(Error.prototype, {
            constructor: s(5, f),
            message: s(5, ""),
            name: s(5, "AggregateError")
          }), r({
            global: !0
          }, {
            AggregateError: f
          });
        },
        5906: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(5981),
            i = n(1052),
            a = n(941),
            u = n(9678),
            s = n(3057),
            c = n(5449),
            f = n(4692),
            l = n(568),
            p = n(9813),
            h = n(3385),
            d = p("isConcatSpreadable"),
            v = 9007199254740991,
            g = "Maximum allowed index exceeded",
            y = h >= 51 || !o(function () {
              var e = [];
              return e[d] = !1, e.concat()[0] !== e;
            }),
            m = l("concat"),
            b = function (e) {
              if (!a(e)) return !1;
              var t = e[d];
              return void 0 !== t ? !!t : i(e);
            };
          r({
            target: "Array",
            proto: !0,
            forced: !y || !m
          }, {
            concat: function (e) {
              var t,
                n,
                r,
                o,
                i,
                a = u(this),
                l = f(a, 0),
                p = 0;
              for (t = -1, r = arguments.length; t < r; t++) if (b(i = -1 === t ? a : arguments[t])) {
                if (p + (o = s(i.length)) > v) throw TypeError(g);
                for (n = 0; n < o; n++, p++) n in i && c(l, p, i[n]);
              } else {
                if (p >= v) throw TypeError(g);
                c(l, p++, i);
              }
              return l.length = p, l;
            }
          });
        },
        1501: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(3610).filter;
          r({
            target: "Array",
            proto: !0,
            forced: !n(568)("filter")
          }, {
            filter: function (e) {
              return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
            }
          });
        },
        833: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(3610).find,
            i = n(8479),
            a = "find",
            u = !0;
          a in [] && Array(1).find(function () {
            u = !1;
          }), r({
            target: "Array",
            proto: !0,
            forced: u
          }, {
            find: function (e) {
              return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
            }
          }), i(a);
        },
        2437: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(6837);
          r({
            target: "Array",
            proto: !0,
            forced: [].forEach != o
          }, {
            forEach: o
          });
        },
        3242: function (e, t, n) {
          var r = n(6887),
            o = n(1354);
          r({
            target: "Array",
            stat: !0,
            forced: !n(1385)(function (e) {
              Array.from(e);
            })
          }, {
            from: o
          });
        },
        9076: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(1692).indexOf,
            i = n(4194),
            a = [].indexOf,
            u = !!a && 1 / [1].indexOf(1, -0) < 0,
            s = i("indexOf");
          r({
            target: "Array",
            proto: !0,
            forced: u || !s
          }, {
            indexOf: function (e) {
              return u ? a.apply(this, arguments) || 0 : o(this, e, arguments.length > 1 ? arguments[1] : void 0);
            }
          });
        },
        2737: function (e, t, n) {
          n(6887)({
            target: "Array",
            stat: !0
          }, {
            isArray: n(1052)
          });
        },
        6274: function (e, t, n) {
          "use strict";

          var r = n(4529),
            o = n(8479),
            i = n(2077),
            a = n(5402),
            u = n(7771),
            s = "Array Iterator",
            c = a.set,
            f = a.getterFor(s);
          e.exports = u(Array, "Array", function (e, t) {
            c(this, {
              type: s,
              target: r(e),
              index: 0,
              kind: t
            });
          }, function () {
            var e = f(this),
              t = e.target,
              n = e.kind,
              r = e.index++;
            return !t || r >= t.length ? (e.target = void 0, {
              value: void 0,
              done: !0
            }) : "keys" == n ? {
              value: r,
              done: !1
            } : "values" == n ? {
              value: t[r],
              done: !1
            } : {
              value: [r, t[r]],
              done: !1
            };
          }, "values"), i.Arguments = i.Array, o("keys"), o("values"), o("entries");
        },
        8787: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(3610).map;
          r({
            target: "Array",
            proto: !0,
            forced: !n(568)("map")
          }, {
            map: function (e) {
              return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
            }
          });
        },
        186: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(941),
            i = n(1052),
            a = n(9413),
            u = n(3057),
            s = n(4529),
            c = n(5449),
            f = n(9813),
            l = n(568)("slice"),
            p = f("species"),
            h = [].slice,
            d = Math.max;
          r({
            target: "Array",
            proto: !0,
            forced: !l
          }, {
            slice: function (e, t) {
              var n,
                r,
                f,
                l = s(this),
                v = u(l.length),
                g = a(e, v),
                y = a(void 0 === t ? v : t, v);
              if (i(l) && ("function" != typeof (n = l.constructor) || n !== Array && !i(n.prototype) ? o(n) && null === (n = n[p]) && (n = void 0) : n = void 0, n === Array || void 0 === n)) return h.call(l, g, y);
              for (r = new (void 0 === n ? Array : n)(d(y - g, 0)), f = 0; g < y; g++, f++) g in l && c(r, f, l[g]);
              return r.length = f, r;
            }
          });
        },
        2619: function (e, t, n) {
          var r = n(6887),
            o = n(626),
            i = n(5981),
            a = o("JSON", "stringify"),
            u = /[\uD800-\uDFFF]/g,
            s = /^[\uD800-\uDBFF]$/,
            c = /^[\uDC00-\uDFFF]$/,
            f = function (e, t, n) {
              var r = n.charAt(t - 1),
                o = n.charAt(t + 1);
              return s.test(e) && !c.test(o) || c.test(e) && !s.test(r) ? "\\u" + e.charCodeAt(0).toString(16) : e;
            },
            l = i(function () {
              return '"\\udf06\\ud834"' !== a("\udf06\ud834") || '"\\udead"' !== a("\udead");
            });
          a && r({
            target: "JSON",
            stat: !0,
            forced: l
          }, {
            stringify: function (e, t, n) {
              var r = a.apply(null, arguments);
              return "string" == typeof r ? r.replace(u, f) : r;
            }
          });
        },
        9120: function (e, t, n) {
          var r = n(1899);
          n(904)(r.JSON, "JSON", !0);
        },
        5327: function () {},
        4979: function (e, t, n) {
          var r = n(6887),
            o = n(5746);
          r({
            target: "Object",
            stat: !0,
            forced: !o,
            sham: !o
          }, {
            defineProperties: n(9938)
          });
        },
        6450: function (e, t, n) {
          var r = n(6887),
            o = n(5746);
          r({
            target: "Object",
            stat: !0,
            forced: !o,
            sham: !o
          }, {
            defineProperty: n(5988).f
          });
        },
        1078: function (e, t, n) {
          var r = n(6887),
            o = n(8810).entries;
          r({
            target: "Object",
            stat: !0
          }, {
            entries: function (e) {
              return o(e);
            }
          });
        },
        8387: function (e, t, n) {
          var r = n(6887),
            o = n(3091),
            i = n(5449);
          r({
            target: "Object",
            stat: !0
          }, {
            fromEntries: function (e) {
              var t = {};
              return o(e, function (e, n) {
                i(t, e, n);
              }, {
                AS_ENTRIES: !0
              }), t;
            }
          });
        },
        6924: function (e, t, n) {
          var r = n(6887),
            o = n(5981),
            i = n(4529),
            a = n(9677).f,
            u = n(5746),
            s = o(function () {
              a(1);
            });
          r({
            target: "Object",
            stat: !0,
            forced: !u || s,
            sham: !u
          }, {
            getOwnPropertyDescriptor: function (e, t) {
              return a(i(e), t);
            }
          });
        },
        8482: function (e, t, n) {
          var r = n(6887),
            o = n(5746),
            i = n(1136),
            a = n(4529),
            u = n(9677),
            s = n(5449);
          r({
            target: "Object",
            stat: !0,
            sham: !o
          }, {
            getOwnPropertyDescriptors: function (e) {
              for (var t, n, r = a(e), o = u.f, c = i(r), f = {}, l = 0; c.length > l;) void 0 !== (n = o(r, t = c[l++])) && s(f, t, n);
              return f;
            }
          });
        },
        1724: function (e, t, n) {
          var r = n(6887),
            o = n(9678),
            i = n(4771);
          r({
            target: "Object",
            stat: !0,
            forced: n(5981)(function () {
              i(1);
            })
          }, {
            keys: function (e) {
              return i(o(e));
            }
          });
        },
        5967: function () {},
        4560: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(3916),
            i = n(9520),
            a = n(2),
            u = n(3091);
          r({
            target: "Promise",
            stat: !0
          }, {
            allSettled: function (e) {
              var t = this,
                n = i.f(t),
                r = n.resolve,
                s = n.reject,
                c = a(function () {
                  var n = o(t.resolve),
                    i = [],
                    a = 0,
                    s = 1;
                  u(e, function (e) {
                    var o = a++,
                      u = !1;
                    i.push(void 0), s++, n.call(t, e).then(function (e) {
                      u || (u = !0, i[o] = {
                        status: "fulfilled",
                        value: e
                      }, --s || r(i));
                    }, function (e) {
                      u || (u = !0, i[o] = {
                        status: "rejected",
                        reason: e
                      }, --s || r(i));
                    });
                  }), --s || r(i);
                });
              return c.error && s(c.value), n.promise;
            }
          });
        },
        7206: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(3916),
            i = n(626),
            a = n(9520),
            u = n(2),
            s = n(3091),
            c = "No one promise resolved";
          r({
            target: "Promise",
            stat: !0
          }, {
            any: function (e) {
              var t = this,
                n = a.f(t),
                r = n.resolve,
                f = n.reject,
                l = u(function () {
                  var n = o(t.resolve),
                    a = [],
                    u = 0,
                    l = 1,
                    p = !1;
                  s(e, function (e) {
                    var o = u++,
                      s = !1;
                    a.push(void 0), l++, n.call(t, e).then(function (e) {
                      s || p || (p = !0, r(e));
                    }, function (e) {
                      s || p || (s = !0, a[o] = e, --l || f(new (i("AggregateError"))(a, c)));
                    });
                  }), --l || f(new (i("AggregateError"))(a, c));
                });
              return l.error && f(l.value), n.promise;
            }
          });
        },
        4349: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(2529),
            i = n(9297),
            a = n(5981),
            u = n(626),
            s = n(487),
            c = n(6584),
            f = n(1341);
          if (r({
            target: "Promise",
            proto: !0,
            real: !0,
            forced: !!i && a(function () {
              i.prototype.finally.call({
                then: function () {}
              }, function () {});
            })
          }, {
            finally: function (e) {
              var t = s(this, u("Promise")),
                n = "function" == typeof e;
              return this.then(n ? function (n) {
                return c(t, e()).then(function () {
                  return n;
                });
              } : e, n ? function (n) {
                return c(t, e()).then(function () {
                  throw n;
                });
              } : e);
            }
          }), !o && "function" == typeof i) {
            var l = u("Promise").prototype.finally;
            i.prototype.finally !== l && f(i.prototype, "finally", l, {
              unsafe: !0
            });
          }
        },
        8881: function (e, t, n) {
          "use strict";

          var r,
            o,
            i,
            a,
            u = n(6887),
            s = n(2529),
            c = n(1899),
            f = n(626),
            l = n(9297),
            p = n(1341),
            h = n(7524),
            d = n(8929),
            v = n(904),
            g = n(4431),
            y = n(941),
            m = n(3916),
            b = n(5743),
            k = n(1302),
            w = n(3091),
            x = n(1385),
            S = n(487),
            T = n(2941).set,
            O = n(6132),
            A = n(6584),
            E = n(4845),
            _ = n(9520),
            R = n(2),
            P = n(5402),
            j = n(7252),
            I = n(9813),
            C = n(3321),
            M = n(6049),
            U = n(3385),
            F = I("species"),
            N = "Promise",
            L = P.get,
            D = P.set,
            B = P.getterFor(N),
            q = l && l.prototype,
            H = l,
            K = q,
            V = c.TypeError,
            G = c.document,
            W = c.process,
            $ = _.f,
            z = $,
            J = !!(G && G.createEvent && c.dispatchEvent),
            Y = "function" == typeof PromiseRejectionEvent,
            X = "unhandledrejection",
            Q = !1,
            Z = j(N, function () {
              var e = k(H) !== String(H);
              if (!e && 66 === U) return !0;
              if (s && !K.finally) return !0;
              if (U >= 51 && /native code/.test(H)) return !1;
              var t = new H(function (e) {
                  e(1);
                }),
                n = function (e) {
                  e(function () {}, function () {});
                };
              return (t.constructor = {})[F] = n, !(Q = t.then(function () {}) instanceof n) || !e && C && !Y;
            }),
            ee = Z || !x(function (e) {
              H.all(e).catch(function () {});
            }),
            te = function (e) {
              var t;
              return !(!y(e) || "function" != typeof (t = e.then)) && t;
            },
            ne = function (e, t) {
              if (!e.notified) {
                e.notified = !0;
                var n = e.reactions;
                O(function () {
                  for (var r = e.value, o = 1 == e.state, i = 0; n.length > i;) {
                    var a,
                      u,
                      s,
                      c = n[i++],
                      f = o ? c.ok : c.fail,
                      l = c.resolve,
                      p = c.reject,
                      h = c.domain;
                    try {
                      f ? (o || (2 === e.rejection && ae(e), e.rejection = 1), !0 === f ? a = r : (h && h.enter(), a = f(r), h && (h.exit(), s = !0)), a === c.promise ? p(V("Promise-chain cycle")) : (u = te(a)) ? u.call(a, l, p) : l(a)) : p(r);
                    } catch (e) {
                      h && !s && h.exit(), p(e);
                    }
                  }
                  e.reactions = [], e.notified = !1, t && !e.rejection && oe(e);
                });
              }
            },
            re = function (e, t, n) {
              var r, o;
              J ? ((r = G.createEvent("Event")).promise = t, r.reason = n, r.initEvent(e, !1, !0), c.dispatchEvent(r)) : r = {
                promise: t,
                reason: n
              }, !Y && (o = c["on" + e]) ? o(r) : e === X && E("Unhandled promise rejection", n);
            },
            oe = function (e) {
              T.call(c, function () {
                var t,
                  n = e.facade,
                  r = e.value;
                if (ie(e) && (t = R(function () {
                  M ? W.emit("unhandledRejection", r, n) : re(X, n, r);
                }), e.rejection = M || ie(e) ? 2 : 1, t.error)) throw t.value;
              });
            },
            ie = function (e) {
              return 1 !== e.rejection && !e.parent;
            },
            ae = function (e) {
              T.call(c, function () {
                var t = e.facade;
                M ? W.emit("rejectionHandled", t) : re("rejectionhandled", t, e.value);
              });
            },
            ue = function (e, t, n) {
              return function (r) {
                e(t, r, n);
              };
            },
            se = function (e, t, n) {
              e.done || (e.done = !0, n && (e = n), e.value = t, e.state = 2, ne(e, !0));
            },
            ce = function (e, t, n) {
              if (!e.done) {
                e.done = !0, n && (e = n);
                try {
                  if (e.facade === t) throw V("Promise can't be resolved itself");
                  var r = te(t);
                  r ? O(function () {
                    var n = {
                      done: !1
                    };
                    try {
                      r.call(t, ue(ce, n, e), ue(se, n, e));
                    } catch (t) {
                      se(n, t, e);
                    }
                  }) : (e.value = t, e.state = 1, ne(e, !1));
                } catch (t) {
                  se({
                    done: !1
                  }, t, e);
                }
              }
            };
          if (Z && (K = (H = function (e) {
            b(this, H, N), m(e), r.call(this);
            var t = L(this);
            try {
              e(ue(ce, t), ue(se, t));
            } catch (e) {
              se(t, e);
            }
          }).prototype, (r = function (e) {
            D(this, {
              type: N,
              done: !1,
              notified: !1,
              parent: !1,
              reactions: [],
              rejection: !1,
              state: 0,
              value: void 0
            });
          }).prototype = h(K, {
            then: function (e, t) {
              var n = B(this),
                r = $(S(this, H));
              return r.ok = "function" != typeof e || e, r.fail = "function" == typeof t && t, r.domain = M ? W.domain : void 0, n.parent = !0, n.reactions.push(r), 0 != n.state && ne(n, !1), r.promise;
            },
            catch: function (e) {
              return this.then(void 0, e);
            }
          }), o = function () {
            var e = new r(),
              t = L(e);
            this.promise = e, this.resolve = ue(ce, t), this.reject = ue(se, t);
          }, _.f = $ = function (e) {
            return e === H || e === i ? new o(e) : z(e);
          }, !s && "function" == typeof l && q !== Object.prototype)) {
            a = q.then, Q || (p(q, "then", function (e, t) {
              var n = this;
              return new H(function (e, t) {
                a.call(n, e, t);
              }).then(e, t);
            }, {
              unsafe: !0
            }), p(q, "catch", K.catch, {
              unsafe: !0
            }));
            try {
              delete q.constructor;
            } catch (e) {}
            d && d(q, K);
          }
          u({
            global: !0,
            wrap: !0,
            forced: Z
          }, {
            Promise: H
          }), v(H, N, !1, !0), g(N), i = f(N), u({
            target: N,
            stat: !0,
            forced: Z
          }, {
            reject: function (e) {
              var t = $(this);
              return t.reject.call(void 0, e), t.promise;
            }
          }), u({
            target: N,
            stat: !0,
            forced: s || Z
          }, {
            resolve: function (e) {
              return A(s && this === i ? H : this, e);
            }
          }), u({
            target: N,
            stat: !0,
            forced: ee
          }, {
            all: function (e) {
              var t = this,
                n = $(t),
                r = n.resolve,
                o = n.reject,
                i = R(function () {
                  var n = m(t.resolve),
                    i = [],
                    a = 0,
                    u = 1;
                  w(e, function (e) {
                    var s = a++,
                      c = !1;
                    i.push(void 0), u++, n.call(t, e).then(function (e) {
                      c || (c = !0, i[s] = e, --u || r(i));
                    }, o);
                  }), --u || r(i);
                });
              return i.error && o(i.value), n.promise;
            },
            race: function (e) {
              var t = this,
                n = $(t),
                r = n.reject,
                o = R(function () {
                  var o = m(t.resolve);
                  w(e, function (e) {
                    o.call(t, e).then(n.resolve, r);
                  });
                });
              return o.error && r(o.value), n.promise;
            }
          });
        },
        1502: function () {},
        7971: function (e, t, n) {
          "use strict";

          var r = n(4620).charAt,
            o = n(5402),
            i = n(7771),
            a = "String Iterator",
            u = o.set,
            s = o.getterFor(a);
          i(String, "String", function (e) {
            u(this, {
              type: a,
              string: String(e),
              index: 0
            });
          }, function () {
            var e,
              t = s(this),
              n = t.string,
              o = t.index;
            return o >= n.length ? {
              value: void 0,
              done: !0
            } : (e = r(n, o), t.index += e.length, {
              value: e,
              done: !1
            });
          });
        },
        8555: function (e, t, n) {
          n(6349)("asyncIterator");
        },
        2615: function () {},
        1732: function (e, t, n) {
          n(6349)("hasInstance");
        },
        5903: function (e, t, n) {
          n(6349)("isConcatSpreadable");
        },
        1825: function (e, t, n) {
          n(6349)("iterator");
        },
        5824: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(1899),
            i = n(626),
            a = n(2529),
            u = n(5746),
            s = n(2497),
            c = n(2302),
            f = n(5981),
            l = n(7457),
            p = n(1052),
            h = n(941),
            d = n(6059),
            v = n(9678),
            g = n(4529),
            y = n(6935),
            m = n(1887),
            b = n(9290),
            k = n(4771),
            w = n(946),
            x = n(684),
            S = n(7857),
            T = n(9677),
            O = n(5988),
            A = n(8838),
            E = n(2029),
            _ = n(1341),
            R = n(8726),
            P = n(4262),
            j = n(7748),
            I = n(9418),
            C = n(9813),
            M = n(1477),
            U = n(6349),
            F = n(904),
            N = n(5402),
            L = n(3610).forEach,
            D = P("hidden"),
            B = "Symbol",
            q = C("toPrimitive"),
            H = N.set,
            K = N.getterFor(B),
            V = Object.prototype,
            G = o.Symbol,
            W = i("JSON", "stringify"),
            $ = T.f,
            z = O.f,
            J = x.f,
            Y = A.f,
            X = R("symbols"),
            Q = R("op-symbols"),
            Z = R("string-to-symbol-registry"),
            ee = R("symbol-to-string-registry"),
            te = R("wks"),
            ne = o.QObject,
            re = !ne || !ne.prototype || !ne.prototype.findChild,
            oe = u && f(function () {
              return 7 != b(z({}, "a", {
                get: function () {
                  return z(this, "a", {
                    value: 7
                  }).a;
                }
              })).a;
            }) ? function (e, t, n) {
              var r = $(V, t);
              r && delete V[t], z(e, t, n), r && e !== V && z(V, t, r);
            } : z,
            ie = function (e, t) {
              var n = X[e] = b(G.prototype);
              return H(n, {
                type: B,
                tag: e,
                description: t
              }), u || (n.description = t), n;
            },
            ae = c ? function (e) {
              return "symbol" == typeof e;
            } : function (e) {
              return Object(e) instanceof G;
            },
            ue = function (e, t, n) {
              e === V && ue(Q, t, n), d(e);
              var r = y(t, !0);
              return d(n), l(X, r) ? (n.enumerable ? (l(e, D) && e[D][r] && (e[D][r] = !1), n = b(n, {
                enumerable: m(0, !1)
              })) : (l(e, D) || z(e, D, m(1, {})), e[D][r] = !0), oe(e, r, n)) : z(e, r, n);
            },
            se = function (e, t) {
              d(e);
              var n = g(t),
                r = k(n).concat(pe(n));
              return L(r, function (t) {
                u && !ce.call(n, t) || ue(e, t, n[t]);
              }), e;
            },
            ce = function (e) {
              var t = y(e, !0),
                n = Y.call(this, t);
              return !(this === V && l(X, t) && !l(Q, t)) && (!(n || !l(this, t) || !l(X, t) || l(this, D) && this[D][t]) || n);
            },
            fe = function (e, t) {
              var n = g(e),
                r = y(t, !0);
              if (n !== V || !l(X, r) || l(Q, r)) {
                var o = $(n, r);
                return !o || !l(X, r) || l(n, D) && n[D][r] || (o.enumerable = !0), o;
              }
            },
            le = function (e) {
              var t = J(g(e)),
                n = [];
              return L(t, function (e) {
                l(X, e) || l(j, e) || n.push(e);
              }), n;
            },
            pe = function (e) {
              var t = e === V,
                n = J(t ? Q : g(e)),
                r = [];
              return L(n, function (e) {
                !l(X, e) || t && !l(V, e) || r.push(X[e]);
              }), r;
            };
          s || (G = function () {
            if (this instanceof G) throw TypeError("Symbol is not a constructor");
            var e = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
              t = I(e),
              n = function (e) {
                this === V && n.call(Q, e), l(this, D) && l(this[D], t) && (this[D][t] = !1), oe(this, t, m(1, e));
              };
            return u && re && oe(V, t, {
              configurable: !0,
              set: n
            }), ie(t, e);
          }, _(G.prototype, "toString", function () {
            return K(this).tag;
          }), _(G, "withoutSetter", function (e) {
            return ie(I(e), e);
          }), A.f = ce, O.f = ue, T.f = fe, w.f = x.f = le, S.f = pe, M.f = function (e) {
            return ie(C(e), e);
          }, u && (z(G.prototype, "description", {
            configurable: !0,
            get: function () {
              return K(this).description;
            }
          }), a || _(V, "propertyIsEnumerable", ce, {
            unsafe: !0
          }))), r({
            global: !0,
            wrap: !0,
            forced: !s,
            sham: !s
          }, {
            Symbol: G
          }), L(k(te), function (e) {
            U(e);
          }), r({
            target: B,
            stat: !0,
            forced: !s
          }, {
            for: function (e) {
              var t = String(e);
              if (l(Z, t)) return Z[t];
              var n = G(t);
              return Z[t] = n, ee[n] = t, n;
            },
            keyFor: function (e) {
              if (!ae(e)) throw TypeError(e + " is not a symbol");
              if (l(ee, e)) return ee[e];
            },
            useSetter: function () {
              re = !0;
            },
            useSimple: function () {
              re = !1;
            }
          }), r({
            target: "Object",
            stat: !0,
            forced: !s,
            sham: !u
          }, {
            create: function (e, t) {
              return void 0 === t ? b(e) : se(b(e), t);
            },
            defineProperty: ue,
            defineProperties: se,
            getOwnPropertyDescriptor: fe
          }), r({
            target: "Object",
            stat: !0,
            forced: !s
          }, {
            getOwnPropertyNames: le,
            getOwnPropertySymbols: pe
          }), r({
            target: "Object",
            stat: !0,
            forced: f(function () {
              S.f(1);
            })
          }, {
            getOwnPropertySymbols: function (e) {
              return S.f(v(e));
            }
          }), W && r({
            target: "JSON",
            stat: !0,
            forced: !s || f(function () {
              var e = G();
              return "[null]" != W([e]) || "{}" != W({
                a: e
              }) || "{}" != W(Object(e));
            })
          }, {
            stringify: function (e, t, n) {
              for (var r, o = [e], i = 1; arguments.length > i;) o.push(arguments[i++]);
              if (r = t, (h(t) || void 0 !== e) && !ae(e)) return p(t) || (t = function (e, t) {
                if ("function" == typeof r && (t = r.call(this, e, t)), !ae(t)) return t;
              }), o[1] = t, W.apply(null, o);
            }
          }), G.prototype[q] || E(G.prototype, q, G.prototype.valueOf), F(G, B), j[D] = !0;
        },
        5915: function (e, t, n) {
          n(6349)("matchAll");
        },
        8394: function (e, t, n) {
          n(6349)("match");
        },
        1766: function (e, t, n) {
          n(6349)("replace");
        },
        9791: function (e, t, n) {
          n(6349)("search");
        },
        9911: function (e, t, n) {
          n(6349)("species");
        },
        4315: function (e, t, n) {
          n(6349)("split");
        },
        3131: function (e, t, n) {
          n(6349)("toPrimitive");
        },
        4714: function (e, t, n) {
          n(6349)("toStringTag");
        },
        659: function (e, t, n) {
          n(6349)("unscopables");
        },
        9731: function (e, t, n) {
          n(7627);
        },
        5708: function (e, t, n) {
          n(4560);
        },
        8731: function (e, t, n) {
          n(7206);
        },
        14: function (e, t, n) {
          "use strict";

          var r = n(6887),
            o = n(9520),
            i = n(2);
          r({
            target: "Promise",
            stat: !0
          }, {
            try: function (e) {
              var t = o.f(this),
                n = i(e);
              return (n.error ? t.reject : t.resolve)(n.value), t.promise;
            }
          });
        },
        8783: function (e, t, n) {
          n(6349)("asyncDispose");
        },
        3975: function (e, t, n) {
          n(6349)("dispose");
        },
        5799: function (e, t, n) {
          n(6349)("matcher");
        },
        5414: function (e, t, n) {
          n(6349)("metadata");
        },
        6774: function (e, t, n) {
          n(6349)("observable");
        },
        620: function (e, t, n) {
          n(6349)("patternMatch");
        },
        6172: function (e, t, n) {
          n(6349)("replaceAll");
        },
        7634: function (e, t, n) {
          n(6274);
          var r = n(3281),
            o = n(1899),
            i = n(9697),
            a = n(2029),
            u = n(2077),
            s = n(9813)("toStringTag");
          for (var c in r) {
            var f = o[c],
              l = f && f.prototype;
            l && i(l) !== s && a(l, s, c), u[c] = u.Array;
          }
        },
        5304: function (e, t, n) {
          "use strict";

          n(6274);
          var r = n(6887),
            o = n(626),
            i = n(8468),
            a = n(1341),
            u = n(7524),
            s = n(904),
            c = n(1046),
            f = n(5402),
            l = n(5743),
            p = n(7457),
            h = n(6843),
            d = n(9697),
            v = n(6059),
            g = n(941),
            y = n(9290),
            m = n(1887),
            b = n(429),
            k = n(2902),
            w = n(9813),
            x = o("fetch"),
            S = o("Headers"),
            T = w("iterator"),
            O = "URLSearchParams",
            A = "URLSearchParamsIterator",
            E = f.set,
            _ = f.getterFor(O),
            R = f.getterFor(A),
            P = /\+/g,
            j = Array(4),
            I = function (e) {
              return j[e - 1] || (j[e - 1] = RegExp("((?:%[\\da-f]{2}){" + e + "})", "gi"));
            },
            C = function (e) {
              try {
                return decodeURIComponent(e);
              } catch (t) {
                return e;
              }
            },
            M = function (e) {
              var t = e.replace(P, " "),
                n = 4;
              try {
                return decodeURIComponent(t);
              } catch (e) {
                for (; n;) t = t.replace(I(n--), C);
                return t;
              }
            },
            U = /[!'()~]|%20/g,
            F = {
              "!": "%21",
              "'": "%27",
              "(": "%28",
              ")": "%29",
              "~": "%7E",
              "%20": "+"
            },
            N = function (e) {
              return F[e];
            },
            L = function (e) {
              return encodeURIComponent(e).replace(U, N);
            },
            D = function (e, t) {
              if (t) for (var n, r, o = t.split("&"), i = 0; i < o.length;) (n = o[i++]).length && (r = n.split("="), e.push({
                key: M(r.shift()),
                value: M(r.join("="))
              }));
            },
            B = function (e) {
              this.entries.length = 0, D(this.entries, e);
            },
            q = function (e, t) {
              if (e < t) throw TypeError("Not enough arguments");
            },
            H = c(function (e, t) {
              E(this, {
                type: A,
                iterator: b(_(e).entries),
                kind: t
              });
            }, "Iterator", function () {
              var e = R(this),
                t = e.kind,
                n = e.iterator.next(),
                r = n.value;
              return n.done || (n.value = "keys" === t ? r.key : "values" === t ? r.value : [r.key, r.value]), n;
            }),
            K = function () {
              l(this, K, O);
              var e,
                t,
                n,
                r,
                o,
                i,
                a,
                u,
                s,
                c = arguments.length > 0 ? arguments[0] : void 0,
                f = this,
                h = [];
              if (E(f, {
                type: O,
                entries: h,
                updateURL: function () {},
                updateSearchParams: B
              }), void 0 !== c) if (g(c)) {
                if ("function" == typeof (e = k(c))) for (n = (t = e.call(c)).next; !(r = n.call(t)).done;) {
                  if ((a = (i = (o = b(v(r.value))).next).call(o)).done || (u = i.call(o)).done || !i.call(o).done) throw TypeError("Expected sequence with length 2");
                  h.push({
                    key: a.value + "",
                    value: u.value + ""
                  });
                } else for (s in c) p(c, s) && h.push({
                  key: s,
                  value: c[s] + ""
                });
              } else D(h, "string" == typeof c ? "?" === c.charAt(0) ? c.slice(1) : c : c + "");
            },
            V = K.prototype;
          u(V, {
            append: function (e, t) {
              q(arguments.length, 2);
              var n = _(this);
              n.entries.push({
                key: e + "",
                value: t + ""
              }), n.updateURL();
            },
            delete: function (e) {
              q(arguments.length, 1);
              for (var t = _(this), n = t.entries, r = e + "", o = 0; o < n.length;) n[o].key === r ? n.splice(o, 1) : o++;
              t.updateURL();
            },
            get: function (e) {
              q(arguments.length, 1);
              for (var t = _(this).entries, n = e + "", r = 0; r < t.length; r++) if (t[r].key === n) return t[r].value;
              return null;
            },
            getAll: function (e) {
              q(arguments.length, 1);
              for (var t = _(this).entries, n = e + "", r = [], o = 0; o < t.length; o++) t[o].key === n && r.push(t[o].value);
              return r;
            },
            has: function (e) {
              q(arguments.length, 1);
              for (var t = _(this).entries, n = e + "", r = 0; r < t.length;) if (t[r++].key === n) return !0;
              return !1;
            },
            set: function (e, t) {
              q(arguments.length, 1);
              for (var n, r = _(this), o = r.entries, i = !1, a = e + "", u = t + "", s = 0; s < o.length; s++) (n = o[s]).key === a && (i ? o.splice(s--, 1) : (i = !0, n.value = u));
              i || o.push({
                key: a,
                value: u
              }), r.updateURL();
            },
            sort: function () {
              var e,
                t,
                n,
                r = _(this),
                o = r.entries,
                i = o.slice();
              for (o.length = 0, n = 0; n < i.length; n++) {
                for (e = i[n], t = 0; t < n; t++) if (o[t].key > e.key) {
                  o.splice(t, 0, e);
                  break;
                }
                t === n && o.push(e);
              }
              r.updateURL();
            },
            forEach: function (e) {
              for (var t, n = _(this).entries, r = h(e, arguments.length > 1 ? arguments[1] : void 0, 3), o = 0; o < n.length;) r((t = n[o++]).value, t.key, this);
            },
            keys: function () {
              return new H(this, "keys");
            },
            values: function () {
              return new H(this, "values");
            },
            entries: function () {
              return new H(this, "entries");
            }
          }, {
            enumerable: !0
          }), a(V, T, V.entries), a(V, "toString", function () {
            for (var e, t = _(this).entries, n = [], r = 0; r < t.length;) e = t[r++], n.push(L(e.key) + "=" + L(e.value));
            return n.join("&");
          }, {
            enumerable: !0
          }), s(K, O), r({
            global: !0,
            forced: !i
          }, {
            URLSearchParams: K
          }), i || "function" != typeof x || "function" != typeof S || r({
            global: !0,
            enumerable: !0,
            forced: !0
          }, {
            fetch: function (e) {
              var t,
                n,
                r,
                o = [e];
              return arguments.length > 1 && (g(t = arguments[1]) && (n = t.body, d(n) === O && ((r = t.headers ? new S(t.headers) : new S()).has("content-type") || r.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = y(t, {
                body: m(0, String(n)),
                headers: m(0, r)
              }))), o.push(t)), x.apply(this, o);
            }
          }), e.exports = {
            URLSearchParams: K,
            getState: _
          };
        },
        3601: function (e, t, n) {
          "use strict";

          n(7971);
          var r,
            o = n(6887),
            i = n(5746),
            a = n(8468),
            u = n(1899),
            s = n(9938),
            c = n(1341),
            f = n(5743),
            l = n(7457),
            p = n(4420),
            h = n(1354),
            d = n(4620).codeAt,
            v = n(3291),
            g = n(904),
            y = n(5304),
            m = n(5402),
            b = u.URL,
            k = y.URLSearchParams,
            w = y.getState,
            x = m.set,
            S = m.getterFor("URL"),
            T = Math.floor,
            O = Math.pow,
            A = "Invalid scheme",
            E = "Invalid host",
            _ = "Invalid port",
            R = /[A-Za-z]/,
            P = /[\d+-.A-Za-z]/,
            j = /\d/,
            I = /^0x/i,
            C = /^[0-7]+$/,
            M = /^\d+$/,
            U = /^[\dA-Fa-f]+$/,
            F = /[\0\t\n\r #%/:<>?@[\\\]^|]/,
            N = /[\0\t\n\r #/:<>?@[\\\]^|]/,
            L = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
            D = /[\t\n\r]/g,
            B = function (e, t) {
              var n, r, o;
              if ("[" == t.charAt(0)) {
                if ("]" != t.charAt(t.length - 1)) return E;
                if (!(n = H(t.slice(1, -1)))) return E;
                e.host = n;
              } else if (Y(e)) {
                if (t = v(t), F.test(t)) return E;
                if (null === (n = q(t))) return E;
                e.host = n;
              } else {
                if (N.test(t)) return E;
                for (n = "", r = h(t), o = 0; o < r.length; o++) n += z(r[o], V);
                e.host = n;
              }
            },
            q = function (e) {
              var t,
                n,
                r,
                o,
                i,
                a,
                u,
                s = e.split(".");
              if (s.length && "" == s[s.length - 1] && s.pop(), (t = s.length) > 4) return e;
              for (n = [], r = 0; r < t; r++) {
                if ("" == (o = s[r])) return e;
                if (i = 10, o.length > 1 && "0" == o.charAt(0) && (i = I.test(o) ? 16 : 8, o = o.slice(8 == i ? 1 : 2)), "" === o) a = 0;else {
                  if (!(10 == i ? M : 8 == i ? C : U).test(o)) return e;
                  a = parseInt(o, i);
                }
                n.push(a);
              }
              for (r = 0; r < t; r++) if (a = n[r], r == t - 1) {
                if (a >= O(256, 5 - t)) return null;
              } else if (a > 255) return null;
              for (u = n.pop(), r = 0; r < n.length; r++) u += n[r] * O(256, 3 - r);
              return u;
            },
            H = function (e) {
              var t,
                n,
                r,
                o,
                i,
                a,
                u,
                s = [0, 0, 0, 0, 0, 0, 0, 0],
                c = 0,
                f = null,
                l = 0,
                p = function () {
                  return e.charAt(l);
                };
              if (":" == p()) {
                if (":" != e.charAt(1)) return;
                l += 2, f = ++c;
              }
              for (; p();) {
                if (8 == c) return;
                if (":" != p()) {
                  for (t = n = 0; n < 4 && U.test(p());) t = 16 * t + parseInt(p(), 16), l++, n++;
                  if ("." == p()) {
                    if (0 == n) return;
                    if (l -= n, c > 6) return;
                    for (r = 0; p();) {
                      if (o = null, r > 0) {
                        if (!("." == p() && r < 4)) return;
                        l++;
                      }
                      if (!j.test(p())) return;
                      for (; j.test(p());) {
                        if (i = parseInt(p(), 10), null === o) o = i;else {
                          if (0 == o) return;
                          o = 10 * o + i;
                        }
                        if (o > 255) return;
                        l++;
                      }
                      s[c] = 256 * s[c] + o, 2 != ++r && 4 != r || c++;
                    }
                    if (4 != r) return;
                    break;
                  }
                  if (":" == p()) {
                    if (l++, !p()) return;
                  } else if (p()) return;
                  s[c++] = t;
                } else {
                  if (null !== f) return;
                  l++, f = ++c;
                }
              }
              if (null !== f) for (a = c - f, c = 7; 0 != c && a > 0;) u = s[c], s[c--] = s[f + a - 1], s[f + --a] = u;else if (8 != c) return;
              return s;
            },
            K = function (e) {
              var t, n, r, o;
              if ("number" == typeof e) {
                for (t = [], n = 0; n < 4; n++) t.unshift(e % 256), e = T(e / 256);
                return t.join(".");
              }
              if ("object" == typeof e) {
                for (t = "", r = function (e) {
                  for (var t = null, n = 1, r = null, o = 0, i = 0; i < 8; i++) 0 !== e[i] ? (o > n && (t = r, n = o), r = null, o = 0) : (null === r && (r = i), ++o);
                  return o > n && (t = r, n = o), t;
                }(e), n = 0; n < 8; n++) o && 0 === e[n] || (o && (o = !1), r === n ? (t += n ? ":" : "::", o = !0) : (t += e[n].toString(16), n < 7 && (t += ":")));
                return "[" + t + "]";
              }
              return e;
            },
            V = {},
            G = p({}, V, {
              " ": 1,
              '"': 1,
              "<": 1,
              ">": 1,
              "`": 1
            }),
            W = p({}, G, {
              "#": 1,
              "?": 1,
              "{": 1,
              "}": 1
            }),
            $ = p({}, W, {
              "/": 1,
              ":": 1,
              ";": 1,
              "=": 1,
              "@": 1,
              "[": 1,
              "\\": 1,
              "]": 1,
              "^": 1,
              "|": 1
            }),
            z = function (e, t) {
              var n = d(e, 0);
              return n > 32 && n < 127 && !l(t, e) ? e : encodeURIComponent(e);
            },
            J = {
              ftp: 21,
              file: null,
              http: 80,
              https: 443,
              ws: 80,
              wss: 443
            },
            Y = function (e) {
              return l(J, e.scheme);
            },
            X = function (e) {
              return "" != e.username || "" != e.password;
            },
            Q = function (e) {
              return !e.host || e.cannotBeABaseURL || "file" == e.scheme;
            },
            Z = function (e, t) {
              var n;
              return 2 == e.length && R.test(e.charAt(0)) && (":" == (n = e.charAt(1)) || !t && "|" == n);
            },
            ee = function (e) {
              var t;
              return e.length > 1 && Z(e.slice(0, 2)) && (2 == e.length || "/" === (t = e.charAt(2)) || "\\" === t || "?" === t || "#" === t);
            },
            te = function (e) {
              var t = e.path,
                n = t.length;
              !n || "file" == e.scheme && 1 == n && Z(t[0], !0) || t.pop();
            },
            ne = function (e) {
              return "." === e || "%2e" === e.toLowerCase();
            },
            re = {},
            oe = {},
            ie = {},
            ae = {},
            ue = {},
            se = {},
            ce = {},
            fe = {},
            le = {},
            pe = {},
            he = {},
            de = {},
            ve = {},
            ge = {},
            ye = {},
            me = {},
            be = {},
            ke = {},
            we = {},
            xe = {},
            Se = {},
            Te = function (e, t, n, o) {
              var i,
                a,
                u,
                s,
                c,
                f = n || re,
                p = 0,
                d = "",
                v = !1,
                g = !1,
                y = !1;
              for (n || (e.scheme = "", e.username = "", e.password = "", e.host = null, e.port = null, e.path = [], e.query = null, e.fragment = null, e.cannotBeABaseURL = !1, t = t.replace(L, "")), t = t.replace(D, ""), i = h(t); p <= i.length;) {
                switch (a = i[p], f) {
                  case re:
                    if (!a || !R.test(a)) {
                      if (n) return A;
                      f = ie;
                      continue;
                    }
                    d += a.toLowerCase(), f = oe;
                    break;
                  case oe:
                    if (a && (P.test(a) || "+" == a || "-" == a || "." == a)) d += a.toLowerCase();else {
                      if (":" != a) {
                        if (n) return A;
                        d = "", f = ie, p = 0;
                        continue;
                      }
                      if (n && (Y(e) != l(J, d) || "file" == d && (X(e) || null !== e.port) || "file" == e.scheme && !e.host)) return;
                      if (e.scheme = d, n) return void (Y(e) && J[e.scheme] == e.port && (e.port = null));
                      d = "", "file" == e.scheme ? f = ge : Y(e) && o && o.scheme == e.scheme ? f = ae : Y(e) ? f = fe : "/" == i[p + 1] ? (f = ue, p++) : (e.cannotBeABaseURL = !0, e.path.push(""), f = we);
                    }
                    break;
                  case ie:
                    if (!o || o.cannotBeABaseURL && "#" != a) return A;
                    if (o.cannotBeABaseURL && "#" == a) {
                      e.scheme = o.scheme, e.path = o.path.slice(), e.query = o.query, e.fragment = "", e.cannotBeABaseURL = !0, f = Se;
                      break;
                    }
                    f = "file" == o.scheme ? ge : se;
                    continue;
                  case ae:
                    if ("/" != a || "/" != i[p + 1]) {
                      f = se;
                      continue;
                    }
                    f = le, p++;
                    break;
                  case ue:
                    if ("/" == a) {
                      f = pe;
                      break;
                    }
                    f = ke;
                    continue;
                  case se:
                    if (e.scheme = o.scheme, a == r) e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = o.query;else if ("/" == a || "\\" == a && Y(e)) f = ce;else if ("?" == a) e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = "", f = xe;else {
                      if ("#" != a) {
                        e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.path.pop(), f = ke;
                        continue;
                      }
                      e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = o.query, e.fragment = "", f = Se;
                    }
                    break;
                  case ce:
                    if (!Y(e) || "/" != a && "\\" != a) {
                      if ("/" != a) {
                        e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, f = ke;
                        continue;
                      }
                      f = pe;
                    } else f = le;
                    break;
                  case fe:
                    if (f = le, "/" != a || "/" != d.charAt(p + 1)) continue;
                    p++;
                    break;
                  case le:
                    if ("/" != a && "\\" != a) {
                      f = pe;
                      continue;
                    }
                    break;
                  case pe:
                    if ("@" == a) {
                      v && (d = "%40" + d), v = !0, u = h(d);
                      for (var m = 0; m < u.length; m++) {
                        var b = u[m];
                        if (":" != b || y) {
                          var k = z(b, $);
                          y ? e.password += k : e.username += k;
                        } else y = !0;
                      }
                      d = "";
                    } else if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && Y(e)) {
                      if (v && "" == d) return "Invalid authority";
                      p -= h(d).length + 1, d = "", f = he;
                    } else d += a;
                    break;
                  case he:
                  case de:
                    if (n && "file" == e.scheme) {
                      f = me;
                      continue;
                    }
                    if (":" != a || g) {
                      if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && Y(e)) {
                        if (Y(e) && "" == d) return E;
                        if (n && "" == d && (X(e) || null !== e.port)) return;
                        if (s = B(e, d)) return s;
                        if (d = "", f = be, n) return;
                        continue;
                      }
                      "[" == a ? g = !0 : "]" == a && (g = !1), d += a;
                    } else {
                      if ("" == d) return E;
                      if (s = B(e, d)) return s;
                      if (d = "", f = ve, n == de) return;
                    }
                    break;
                  case ve:
                    if (!j.test(a)) {
                      if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && Y(e) || n) {
                        if ("" != d) {
                          var w = parseInt(d, 10);
                          if (w > 65535) return _;
                          e.port = Y(e) && w === J[e.scheme] ? null : w, d = "";
                        }
                        if (n) return;
                        f = be;
                        continue;
                      }
                      return _;
                    }
                    d += a;
                    break;
                  case ge:
                    if (e.scheme = "file", "/" == a || "\\" == a) f = ye;else {
                      if (!o || "file" != o.scheme) {
                        f = ke;
                        continue;
                      }
                      if (a == r) e.host = o.host, e.path = o.path.slice(), e.query = o.query;else if ("?" == a) e.host = o.host, e.path = o.path.slice(), e.query = "", f = xe;else {
                        if ("#" != a) {
                          ee(i.slice(p).join("")) || (e.host = o.host, e.path = o.path.slice(), te(e)), f = ke;
                          continue;
                        }
                        e.host = o.host, e.path = o.path.slice(), e.query = o.query, e.fragment = "", f = Se;
                      }
                    }
                    break;
                  case ye:
                    if ("/" == a || "\\" == a) {
                      f = me;
                      break;
                    }
                    o && "file" == o.scheme && !ee(i.slice(p).join("")) && (Z(o.path[0], !0) ? e.path.push(o.path[0]) : e.host = o.host), f = ke;
                    continue;
                  case me:
                    if (a == r || "/" == a || "\\" == a || "?" == a || "#" == a) {
                      if (!n && Z(d)) f = ke;else if ("" == d) {
                        if (e.host = "", n) return;
                        f = be;
                      } else {
                        if (s = B(e, d)) return s;
                        if ("localhost" == e.host && (e.host = ""), n) return;
                        d = "", f = be;
                      }
                      continue;
                    }
                    d += a;
                    break;
                  case be:
                    if (Y(e)) {
                      if (f = ke, "/" != a && "\\" != a) continue;
                    } else if (n || "?" != a) {
                      if (n || "#" != a) {
                        if (a != r && (f = ke, "/" != a)) continue;
                      } else e.fragment = "", f = Se;
                    } else e.query = "", f = xe;
                    break;
                  case ke:
                    if (a == r || "/" == a || "\\" == a && Y(e) || !n && ("?" == a || "#" == a)) {
                      if (".." === (c = (c = d).toLowerCase()) || "%2e." === c || ".%2e" === c || "%2e%2e" === c ? (te(e), "/" == a || "\\" == a && Y(e) || e.path.push("")) : ne(d) ? "/" == a || "\\" == a && Y(e) || e.path.push("") : ("file" == e.scheme && !e.path.length && Z(d) && (e.host && (e.host = ""), d = d.charAt(0) + ":"), e.path.push(d)), d = "", "file" == e.scheme && (a == r || "?" == a || "#" == a)) for (; e.path.length > 1 && "" === e.path[0];) e.path.shift();
                      "?" == a ? (e.query = "", f = xe) : "#" == a && (e.fragment = "", f = Se);
                    } else d += z(a, W);
                    break;
                  case we:
                    "?" == a ? (e.query = "", f = xe) : "#" == a ? (e.fragment = "", f = Se) : a != r && (e.path[0] += z(a, V));
                    break;
                  case xe:
                    n || "#" != a ? a != r && ("'" == a && Y(e) ? e.query += "%27" : e.query += "#" == a ? "%23" : z(a, V)) : (e.fragment = "", f = Se);
                    break;
                  case Se:
                    a != r && (e.fragment += z(a, G));
                }
                p++;
              }
            },
            Oe = function (e) {
              var t,
                n,
                r = f(this, Oe, "URL"),
                o = arguments.length > 1 ? arguments[1] : void 0,
                a = String(e),
                u = x(r, {
                  type: "URL"
                });
              if (void 0 !== o) if (o instanceof Oe) t = S(o);else if (n = Te(t = {}, String(o))) throw TypeError(n);
              if (n = Te(u, a, null, t)) throw TypeError(n);
              var s = u.searchParams = new k(),
                c = w(s);
              c.updateSearchParams(u.query), c.updateURL = function () {
                u.query = String(s) || null;
              }, i || (r.href = Ee.call(r), r.origin = _e.call(r), r.protocol = Re.call(r), r.username = Pe.call(r), r.password = je.call(r), r.host = Ie.call(r), r.hostname = Ce.call(r), r.port = Me.call(r), r.pathname = Ue.call(r), r.search = Fe.call(r), r.searchParams = Ne.call(r), r.hash = Le.call(r));
            },
            Ae = Oe.prototype,
            Ee = function () {
              var e = S(this),
                t = e.scheme,
                n = e.username,
                r = e.password,
                o = e.host,
                i = e.port,
                a = e.path,
                u = e.query,
                s = e.fragment,
                c = t + ":";
              return null !== o ? (c += "//", X(e) && (c += n + (r ? ":" + r : "") + "@"), c += K(o), null !== i && (c += ":" + i)) : "file" == t && (c += "//"), c += e.cannotBeABaseURL ? a[0] : a.length ? "/" + a.join("/") : "", null !== u && (c += "?" + u), null !== s && (c += "#" + s), c;
            },
            _e = function () {
              var e = S(this),
                t = e.scheme,
                n = e.port;
              if ("blob" == t) try {
                return new Oe(t.path[0]).origin;
              } catch (e) {
                return "null";
              }
              return "file" != t && Y(e) ? t + "://" + K(e.host) + (null !== n ? ":" + n : "") : "null";
            },
            Re = function () {
              return S(this).scheme + ":";
            },
            Pe = function () {
              return S(this).username;
            },
            je = function () {
              return S(this).password;
            },
            Ie = function () {
              var e = S(this),
                t = e.host,
                n = e.port;
              return null === t ? "" : null === n ? K(t) : K(t) + ":" + n;
            },
            Ce = function () {
              var e = S(this).host;
              return null === e ? "" : K(e);
            },
            Me = function () {
              var e = S(this).port;
              return null === e ? "" : String(e);
            },
            Ue = function () {
              var e = S(this),
                t = e.path;
              return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
            },
            Fe = function () {
              var e = S(this).query;
              return e ? "?" + e : "";
            },
            Ne = function () {
              return S(this).searchParams;
            },
            Le = function () {
              var e = S(this).fragment;
              return e ? "#" + e : "";
            },
            De = function (e, t) {
              return {
                get: e,
                set: t,
                configurable: !0,
                enumerable: !0
              };
            };
          if (i && s(Ae, {
            href: De(Ee, function (e) {
              var t = S(this),
                n = String(e),
                r = Te(t, n);
              if (r) throw TypeError(r);
              w(t.searchParams).updateSearchParams(t.query);
            }),
            origin: De(_e),
            protocol: De(Re, function (e) {
              var t = S(this);
              Te(t, String(e) + ":", re);
            }),
            username: De(Pe, function (e) {
              var t = S(this),
                n = h(String(e));
              if (!Q(t)) {
                t.username = "";
                for (var r = 0; r < n.length; r++) t.username += z(n[r], $);
              }
            }),
            password: De(je, function (e) {
              var t = S(this),
                n = h(String(e));
              if (!Q(t)) {
                t.password = "";
                for (var r = 0; r < n.length; r++) t.password += z(n[r], $);
              }
            }),
            host: De(Ie, function (e) {
              var t = S(this);
              t.cannotBeABaseURL || Te(t, String(e), he);
            }),
            hostname: De(Ce, function (e) {
              var t = S(this);
              t.cannotBeABaseURL || Te(t, String(e), de);
            }),
            port: De(Me, function (e) {
              var t = S(this);
              Q(t) || ("" == (e = String(e)) ? t.port = null : Te(t, e, ve));
            }),
            pathname: De(Ue, function (e) {
              var t = S(this);
              t.cannotBeABaseURL || (t.path = [], Te(t, e + "", be));
            }),
            search: De(Fe, function (e) {
              var t = S(this);
              "" == (e = String(e)) ? t.query = null : ("?" == e.charAt(0) && (e = e.slice(1)), t.query = "", Te(t, e, xe)), w(t.searchParams).updateSearchParams(t.query);
            }),
            searchParams: De(Ne),
            hash: De(Le, function (e) {
              var t = S(this);
              "" != (e = String(e)) ? ("#" == e.charAt(0) && (e = e.slice(1)), t.fragment = "", Te(t, e, Se)) : t.fragment = null;
            })
          }), c(Ae, "toJSON", function () {
            return Ee.call(this);
          }, {
            enumerable: !0
          }), c(Ae, "toString", function () {
            return Ee.call(this);
          }, {
            enumerable: !0
          }), b) {
            var Be = b.createObjectURL,
              qe = b.revokeObjectURL;
            Be && c(Oe, "createObjectURL", function (e) {
              return Be.apply(b, arguments);
            }), qe && c(Oe, "revokeObjectURL", function (e) {
              return qe.apply(b, arguments);
            });
          }
          g(Oe, "URL"), o({
            global: !0,
            forced: !a,
            sham: !i
          }, {
            URL: Oe
          });
        },
        8947: function () {},
        7698: function (e, t, n) {
          var r = n(4493);
          e.exports = r;
        },
        3363: function (e, t, n) {
          var r = n(4034);
          e.exports = r;
        },
        9216: function (e, t, n) {
          var r = n(9324);
          e.exports = r;
        },
        8065: function (e, t, n) {
          var r = n(6043);
          e.exports = r;
        },
        1955: function (e, t, n) {
          var r = n(2480);
          e.exports = r;
        },
        1577: function (e, t, n) {
          var r = n(2236);
          e.exports = r;
        },
        6279: function (e, t, n) {
          n(7634);
          var r = n(9216),
            o = n(9697),
            i = Array.prototype,
            a = {
              DOMTokenList: !0,
              NodeList: !0
            };
          e.exports = function (e) {
            var t = e.forEach;
            return e === i || e instanceof Array && t === i.forEach || a.hasOwnProperty(o(e)) ? r : t;
          };
        },
        9373: function (e, t, n) {
          var r = n(4570);
          e.exports = r;
        },
        1798: function (e, t, n) {
          var r = n(8287);
          e.exports = r;
        },
        2073: function (e, t, n) {
          var r = n(9601);
          e.exports = r;
        },
        8933: function (e, t, n) {
          var r = n(4426);
          e.exports = r;
        },
        7396: function (e, t, n) {
          var r = n(7702);
          e.exports = r;
        },
        1910: function (e, t, n) {
          var r = n(8171);
          e.exports = r;
        },
        6209: function (e, t, n) {
          var r = n(3081);
          e.exports = r;
        },
        3402: function (e, t, n) {
          var r = n(7699);
          e.exports = r;
        },
        9427: function (e, t, n) {
          var r = n(286);
          e.exports = r;
        },
        2857: function (e, t, n) {
          var r = n(2766);
          e.exports = r;
        },
        9534: function (e, t, n) {
          var r = n(498);
          e.exports = r;
        },
        3059: function (e, t, n) {
          var r = n(8494);
          e.exports = r;
        },
        7460: function (e, t, n) {
          var r = n(2956);
          e.exports = r;
        },
        2547: function (e, t, n) {
          var r = n(7473);
          e.exports = r;
        },
        7641: function (e, t, n) {
          var r = n(1459);
          e.exports = r;
        },
        1459: function (e, t, n) {
          n(3601), n(8947), n(5304);
          var r = n(4058);
          e.exports = r.URL;
        },
        1530: function (e, t, n) {
          "use strict";

          var r = n(8710).charAt;
          e.exports = function (e, t, n) {
            return t + (n ? r(e, t).length : 1);
          };
        },
        9670: function (e, t, n) {
          var r = n(111);
          e.exports = function (e) {
            if (!r(e)) throw TypeError(String(e) + " is not an object");
            return e;
          };
        },
        1318: function (e, t, n) {
          var r = n(5656),
            o = n(7466),
            i = n(1400),
            a = function (e) {
              return function (t, n, a) {
                var u,
                  s = r(t),
                  c = o(s.length),
                  f = i(a, c);
                if (e && n != n) {
                  for (; c > f;) if ((u = s[f++]) != u) return !0;
                } else for (; c > f; f++) if ((e || f in s) && s[f] === n) return e || f || 0;
                return !e && -1;
              };
            };
          e.exports = {
            includes: a(!0),
            indexOf: a(!1)
          };
        },
        9341: function (e, t, n) {
          "use strict";

          var r = n(7293);
          e.exports = function (e, t) {
            var n = [][e];
            return !!n && r(function () {
              n.call(null, t || function () {
                throw 1;
              }, 1);
            });
          };
        },
        4326: function (e) {
          var t = {}.toString;
          e.exports = function (e) {
            return t.call(e).slice(8, -1);
          };
        },
        648: function (e, t, n) {
          var r = n(1694),
            o = n(4326),
            i = n(5112)("toStringTag"),
            a = "Arguments" == o(function () {
              return arguments;
            }());
          e.exports = r ? o : function (e) {
            var t, n, r;
            return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
              try {
                return e[t];
              } catch (e) {}
            }(t = Object(e), i)) ? n : a ? o(t) : "Object" == (r = o(t)) && "function" == typeof t.callee ? "Arguments" : r;
          };
        },
        9920: function (e, t, n) {
          var r = n(6656),
            o = n(3887),
            i = n(1236),
            a = n(3070);
          e.exports = function (e, t) {
            for (var n = o(t), u = a.f, s = i.f, c = 0; c < n.length; c++) {
              var f = n[c];
              r(e, f) || u(e, f, s(t, f));
            }
          };
        },
        8880: function (e, t, n) {
          var r = n(9781),
            o = n(3070),
            i = n(9114);
          e.exports = r ? function (e, t, n) {
            return o.f(e, t, i(1, n));
          } : function (e, t, n) {
            return e[t] = n, e;
          };
        },
        9114: function (e) {
          e.exports = function (e, t) {
            return {
              enumerable: !(1 & e),
              configurable: !(2 & e),
              writable: !(4 & e),
              value: t
            };
          };
        },
        9781: function (e, t, n) {
          var r = n(7293);
          e.exports = !r(function () {
            return 7 != Object.defineProperty({}, 1, {
              get: function () {
                return 7;
              }
            })[1];
          });
        },
        317: function (e, t, n) {
          var r = n(7854),
            o = n(111),
            i = r.document,
            a = o(i) && o(i.createElement);
          e.exports = function (e) {
            return a ? i.createElement(e) : {};
          };
        },
        8113: function (e, t, n) {
          var r = n(5005);
          e.exports = r("navigator", "userAgent") || "";
        },
        7392: function (e, t, n) {
          var r,
            o,
            i = n(7854),
            a = n(8113),
            u = i.process,
            s = u && u.versions,
            c = s && s.v8;
          c ? o = (r = c.split("."))[0] < 4 ? 1 : r[0] + r[1] : a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = r[1]), e.exports = o && +o;
        },
        748: function (e) {
          e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        },
        2109: function (e, t, n) {
          var r = n(7854),
            o = n(1236).f,
            i = n(8880),
            a = n(1320),
            u = n(3505),
            s = n(9920),
            c = n(4705);
          e.exports = function (e, t) {
            var n,
              f,
              l,
              p,
              h,
              d = e.target,
              v = e.global,
              g = e.stat;
            if (n = v ? r : g ? r[d] || u(d, {}) : (r[d] || {}).prototype) for (f in t) {
              if (p = t[f], l = e.noTargetGet ? (h = o(n, f)) && h.value : n[f], !c(v ? f : d + (g ? "." : "#") + f, e.forced) && void 0 !== l) {
                if (typeof p == typeof l) continue;
                s(p, l);
              }
              (e.sham || l && l.sham) && i(p, "sham", !0), a(n, f, p, e);
            }
          };
        },
        7293: function (e) {
          e.exports = function (e) {
            try {
              return !!e();
            } catch (e) {
              return !0;
            }
          };
        },
        7007: function (e, t, n) {
          "use strict";

          n(4916);
          var r = n(1320),
            o = n(2261),
            i = n(7293),
            a = n(5112),
            u = n(8880),
            s = a("species"),
            c = RegExp.prototype;
          e.exports = function (e, t, n, f) {
            var l = a(e),
              p = !i(function () {
                var t = {};
                return t[l] = function () {
                  return 7;
                }, 7 != ""[e](t);
              }),
              h = p && !i(function () {
                var t = !1,
                  n = /a/;
                return "split" === e && ((n = {}).constructor = {}, n.constructor[s] = function () {
                  return n;
                }, n.flags = "", n[l] = /./[l]), n.exec = function () {
                  return t = !0, null;
                }, n[l](""), !t;
              });
            if (!p || !h || n) {
              var d = /./[l],
                v = t(l, ""[e], function (e, t, n, r, i) {
                  var a = t.exec;
                  return a === o || a === c.exec ? p && !i ? {
                    done: !0,
                    value: d.call(t, n, r)
                  } : {
                    done: !0,
                    value: e.call(n, t, r)
                  } : {
                    done: !1
                  };
                });
              r(String.prototype, e, v[0]), r(c, l, v[1]);
            }
            f && u(c[l], "sham", !0);
          };
        },
        5005: function (e, t, n) {
          var r = n(857),
            o = n(7854),
            i = function (e) {
              return "function" == typeof e ? e : void 0;
            };
          e.exports = function (e, t) {
            return arguments.length < 2 ? i(r[e]) || i(o[e]) : r[e] && r[e][t] || o[e] && o[e][t];
          };
        },
        647: function (e, t, n) {
          var r = n(7908),
            o = Math.floor,
            i = "".replace,
            a = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
            u = /\$([$&'`]|\d{1,2})/g;
          e.exports = function (e, t, n, s, c, f) {
            var l = n + e.length,
              p = s.length,
              h = u;
            return void 0 !== c && (c = r(c), h = a), i.call(f, h, function (r, i) {
              var a;
              switch (i.charAt(0)) {
                case "$":
                  return "$";
                case "&":
                  return e;
                case "`":
                  return t.slice(0, n);
                case "'":
                  return t.slice(l);
                case "<":
                  a = c[i.slice(1, -1)];
                  break;
                default:
                  var u = +i;
                  if (0 === u) return r;
                  if (u > p) {
                    var f = o(u / 10);
                    return 0 === f ? r : f <= p ? void 0 === s[f - 1] ? i.charAt(1) : s[f - 1] + i.charAt(1) : r;
                  }
                  a = s[u - 1];
              }
              return void 0 === a ? "" : a;
            });
          };
        },
        7854: function (e, t, n) {
          var r = function (e) {
            return e && e.Math == Math && e;
          };
          e.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof n.g && n.g) || function () {
            return this;
          }() || Function("return this")();
        },
        6656: function (e, t, n) {
          var r = n(7908),
            o = {}.hasOwnProperty;
          e.exports = Object.hasOwn || function (e, t) {
            return o.call(r(e), t);
          };
        },
        3501: function (e) {
          e.exports = {};
        },
        490: function (e, t, n) {
          var r = n(5005);
          e.exports = r("document", "documentElement");
        },
        4664: function (e, t, n) {
          var r = n(9781),
            o = n(7293),
            i = n(317);
          e.exports = !r && !o(function () {
            return 7 != Object.defineProperty(i("div"), "a", {
              get: function () {
                return 7;
              }
            }).a;
          });
        },
        8361: function (e, t, n) {
          var r = n(7293),
            o = n(4326),
            i = "".split;
          e.exports = r(function () {
            return !Object("z").propertyIsEnumerable(0);
          }) ? function (e) {
            return "String" == o(e) ? i.call(e, "") : Object(e);
          } : Object;
        },
        2788: function (e, t, n) {
          var r = n(5465),
            o = Function.toString;
          "function" != typeof r.inspectSource && (r.inspectSource = function (e) {
            return o.call(e);
          }), e.exports = r.inspectSource;
        },
        9909: function (e, t, n) {
          var r,
            o,
            i,
            a = n(8536),
            u = n(7854),
            s = n(111),
            c = n(8880),
            f = n(6656),
            l = n(5465),
            p = n(6200),
            h = n(3501),
            d = "Object already initialized",
            v = u.WeakMap;
          if (a || l.state) {
            var g = l.state || (l.state = new v()),
              y = g.get,
              m = g.has,
              b = g.set;
            r = function (e, t) {
              if (m.call(g, e)) throw new TypeError(d);
              return t.facade = e, b.call(g, e, t), t;
            }, o = function (e) {
              return y.call(g, e) || {};
            }, i = function (e) {
              return m.call(g, e);
            };
          } else {
            var k = p("state");
            h[k] = !0, r = function (e, t) {
              if (f(e, k)) throw new TypeError(d);
              return t.facade = e, c(e, k, t), t;
            }, o = function (e) {
              return f(e, k) ? e[k] : {};
            }, i = function (e) {
              return f(e, k);
            };
          }
          e.exports = {
            set: r,
            get: o,
            has: i,
            enforce: function (e) {
              return i(e) ? o(e) : r(e, {});
            },
            getterFor: function (e) {
              return function (t) {
                var n;
                if (!s(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
                return n;
              };
            }
          };
        },
        4705: function (e, t, n) {
          var r = n(7293),
            o = /#|\.prototype\./,
            i = function (e, t) {
              var n = u[a(e)];
              return n == c || n != s && ("function" == typeof t ? r(t) : !!t);
            },
            a = i.normalize = function (e) {
              return String(e).replace(o, ".").toLowerCase();
            },
            u = i.data = {},
            s = i.NATIVE = "N",
            c = i.POLYFILL = "P";
          e.exports = i;
        },
        111: function (e) {
          e.exports = function (e) {
            return "object" == typeof e ? null !== e : "function" == typeof e;
          };
        },
        1913: function (e) {
          e.exports = !1;
        },
        133: function (e, t, n) {
          var r = n(7392),
            o = n(7293);
          e.exports = !!Object.getOwnPropertySymbols && !o(function () {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && r && r < 41;
          });
        },
        8536: function (e, t, n) {
          var r = n(7854),
            o = n(2788),
            i = r.WeakMap;
          e.exports = "function" == typeof i && /native code/.test(o(i));
        },
        30: function (e, t, n) {
          var r,
            o = n(9670),
            i = n(6048),
            a = n(748),
            u = n(3501),
            s = n(490),
            c = n(317),
            f = n(6200)("IE_PROTO"),
            l = function () {},
            p = function (e) {
              return "<script>" + e + "<\/script>";
            },
            h = function () {
              try {
                r = document.domain && new ActiveXObject("htmlfile");
              } catch (e) {}
              var e, t;
              h = r ? function (e) {
                e.write(p("")), e.close();
                var t = e.parentWindow.Object;
                return e = null, t;
              }(r) : ((t = c("iframe")).style.display = "none", s.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(p("document.F=Object")), e.close(), e.F);
              for (var n = a.length; n--;) delete h.prototype[a[n]];
              return h();
            };
          u[f] = !0, e.exports = Object.create || function (e, t) {
            var n;
            return null !== e ? (l.prototype = o(e), n = new l(), l.prototype = null, n[f] = e) : n = h(), void 0 === t ? n : i(n, t);
          };
        },
        6048: function (e, t, n) {
          var r = n(9781),
            o = n(3070),
            i = n(9670),
            a = n(1956);
          e.exports = r ? Object.defineProperties : function (e, t) {
            i(e);
            for (var n, r = a(t), u = r.length, s = 0; u > s;) o.f(e, n = r[s++], t[n]);
            return e;
          };
        },
        3070: function (e, t, n) {
          var r = n(9781),
            o = n(4664),
            i = n(9670),
            a = n(7593),
            u = Object.defineProperty;
          t.f = r ? u : function (e, t, n) {
            if (i(e), t = a(t, !0), i(n), o) try {
              return u(e, t, n);
            } catch (e) {}
            if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
            return "value" in n && (e[t] = n.value), e;
          };
        },
        1236: function (e, t, n) {
          var r = n(9781),
            o = n(5296),
            i = n(9114),
            a = n(5656),
            u = n(7593),
            s = n(6656),
            c = n(4664),
            f = Object.getOwnPropertyDescriptor;
          t.f = r ? f : function (e, t) {
            if (e = a(e), t = u(t, !0), c) try {
              return f(e, t);
            } catch (e) {}
            if (s(e, t)) return i(!o.f.call(e, t), e[t]);
          };
        },
        8006: function (e, t, n) {
          var r = n(6324),
            o = n(748).concat("length", "prototype");
          t.f = Object.getOwnPropertyNames || function (e) {
            return r(e, o);
          };
        },
        5181: function (e, t) {
          t.f = Object.getOwnPropertySymbols;
        },
        6324: function (e, t, n) {
          var r = n(6656),
            o = n(5656),
            i = n(1318).indexOf,
            a = n(3501);
          e.exports = function (e, t) {
            var n,
              u = o(e),
              s = 0,
              c = [];
            for (n in u) !r(a, n) && r(u, n) && c.push(n);
            for (; t.length > s;) r(u, n = t[s++]) && (~i(c, n) || c.push(n));
            return c;
          };
        },
        1956: function (e, t, n) {
          var r = n(6324),
            o = n(748);
          e.exports = Object.keys || function (e) {
            return r(e, o);
          };
        },
        5296: function (e, t) {
          "use strict";

          var n = {}.propertyIsEnumerable,
            r = Object.getOwnPropertyDescriptor,
            o = r && !n.call({
              1: 2
            }, 1);
          t.f = o ? function (e) {
            var t = r(this, e);
            return !!t && t.enumerable;
          } : n;
        },
        288: function (e, t, n) {
          "use strict";

          var r = n(1694),
            o = n(648);
          e.exports = r ? {}.toString : function () {
            return "[object " + o(this) + "]";
          };
        },
        3887: function (e, t, n) {
          var r = n(5005),
            o = n(8006),
            i = n(5181),
            a = n(9670);
          e.exports = r("Reflect", "ownKeys") || function (e) {
            var t = o.f(a(e)),
              n = i.f;
            return n ? t.concat(n(e)) : t;
          };
        },
        857: function (e, t, n) {
          var r = n(7854);
          e.exports = r;
        },
        1320: function (e, t, n) {
          var r = n(7854),
            o = n(8880),
            i = n(6656),
            a = n(3505),
            u = n(2788),
            s = n(9909),
            c = s.get,
            f = s.enforce,
            l = String(String).split("String");
          (e.exports = function (e, t, n, u) {
            var s,
              c = !!u && !!u.unsafe,
              p = !!u && !!u.enumerable,
              h = !!u && !!u.noTargetGet;
            "function" == typeof n && ("string" != typeof t || i(n, "name") || o(n, "name", t), (s = f(n)).source || (s.source = l.join("string" == typeof t ? t : ""))), e !== r ? (c ? !h && e[t] && (p = !0) : delete e[t], p ? e[t] = n : o(e, t, n)) : p ? e[t] = n : a(t, n);
          })(Function.prototype, "toString", function () {
            return "function" == typeof this && c(this).source || u(this);
          });
        },
        7651: function (e, t, n) {
          var r = n(4326),
            o = n(2261);
          e.exports = function (e, t) {
            var n = e.exec;
            if ("function" == typeof n) {
              var i = n.call(e, t);
              if ("object" != typeof i) throw TypeError("RegExp exec method returned something other than an Object or null");
              return i;
            }
            if ("RegExp" !== r(e)) throw TypeError("RegExp#exec called on incompatible receiver");
            return o.call(e, t);
          };
        },
        2261: function (e, t, n) {
          "use strict";

          var r,
            o,
            i = n(7066),
            a = n(2999),
            u = n(2309),
            s = n(30),
            c = n(9909).get,
            f = n(9441),
            l = n(8173),
            p = RegExp.prototype.exec,
            h = u("native-string-replace", String.prototype.replace),
            d = p,
            v = (r = /a/, o = /b*/g, p.call(r, "a"), p.call(o, "a"), 0 !== r.lastIndex || 0 !== o.lastIndex),
            g = a.UNSUPPORTED_Y || a.BROKEN_CARET,
            y = void 0 !== /()??/.exec("")[1];
          (v || y || g || f || l) && (d = function (e) {
            var t,
              n,
              r,
              o,
              a,
              u,
              f,
              l = this,
              m = c(l),
              b = m.raw;
            if (b) return b.lastIndex = l.lastIndex, t = d.call(b, e), l.lastIndex = b.lastIndex, t;
            var k = m.groups,
              w = g && l.sticky,
              x = i.call(l),
              S = l.source,
              T = 0,
              O = e;
            if (w && (-1 === (x = x.replace("y", "")).indexOf("g") && (x += "g"), O = String(e).slice(l.lastIndex), l.lastIndex > 0 && (!l.multiline || l.multiline && "\n" !== e[l.lastIndex - 1]) && (S = "(?: " + S + ")", O = " " + O, T++), n = new RegExp("^(?:" + S + ")", x)), y && (n = new RegExp("^" + S + "$(?!\\s)", x)), v && (r = l.lastIndex), o = p.call(w ? n : l, O), w ? o ? (o.input = o.input.slice(T), o[0] = o[0].slice(T), o.index = l.lastIndex, l.lastIndex += o[0].length) : l.lastIndex = 0 : v && o && (l.lastIndex = l.global ? o.index + o[0].length : r), y && o && o.length > 1 && h.call(o[0], n, function () {
              for (a = 1; a < arguments.length - 2; a++) void 0 === arguments[a] && (o[a] = void 0);
            }), o && k) for (o.groups = u = s(null), a = 0; a < k.length; a++) u[(f = k[a])[0]] = o[f[1]];
            return o;
          }), e.exports = d;
        },
        7066: function (e, t, n) {
          "use strict";

          var r = n(9670);
          e.exports = function () {
            var e = r(this),
              t = "";
            return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
          };
        },
        2999: function (e, t, n) {
          var r = n(7293),
            o = function (e, t) {
              return RegExp(e, t);
            };
          t.UNSUPPORTED_Y = r(function () {
            var e = o("a", "y");
            return e.lastIndex = 2, null != e.exec("abcd");
          }), t.BROKEN_CARET = r(function () {
            var e = o("^r", "gy");
            return e.lastIndex = 2, null != e.exec("str");
          });
        },
        9441: function (e, t, n) {
          var r = n(7293);
          e.exports = r(function () {
            var e = RegExp(".", "string".charAt(0));
            return !(e.dotAll && e.exec("\n") && "s" === e.flags);
          });
        },
        8173: function (e, t, n) {
          var r = n(7293);
          e.exports = r(function () {
            var e = RegExp("(?<a>b)", "string".charAt(5));
            return "b" !== e.exec("b").groups.a || "bc" !== "b".replace(e, "$<a>c");
          });
        },
        4488: function (e) {
          e.exports = function (e) {
            if (null == e) throw TypeError("Can't call method on " + e);
            return e;
          };
        },
        3505: function (e, t, n) {
          var r = n(7854),
            o = n(8880);
          e.exports = function (e, t) {
            try {
              o(r, e, t);
            } catch (n) {
              r[e] = t;
            }
            return t;
          };
        },
        6200: function (e, t, n) {
          var r = n(2309),
            o = n(9711),
            i = r("keys");
          e.exports = function (e) {
            return i[e] || (i[e] = o(e));
          };
        },
        5465: function (e, t, n) {
          var r = n(7854),
            o = n(3505),
            i = "__core-js_shared__",
            a = r[i] || o(i, {});
          e.exports = a;
        },
        2309: function (e, t, n) {
          var r = n(1913),
            o = n(5465);
          (e.exports = function (e, t) {
            return o[e] || (o[e] = void 0 !== t ? t : {});
          })("versions", []).push({
            version: "3.15.1",
            mode: r ? "pure" : "global",
            copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
          });
        },
        8710: function (e, t, n) {
          var r = n(9958),
            o = n(4488),
            i = function (e) {
              return function (t, n) {
                var i,
                  a,
                  u = String(o(t)),
                  s = r(n),
                  c = u.length;
                return s < 0 || s >= c ? e ? "" : void 0 : (i = u.charCodeAt(s)) < 55296 || i > 56319 || s + 1 === c || (a = u.charCodeAt(s + 1)) < 56320 || a > 57343 ? e ? u.charAt(s) : i : e ? u.slice(s, s + 2) : a - 56320 + (i - 55296 << 10) + 65536;
              };
            };
          e.exports = {
            codeAt: i(!1),
            charAt: i(!0)
          };
        },
        1400: function (e, t, n) {
          var r = n(9958),
            o = Math.max,
            i = Math.min;
          e.exports = function (e, t) {
            var n = r(e);
            return n < 0 ? o(n + t, 0) : i(n, t);
          };
        },
        5656: function (e, t, n) {
          var r = n(8361),
            o = n(4488);
          e.exports = function (e) {
            return r(o(e));
          };
        },
        9958: function (e) {
          var t = Math.ceil,
            n = Math.floor;
          e.exports = function (e) {
            return isNaN(e = +e) ? 0 : (e > 0 ? n : t)(e);
          };
        },
        7466: function (e, t, n) {
          var r = n(9958),
            o = Math.min;
          e.exports = function (e) {
            return e > 0 ? o(r(e), 9007199254740991) : 0;
          };
        },
        7908: function (e, t, n) {
          var r = n(4488);
          e.exports = function (e) {
            return Object(r(e));
          };
        },
        7593: function (e, t, n) {
          var r = n(111);
          e.exports = function (e, t) {
            if (!r(e)) return e;
            var n, o;
            if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
            if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
            if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
            throw TypeError("Can't convert object to primitive value");
          };
        },
        1694: function (e, t, n) {
          var r = {};
          r[n(5112)("toStringTag")] = "z", e.exports = "[object z]" === String(r);
        },
        9711: function (e) {
          var t = 0,
            n = Math.random();
          e.exports = function (e) {
            return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++t + n).toString(36);
          };
        },
        3307: function (e, t, n) {
          var r = n(133);
          e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
        },
        5112: function (e, t, n) {
          var r = n(7854),
            o = n(2309),
            i = n(6656),
            a = n(9711),
            u = n(133),
            s = n(3307),
            c = o("wks"),
            f = r.Symbol,
            l = s ? f : f && f.withoutSetter || a;
          e.exports = function (e) {
            return i(c, e) && (u || "string" == typeof c[e]) || (u && i(f, e) ? c[e] = f[e] : c[e] = l("Symbol." + e)), c[e];
          };
        },
        9600: function (e, t, n) {
          "use strict";

          var r = n(2109),
            o = n(8361),
            i = n(5656),
            a = n(9341),
            u = [].join,
            s = o != Object,
            c = a("join", ",");
          r({
            target: "Array",
            proto: !0,
            forced: s || !c
          }, {
            join: function (e) {
              return u.call(i(this), void 0 === e ? "," : e);
            }
          });
        },
        8309: function (e, t, n) {
          var r = n(9781),
            o = n(3070).f,
            i = Function.prototype,
            a = i.toString,
            u = /^\s*function ([^ (]*)/,
            s = "name";
          r && !(s in i) && o(i, s, {
            configurable: !0,
            get: function () {
              try {
                return a.call(this).match(u)[1];
              } catch (e) {
                return "";
              }
            }
          });
        },
        1539: function (e, t, n) {
          var r = n(1694),
            o = n(1320),
            i = n(288);
          r || o(Object.prototype, "toString", i, {
            unsafe: !0
          });
        },
        4916: function (e, t, n) {
          "use strict";

          var r = n(2109),
            o = n(2261);
          r({
            target: "RegExp",
            proto: !0,
            forced: /./.exec !== o
          }, {
            exec: o
          });
        },
        5306: function (e, t, n) {
          "use strict";

          var r = n(7007),
            o = n(7293),
            i = n(9670),
            a = n(7466),
            u = n(9958),
            s = n(4488),
            c = n(1530),
            f = n(647),
            l = n(7651),
            p = n(5112)("replace"),
            h = Math.max,
            d = Math.min,
            v = "$0" === "a".replace(/./, "$0"),
            g = !!/./[p] && "" === /./[p]("a", "$0");
          r("replace", function (e, t, n) {
            var r = g ? "$" : "$0";
            return [function (e, n) {
              var r = s(this),
                o = null == e ? void 0 : e[p];
              return void 0 !== o ? o.call(e, r, n) : t.call(String(r), e, n);
            }, function (e, o) {
              if ("string" == typeof o && -1 === o.indexOf(r) && -1 === o.indexOf("$<")) {
                var s = n(t, this, e, o);
                if (s.done) return s.value;
              }
              var p = i(this),
                v = String(e),
                g = "function" == typeof o;
              g || (o = String(o));
              var y = p.global;
              if (y) {
                var m = p.unicode;
                p.lastIndex = 0;
              }
              for (var b = [];;) {
                var k = l(p, v);
                if (null === k) break;
                if (b.push(k), !y) break;
                "" === String(k[0]) && (p.lastIndex = c(v, a(p.lastIndex), m));
              }
              for (var w, x = "", S = 0, T = 0; T < b.length; T++) {
                k = b[T];
                for (var O = String(k[0]), A = h(d(u(k.index), v.length), 0), E = [], _ = 1; _ < k.length; _++) E.push(void 0 === (w = k[_]) ? w : String(w));
                var R = k.groups;
                if (g) {
                  var P = [O].concat(E, A, v);
                  void 0 !== R && P.push(R);
                  var j = String(o.apply(void 0, P));
                } else j = f(O, v, A, E, R, o);
                A >= S && (x += v.slice(S, A) + j, S = A + O.length);
              }
              return x + v.slice(S);
            }];
          }, !!o(function () {
            var e = /./;
            return e.exec = function () {
              var e = [];
              return e.groups = {
                a: "7"
              }, e;
            }, "7" !== "".replace(e, "$<a>");
          }) || !v || g);
        },
        4098: function (e, t) {
          var n = "undefined" != typeof self ? self : this,
            r = function () {
              function e() {
                this.fetch = !1, this.DOMException = n.DOMException;
              }
              return e.prototype = n, new e();
            }();
          !function (e) {
            !function (t) {
              var n = ("URLSearchParams" in e),
                r = "Symbol" in e && "iterator" in Symbol,
                o = "FileReader" in e && "Blob" in e && function () {
                  try {
                    return new Blob(), !0;
                  } catch (e) {
                    return !1;
                  }
                }(),
                i = ("FormData" in e),
                a = ("ArrayBuffer" in e);
              if (a) var u = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
                s = ArrayBuffer.isView || function (e) {
                  return e && u.indexOf(Object.prototype.toString.call(e)) > -1;
                };
              function c(e) {
                if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
                return e.toLowerCase();
              }
              function f(e) {
                return "string" != typeof e && (e = String(e)), e;
              }
              function l(e) {
                var t = {
                  next: function () {
                    var t = e.shift();
                    return {
                      done: void 0 === t,
                      value: t
                    };
                  }
                };
                return r && (t[Symbol.iterator] = function () {
                  return t;
                }), t;
              }
              function p(e) {
                this.map = {}, e instanceof p ? e.forEach(function (e, t) {
                  this.append(t, e);
                }, this) : Array.isArray(e) ? e.forEach(function (e) {
                  this.append(e[0], e[1]);
                }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
                  this.append(t, e[t]);
                }, this);
              }
              function h(e) {
                if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
                e.bodyUsed = !0;
              }
              function d(e) {
                return new Promise(function (t, n) {
                  e.onload = function () {
                    t(e.result);
                  }, e.onerror = function () {
                    n(e.error);
                  };
                });
              }
              function v(e) {
                var t = new FileReader(),
                  n = d(t);
                return t.readAsArrayBuffer(e), n;
              }
              function g(e) {
                if (e.slice) return e.slice(0);
                var t = new Uint8Array(e.byteLength);
                return t.set(new Uint8Array(e)), t.buffer;
              }
              function y() {
                return this.bodyUsed = !1, this._initBody = function (e) {
                  var t;
                  this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : o && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : i && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : a && o && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = g(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a && (ArrayBuffer.prototype.isPrototypeOf(e) || s(e)) ? this._bodyArrayBuffer = g(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                }, o && (this.blob = function () {
                  var e = h(this);
                  if (e) return e;
                  if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                  if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                  if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                  return Promise.resolve(new Blob([this._bodyText]));
                }, this.arrayBuffer = function () {
                  return this._bodyArrayBuffer ? h(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(v);
                }), this.text = function () {
                  var e,
                    t,
                    n,
                    r = h(this);
                  if (r) return r;
                  if (this._bodyBlob) return e = this._bodyBlob, n = d(t = new FileReader()), t.readAsText(e), n;
                  if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
                    for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) n[r] = String.fromCharCode(t[r]);
                    return n.join("");
                  }(this._bodyArrayBuffer));
                  if (this._bodyFormData) throw new Error("could not read FormData body as text");
                  return Promise.resolve(this._bodyText);
                }, i && (this.formData = function () {
                  return this.text().then(k);
                }), this.json = function () {
                  return this.text().then(JSON.parse);
                }, this;
              }
              p.prototype.append = function (e, t) {
                e = c(e), t = f(t);
                var n = this.map[e];
                this.map[e] = n ? n + ", " + t : t;
              }, p.prototype.delete = function (e) {
                delete this.map[c(e)];
              }, p.prototype.get = function (e) {
                return e = c(e), this.has(e) ? this.map[e] : null;
              }, p.prototype.has = function (e) {
                return this.map.hasOwnProperty(c(e));
              }, p.prototype.set = function (e, t) {
                this.map[c(e)] = f(t);
              }, p.prototype.forEach = function (e, t) {
                for (var n in this.map) this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
              }, p.prototype.keys = function () {
                var e = [];
                return this.forEach(function (t, n) {
                  e.push(n);
                }), l(e);
              }, p.prototype.values = function () {
                var e = [];
                return this.forEach(function (t) {
                  e.push(t);
                }), l(e);
              }, p.prototype.entries = function () {
                var e = [];
                return this.forEach(function (t, n) {
                  e.push([n, t]);
                }), l(e);
              }, r && (p.prototype[Symbol.iterator] = p.prototype.entries);
              var m = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
              function b(e, t) {
                var n,
                  r,
                  o = (t = t || {}).body;
                if (e instanceof b) {
                  if (e.bodyUsed) throw new TypeError("Already read");
                  this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new p(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
                } else this.url = String(e);
                if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new p(t.headers)), this.method = (r = (n = t.method || this.method || "GET").toUpperCase(), m.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                this._initBody(o);
              }
              function k(e) {
                var t = new FormData();
                return e.trim().split("&").forEach(function (e) {
                  if (e) {
                    var n = e.split("="),
                      r = n.shift().replace(/\+/g, " "),
                      o = n.join("=").replace(/\+/g, " ");
                    t.append(decodeURIComponent(r), decodeURIComponent(o));
                  }
                }), t;
              }
              function w(e, t) {
                t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new p(t.headers), this.url = t.url || "", this._initBody(e);
              }
              b.prototype.clone = function () {
                return new b(this, {
                  body: this._bodyInit
                });
              }, y.call(b.prototype), y.call(w.prototype), w.prototype.clone = function () {
                return new w(this._bodyInit, {
                  status: this.status,
                  statusText: this.statusText,
                  headers: new p(this.headers),
                  url: this.url
                });
              }, w.error = function () {
                var e = new w(null, {
                  status: 0,
                  statusText: ""
                });
                return e.type = "error", e;
              };
              var x = [301, 302, 303, 307, 308];
              w.redirect = function (e, t) {
                if (-1 === x.indexOf(t)) throw new RangeError("Invalid status code");
                return new w(null, {
                  status: t,
                  headers: {
                    location: e
                  }
                });
              }, t.DOMException = e.DOMException;
              try {
                new t.DOMException();
              } catch (e) {
                t.DOMException = function (e, t) {
                  this.message = e, this.name = t;
                  var n = Error(e);
                  this.stack = n.stack;
                }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
              }
              function S(e, n) {
                return new Promise(function (r, i) {
                  var a = new b(e, n);
                  if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
                  var u = new XMLHttpRequest();
                  function s() {
                    u.abort();
                  }
                  u.onload = function () {
                    var e,
                      t,
                      n = {
                        status: u.status,
                        statusText: u.statusText,
                        headers: (e = u.getAllResponseHeaders() || "", t = new p(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                          var n = e.split(":"),
                            r = n.shift().trim();
                          if (r) {
                            var o = n.join(":").trim();
                            t.append(r, o);
                          }
                        }), t)
                      };
                    n.url = "responseURL" in u ? u.responseURL : n.headers.get("X-Request-URL");
                    var o = "response" in u ? u.response : u.responseText;
                    r(new w(o, n));
                  }, u.onerror = function () {
                    i(new TypeError("Network request failed"));
                  }, u.ontimeout = function () {
                    i(new TypeError("Network request failed"));
                  }, u.onabort = function () {
                    i(new t.DOMException("Aborted", "AbortError"));
                  }, u.open(a.method, a.url, !0), "include" === a.credentials ? u.withCredentials = !0 : "omit" === a.credentials && (u.withCredentials = !1), "responseType" in u && o && (u.responseType = "blob"), a.headers.forEach(function (e, t) {
                    u.setRequestHeader(t, e);
                  }), a.signal && (a.signal.addEventListener("abort", s), u.onreadystatechange = function () {
                    4 === u.readyState && a.signal.removeEventListener("abort", s);
                  }), u.send(void 0 === a._bodyInit ? null : a._bodyInit);
                });
              }
              S.polyfill = !0, e.fetch || (e.fetch = S, e.Headers = p, e.Request = b, e.Response = w), t.Headers = p, t.Request = b, t.Response = w, t.fetch = S, Object.defineProperty(t, "__esModule", {
                value: !0
              });
            }({});
          }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
          var o = r;
          (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e.exports = t;
        },
        6808: function (e, t, n) {
          var r, o, i;
          i = function () {
            function e() {
              for (var e = 0, t = {}; e < arguments.length; e++) {
                var n = arguments[e];
                for (var r in n) t[r] = n[r];
              }
              return t;
            }
            function t(e) {
              return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
            }
            return function n(r) {
              function o() {}
              function i(t, n, i) {
                if ("undefined" != typeof document) {
                  "number" == typeof (i = e({
                    path: "/"
                  }, o.defaults, i)).expires && (i.expires = new Date(1 * new Date() + 864e5 * i.expires)), i.expires = i.expires ? i.expires.toUTCString() : "";
                  try {
                    var a = JSON.stringify(n);
                    /^[\{\[]/.test(a) && (n = a);
                  } catch (e) {}
                  n = r.write ? r.write(n, t) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                  var u = "";
                  for (var s in i) i[s] && (u += "; " + s, !0 !== i[s] && (u += "=" + i[s].split(";")[0]));
                  return document.cookie = t + "=" + n + u;
                }
              }
              function a(e, n) {
                if ("undefined" != typeof document) {
                  for (var o = {}, i = document.cookie ? document.cookie.split("; ") : [], a = 0; a < i.length; a++) {
                    var u = i[a].split("="),
                      s = u.slice(1).join("=");
                    n || '"' !== s.charAt(0) || (s = s.slice(1, -1));
                    try {
                      var c = t(u[0]);
                      if (s = (r.read || r)(s, c) || t(s), n) try {
                        s = JSON.parse(s);
                      } catch (e) {}
                      if (o[c] = s, e === c) break;
                    } catch (e) {}
                  }
                  return e ? o[e] : o;
                }
              }
              return o.set = i, o.get = function (e) {
                return a(e, !1);
              }, o.getJSON = function (e) {
                return a(e, !0);
              }, o.remove = function (t, n) {
                i(t, "", e(n, {
                  expires: -1
                }));
              }, o.defaults = {}, o.withConverter = n, o;
            }(function () {});
          }, void 0 === (o = "function" == typeof (r = i) ? r.call(t, n, t, e) : r) || (e.exports = o), e.exports = i();
        },
        5653: function (e, t, n) {
          "use strict";

          function r(e) {
            return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
              return typeof e;
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, r(e);
          }
          function o(e) {
            return o = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }, o(e);
          }
          function i(e, t) {
            return i = Object.setPrototypeOf || function (e, t) {
              return e.__proto__ = t, e;
            }, i(e, t);
          }
          function a() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }
          function u(e, t, n) {
            return u = a() ? Reflect.construct : function (e, t, n) {
              var r = [null];
              r.push.apply(r, t);
              var o = new (Function.bind.apply(e, r))();
              return n && i(o, n.prototype), o;
            }, u.apply(null, arguments);
          }
          function s(e) {
            var t = "function" == typeof Map ? new Map() : void 0;
            return s = function (e) {
              if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
              var n;
              if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
              if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, r);
              }
              function r() {
                return u(e, arguments, o(this).constructor);
              }
              return r.prototype = Object.create(e.prototype, {
                constructor: {
                  value: r,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), i(r, e);
            }, s(e);
          }
          function c(e, t) {
            return !t || "object" != typeof t && "function" != typeof t ? function (e) {
              if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return e;
            }(e) : t;
          }
          function f(e) {
            return function (e) {
              if (Array.isArray(e)) return p(e);
            }(e) || function (e) {
              if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || l(e) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function l(e, t) {
            if (e) {
              if ("string" == typeof e) return p(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e, t) : void 0;
            }
          }
          function p(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          n.r(t), n.d(t, {
            JSONPath: function () {
              return y;
            }
          });
          var h = Object.prototype.hasOwnProperty;
          function d(e, t) {
            return (e = e.slice()).push(t), e;
          }
          function v(e, t) {
            return (t = t.slice()).unshift(e), t;
          }
          var g = function (e) {
            !function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }), t && i(e, t);
            }(u, e);
            var t,
              n,
              r = (t = u, n = a(), function () {
                var e,
                  r = o(t);
                if (n) {
                  var i = o(this).constructor;
                  e = Reflect.construct(r, arguments, i);
                } else e = r.apply(this, arguments);
                return c(this, e);
              });
            function u(e) {
              var t;
              return function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, u), (t = r.call(this, 'JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)')).avoidNew = !0, t.value = e, t.name = "NewError", t;
            }
            return u;
          }(s(Error));
          function y(e, t, n, o, i) {
            if (!(this instanceof y)) try {
              return new y(e, t, n, o, i);
            } catch (e) {
              if (!e.avoidNew) throw e;
              return e.value;
            }
            "string" == typeof e && (i = o, o = n, n = t, t = e, e = null);
            var a = e && "object" === r(e);
            if (e = e || {}, this.json = e.json || n, this.path = e.path || t, this.resultType = e.resultType || "value", this.flatten = e.flatten || !1, this.wrap = !h.call(e, "wrap") || e.wrap, this.sandbox = e.sandbox || {}, this.preventEval = e.preventEval || !1, this.parent = e.parent || null, this.parentProperty = e.parentProperty || null, this.callback = e.callback || o || null, this.otherTypeCallback = e.otherTypeCallback || i || function () {
              throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
            }, !1 !== e.autostart) {
              var u = {
                path: a ? e.path : t
              };
              a ? "json" in e && (u.json = e.json) : u.json = n;
              var s = this.evaluate(u);
              if (!s || "object" !== r(s)) throw new g(s);
              return s;
            }
          }
          y.prototype.evaluate = function (e, t, n, o) {
            var i = this,
              a = this.parent,
              u = this.parentProperty,
              s = this.flatten,
              c = this.wrap;
            if (this.currResultType = this.resultType, this.currPreventEval = this.preventEval, this.currSandbox = this.sandbox, n = n || this.callback, this.currOtherTypeCallback = o || this.otherTypeCallback, t = t || this.json, (e = e || this.path) && "object" === r(e) && !Array.isArray(e)) {
              if (!e.path && "" !== e.path) throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');
              if (!h.call(e, "json")) throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');
              t = e.json, s = h.call(e, "flatten") ? e.flatten : s, this.currResultType = h.call(e, "resultType") ? e.resultType : this.currResultType, this.currSandbox = h.call(e, "sandbox") ? e.sandbox : this.currSandbox, c = h.call(e, "wrap") ? e.wrap : c, this.currPreventEval = h.call(e, "preventEval") ? e.preventEval : this.currPreventEval, n = h.call(e, "callback") ? e.callback : n, this.currOtherTypeCallback = h.call(e, "otherTypeCallback") ? e.otherTypeCallback : this.currOtherTypeCallback, a = h.call(e, "parent") ? e.parent : a, u = h.call(e, "parentProperty") ? e.parentProperty : u, e = e.path;
            }
            if (a = a || null, u = u || null, Array.isArray(e) && (e = y.toPathString(e)), (e || "" === e) && t) {
              var f = y.toPathArray(e);
              "$" === f[0] && f.length > 1 && f.shift(), this._hasParentSelector = null;
              var l = this._trace(f, t, ["$"], a, u, n).filter(function (e) {
                return e && !e.isParentSelector;
              });
              return l.length ? c || 1 !== l.length || l[0].hasArrExpr ? l.reduce(function (e, t) {
                var n = i._getPreferredOutput(t);
                return s && Array.isArray(n) ? e = e.concat(n) : e.push(n), e;
              }, []) : this._getPreferredOutput(l[0]) : c ? [] : void 0;
            }
          }, y.prototype._getPreferredOutput = function (e) {
            var t = this.currResultType;
            switch (t) {
              case "all":
                var n = Array.isArray(e.path) ? e.path : y.toPathArray(e.path);
                return e.pointer = y.toPointer(n), e.path = "string" == typeof e.path ? e.path : y.toPathString(e.path), e;
              case "value":
              case "parent":
              case "parentProperty":
                return e[t];
              case "path":
                return y.toPathString(e[t]);
              case "pointer":
                return y.toPointer(e.path);
              default:
                throw new TypeError("Unknown result type");
            }
          }, y.prototype._handleCallback = function (e, t, n) {
            if (t) {
              var r = this._getPreferredOutput(e);
              e.path = "string" == typeof e.path ? e.path : y.toPathString(e.path), t(r, n, e);
            }
          }, y.prototype._trace = function (e, t, n, o, i, a, u, s) {
            var c,
              f = this;
            if (!e.length) return c = {
              path: n,
              value: t,
              parent: o,
              parentProperty: i,
              hasArrExpr: u
            }, this._handleCallback(c, a, "value"), c;
            var p = e[0],
              g = e.slice(1),
              y = [];
            function m(e) {
              Array.isArray(e) ? e.forEach(function (e) {
                y.push(e);
              }) : y.push(e);
            }
            if (("string" != typeof p || s) && t && h.call(t, p)) m(this._trace(g, t[p], d(n, p), t, p, a, u));else if ("*" === p) this._walk(p, g, t, n, o, i, a, function (e, t, n, r, o, i, a, u) {
              m(f._trace(v(e, n), r, o, i, a, u, !0, !0));
            });else if (".." === p) m(this._trace(g, t, n, o, i, a, u)), this._walk(p, g, t, n, o, i, a, function (e, t, n, o, i, a, u, s) {
              "object" === r(o[e]) && m(f._trace(v(t, n), o[e], d(i, e), o, e, s, !0));
            });else {
              if ("^" === p) return this._hasParentSelector = !0, {
                path: n.slice(0, -1),
                expr: g,
                isParentSelector: !0
              };
              if ("~" === p) return c = {
                path: d(n, p),
                value: i,
                parent: o,
                parentProperty: null
              }, this._handleCallback(c, a, "property"), c;
              if ("$" === p) m(this._trace(g, t, n, null, null, a, u));else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(p)) m(this._slice(p, g, t, n, o, i, a));else if (0 === p.indexOf("?(")) {
                if (this.currPreventEval) throw new Error("Eval [?(expr)] prevented in JSONPath expression.");
                this._walk(p, g, t, n, o, i, a, function (e, t, n, r, o, i, a, u) {
                  f._eval(t.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, "$1"), r[e], e, o, i, a) && m(f._trace(v(e, n), r, o, i, a, u, !0));
                });
              } else if ("(" === p[0]) {
                if (this.currPreventEval) throw new Error("Eval [(expr)] prevented in JSONPath expression.");
                m(this._trace(v(this._eval(p, t, n[n.length - 1], n.slice(0, -1), o, i), g), t, n, o, i, a, u));
              } else if ("@" === p[0]) {
                var b = !1,
                  k = p.slice(1, -2);
                switch (k) {
                  case "scalar":
                    t && ["object", "function"].includes(r(t)) || (b = !0);
                    break;
                  case "boolean":
                  case "string":
                  case "undefined":
                  case "function":
                    r(t) === k && (b = !0);
                    break;
                  case "integer":
                    !Number.isFinite(t) || t % 1 || (b = !0);
                    break;
                  case "number":
                    Number.isFinite(t) && (b = !0);
                    break;
                  case "nonFinite":
                    "number" != typeof t || Number.isFinite(t) || (b = !0);
                    break;
                  case "object":
                    t && r(t) === k && (b = !0);
                    break;
                  case "array":
                    Array.isArray(t) && (b = !0);
                    break;
                  case "other":
                    b = this.currOtherTypeCallback(t, n, o, i);
                    break;
                  case "null":
                    null === t && (b = !0);
                    break;
                  default:
                    throw new TypeError("Unknown value type " + k);
                }
                if (b) return c = {
                  path: n,
                  value: t,
                  parent: o,
                  parentProperty: i
                }, this._handleCallback(c, a, "value"), c;
              } else if ("`" === p[0] && t && h.call(t, p.slice(1))) {
                var w = p.slice(1);
                m(this._trace(g, t[w], d(n, w), t, w, a, u, !0));
              } else if (p.includes(",")) {
                var x,
                  S = function (e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                      if (Array.isArray(e) || (n = l(e))) {
                        n && (e = n);
                        var r = 0,
                          o = function () {};
                        return {
                          s: o,
                          n: function () {
                            return r >= e.length ? {
                              done: !0
                            } : {
                              done: !1,
                              value: e[r++]
                            };
                          },
                          e: function (e) {
                            throw e;
                          },
                          f: o
                        };
                      }
                      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i,
                      a = !0,
                      u = !1;
                    return {
                      s: function () {
                        n = n.call(e);
                      },
                      n: function () {
                        var e = n.next();
                        return a = e.done, e;
                      },
                      e: function (e) {
                        u = !0, i = e;
                      },
                      f: function () {
                        try {
                          a || null == n.return || n.return();
                        } finally {
                          if (u) throw i;
                        }
                      }
                    };
                  }(p.split(","));
                try {
                  for (S.s(); !(x = S.n()).done;) {
                    var T = x.value;
                    m(this._trace(v(T, g), t, n, o, i, a, !0));
                  }
                } catch (e) {
                  S.e(e);
                } finally {
                  S.f();
                }
              } else !s && t && h.call(t, p) && m(this._trace(g, t[p], d(n, p), t, p, a, u, !0));
            }
            if (this._hasParentSelector) for (var O = 0; O < y.length; O++) {
              var A = y[O];
              if (A && A.isParentSelector) {
                var E = this._trace(A.expr, t, A.path, o, i, a, u);
                if (Array.isArray(E)) {
                  y[O] = E[0];
                  for (var _ = E.length, R = 1; R < _; R++) O++, y.splice(O, 0, E[R]);
                } else y[O] = E;
              }
            }
            return y;
          }, y.prototype._walk = function (e, t, n, o, i, a, u, s) {
            if (Array.isArray(n)) for (var c = n.length, f = 0; f < c; f++) s(f, e, t, n, o, i, a, u);else n && "object" === r(n) && Object.keys(n).forEach(function (r) {
              s(r, e, t, n, o, i, a, u);
            });
          }, y.prototype._slice = function (e, t, n, r, o, i, a) {
            if (Array.isArray(n)) {
              var u = n.length,
                s = e.split(":"),
                c = s[2] && Number.parseInt(s[2]) || 1,
                f = s[0] && Number.parseInt(s[0]) || 0,
                l = s[1] && Number.parseInt(s[1]) || u;
              f = f < 0 ? Math.max(0, f + u) : Math.min(u, f), l = l < 0 ? Math.max(0, l + u) : Math.min(u, l);
              for (var p = [], h = f; h < l; h += c) this._trace(v(h, t), n, r, o, i, a, !0).forEach(function (e) {
                p.push(e);
              });
              return p;
            }
          }, y.prototype._eval = function (e, t, n, r, o, i) {
            e.includes("@parentProperty") && (this.currSandbox._$_parentProperty = i, e = e.replace(/@parentProperty/g, "_$_parentProperty")), e.includes("@parent") && (this.currSandbox._$_parent = o, e = e.replace(/@parent/g, "_$_parent")), e.includes("@property") && (this.currSandbox._$_property = n, e = e.replace(/@property/g, "_$_property")), e.includes("@path") && (this.currSandbox._$_path = y.toPathString(r.concat([n])), e = e.replace(/@path/g, "_$_path")), e.includes("@root") && (this.currSandbox._$_root = this.json, e = e.replace(/@root/g, "_$_root")), /@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(e) && (this.currSandbox._$_v = t, e = e.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, "_$_v$1"));
            try {
              return this.vm.runInNewContext(e, this.currSandbox);
            } catch (t) {
              throw console.log(t), new Error("jsonPath: " + t.message + ": " + e);
            }
          }, y.cache = {}, y.toPathString = function (e) {
            for (var t = e, n = t.length, r = "$", o = 1; o < n; o++) /^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o]) || (r += /^[\*0-9]+$/.test(t[o]) ? "[" + t[o] + "]" : "['" + t[o] + "']");
            return r;
          }, y.toPointer = function (e) {
            for (var t = e, n = t.length, r = "", o = 1; o < n; o++) /^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o]) || (r += "/" + t[o].toString().replace(/~/g, "~0").replace(/\//g, "~1"));
            return r;
          }, y.toPathArray = function (e) {
            var t = y.cache;
            if (t[e]) return t[e].concat();
            var n = [],
              r = e.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g, function (e, t) {
                return "[#" + (n.push(t) - 1) + "]";
              }).replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g, function (e, t) {
                return "['" + t.replace(/\./g, "%@%").replace(/~/g, "%%@@%%") + "']";
              }).replace(/~/g, ";~;").replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g, ";").replace(/%@%/g, ".").replace(/%%@@%%/g, "~").replace(/(?:;)?(\^+)(?:;)?/g, function (e, t) {
                return ";" + t.split("").join(";") + ";";
              }).replace(/;;;|;;/g, ";..;").replace(/;$|'?\]|'$/g, "").split(";").map(function (e) {
                var t = e.match(/#([0-9]+)/);
                return t && t[1] ? n[t[1]] : e;
              });
            return t[e] = r, t[e].concat();
          }, y.prototype.vm = {
            runInNewContext: function (e, t) {
              var n = Object.keys(t),
                r = [];
              !function (e, n, r) {
                for (var o = e.length, i = 0; i < o; i++) a = e[i], "function" == typeof t[a] && n.push(e.splice(i--, 1)[0]);
                var a;
              }(n, r);
              var o = n.map(function (e, n) {
                  return t[e];
                }),
                i = r.reduce(function (e, n) {
                  var r = t[n].toString();
                  return /function/.test(r) || (r = "function " + r), "var " + n + "=" + r + ";" + e;
                }, "");
              /(["'])use strict\1/.test(e = i + e) || n.includes("arguments") || (e = "var arguments = undefined;" + e);
              var a = (e = e.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "")).lastIndexOf(";"),
                s = a > -1 ? e.slice(0, a + 1) + " return " + e.slice(a + 1) : " return " + e;
              return u(Function, f(n).concat([s])).apply(void 0, f(o));
            }
          };
        },
        5666: function (e) {
          var t = function (e) {
            "use strict";

            var t,
              n = Object.prototype,
              r = n.hasOwnProperty,
              o = "function" == typeof Symbol ? Symbol : {},
              i = o.iterator || "@@iterator",
              a = o.asyncIterator || "@@asyncIterator",
              u = o.toStringTag || "@@toStringTag";
            function s(e, t, n) {
              return Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }), e[t];
            }
            try {
              s({}, "");
            } catch (e) {
              s = function (e, t, n) {
                return e[t] = n;
              };
            }
            function c(e, t, n, r) {
              var o = t && t.prototype instanceof g ? t : g,
                i = Object.create(o.prototype),
                a = new _(r || []);
              return i._invoke = function (e, t, n) {
                var r = l;
                return function (o, i) {
                  if (r === h) throw new Error("Generator is already running");
                  if (r === d) {
                    if ("throw" === o) throw i;
                    return P();
                  }
                  for (n.method = o, n.arg = i;;) {
                    var a = n.delegate;
                    if (a) {
                      var u = O(a, n);
                      if (u) {
                        if (u === v) continue;
                        return u;
                      }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                      if (r === l) throw r = d, n.arg;
                      n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    r = h;
                    var s = f(e, t, n);
                    if ("normal" === s.type) {
                      if (r = n.done ? d : p, s.arg === v) continue;
                      return {
                        value: s.arg,
                        done: n.done
                      };
                    }
                    "throw" === s.type && (r = d, n.method = "throw", n.arg = s.arg);
                  }
                };
              }(e, n, a), i;
            }
            function f(e, t, n) {
              try {
                return {
                  type: "normal",
                  arg: e.call(t, n)
                };
              } catch (e) {
                return {
                  type: "throw",
                  arg: e
                };
              }
            }
            e.wrap = c;
            var l = "suspendedStart",
              p = "suspendedYield",
              h = "executing",
              d = "completed",
              v = {};
            function g() {}
            function y() {}
            function m() {}
            var b = {};
            b[i] = function () {
              return this;
            };
            var k = Object.getPrototypeOf,
              w = k && k(k(R([])));
            w && w !== n && r.call(w, i) && (b = w);
            var x = m.prototype = g.prototype = Object.create(b);
            function S(e) {
              ["next", "throw", "return"].forEach(function (t) {
                s(e, t, function (e) {
                  return this._invoke(t, e);
                });
              });
            }
            function T(e, t) {
              function n(o, i, a, u) {
                var s = f(e[o], e, i);
                if ("throw" !== s.type) {
                  var c = s.arg,
                    l = c.value;
                  return l && "object" == typeof l && r.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                    n("next", e, a, u);
                  }, function (e) {
                    n("throw", e, a, u);
                  }) : t.resolve(l).then(function (e) {
                    c.value = e, a(c);
                  }, function (e) {
                    return n("throw", e, a, u);
                  });
                }
                u(s.arg);
              }
              var o;
              this._invoke = function (e, r) {
                function i() {
                  return new t(function (t, o) {
                    n(e, r, t, o);
                  });
                }
                return o = o ? o.then(i, i) : i();
              };
            }
            function O(e, n) {
              var r = e.iterator[n.method];
              if (r === t) {
                if (n.delegate = null, "throw" === n.method) {
                  if (e.iterator.return && (n.method = "return", n.arg = t, O(e, n), "throw" === n.method)) return v;
                  n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
                }
                return v;
              }
              var o = f(r, e.iterator, n.arg);
              if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, v;
              var i = o.arg;
              return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, v) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
            }
            function A(e) {
              var t = {
                tryLoc: e[0]
              };
              1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
            }
            function E(e) {
              var t = e.completion || {};
              t.type = "normal", delete t.arg, e.completion = t;
            }
            function _(e) {
              this.tryEntries = [{
                tryLoc: "root"
              }], e.forEach(A, this), this.reset(!0);
            }
            function R(e) {
              if (e) {
                var n = e[i];
                if (n) return n.call(e);
                if ("function" == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var o = -1,
                    a = function n() {
                      for (; ++o < e.length;) if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
                      return n.value = t, n.done = !0, n;
                    };
                  return a.next = a;
                }
              }
              return {
                next: P
              };
            }
            function P() {
              return {
                value: t,
                done: !0
              };
            }
            return y.prototype = x.constructor = m, m.constructor = y, y.displayName = s(m, u, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
              var t = "function" == typeof e && e.constructor;
              return !!t && (t === y || "GeneratorFunction" === (t.displayName || t.name));
            }, e.mark = function (e) {
              return Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : (e.__proto__ = m, s(e, u, "GeneratorFunction")), e.prototype = Object.create(x), e;
            }, e.awrap = function (e) {
              return {
                __await: e
              };
            }, S(T.prototype), T.prototype[a] = function () {
              return this;
            }, e.AsyncIterator = T, e.async = function (t, n, r, o, i) {
              void 0 === i && (i = Promise);
              var a = new T(c(t, n, r, o), i);
              return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
                return e.done ? e.value : a.next();
              });
            }, S(x), s(x, u, "Generator"), x[i] = function () {
              return this;
            }, x.toString = function () {
              return "[object Generator]";
            }, e.keys = function (e) {
              var t = [];
              for (var n in e) t.push(n);
              return t.reverse(), function n() {
                for (; t.length;) {
                  var r = t.pop();
                  if (r in e) return n.value = r, n.done = !1, n;
                }
                return n.done = !0, n;
              };
            }, e.values = R, _.prototype = {
              constructor: _,
              reset: function (e) {
                if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(E), !e) for (var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
              },
              stop: function () {
                this.done = !0;
                var e = this.tryEntries[0].completion;
                if ("throw" === e.type) throw e.arg;
                return this.rval;
              },
              dispatchException: function (e) {
                if (this.done) throw e;
                var n = this;
                function o(r, o) {
                  return u.type = "throw", u.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
                }
                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                  var a = this.tryEntries[i],
                    u = a.completion;
                  if ("root" === a.tryLoc) return o("end");
                  if (a.tryLoc <= this.prev) {
                    var s = r.call(a, "catchLoc"),
                      c = r.call(a, "finallyLoc");
                    if (s && c) {
                      if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                      if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                    } else if (s) {
                      if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    } else {
                      if (!c) throw new Error("try statement without catch or finally");
                      if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function (e, t) {
                for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                  var o = this.tryEntries[n];
                  if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                  }
                }
                i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                var a = i ? i.completion : {};
                return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(a);
              },
              complete: function (e, t) {
                if ("throw" === e.type) throw e.arg;
                return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
              },
              finish: function (e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var n = this.tryEntries[t];
                  if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), E(n), v;
                }
              },
              catch: function (e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var n = this.tryEntries[t];
                  if (n.tryLoc === e) {
                    var r = n.completion;
                    if ("throw" === r.type) {
                      var o = r.arg;
                      E(n);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function (e, n, r) {
                return this.delegate = {
                  iterator: R(e),
                  resultName: n,
                  nextLoc: r
                }, "next" === this.method && (this.arg = t), v;
              }
            }, e;
          }(e.exports);
          try {
            regeneratorRuntime = t;
          } catch (e) {
            Function("r", "regeneratorRuntime = r")(t);
          }
        },
        4279: function (e) {
          function t() {}
          t.prototype = {
            on: function (e, t, n) {
              var r = this.e || (this.e = {});
              return (r[e] || (r[e] = [])).push({
                fn: t,
                ctx: n
              }), this;
            },
            once: function (e, t, n) {
              var r = this;
              function o() {
                r.off(e, o), t.apply(n, arguments);
              }
              return o._ = t, this.on(e, o, n);
            },
            emit: function (e) {
              for (var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), r = 0, o = n.length; r < o; r++) n[r].fn.apply(n[r].ctx, t);
              return this;
            },
            off: function (e, t) {
              var n = this.e || (this.e = {}),
                r = n[e],
                o = [];
              if (r && t) for (var i = 0, a = r.length; i < a; i++) r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
              return o.length ? n[e] = o : delete n[e], this;
            }
          }, e.exports = t;
        },
        9148: function () {}
      },
      t = {};
    function n(r) {
      var o = t[r];
      if (void 0 !== o) return o.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.exports;
    }
    n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, {
        a: t
      }), t;
    }, n.d = function (e, t) {
      for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }, n.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return function () {
      "use strict";

      n.r(r), n.d(r, {
        ACCESS_TOKEN_STORAGE_KEY: function () {
          return oe;
        },
        AuthApiError: function () {
          return y;
        },
        AuthPollStopError: function () {
          return m;
        },
        AuthSdkError: function () {
          return b;
        },
        AuthStateManager: function () {
          return Yn;
        },
        AuthTransaction: function () {
          return Ie;
        },
        AuthenticatorKey: function () {
          return dt;
        },
        CACHE_STORAGE_NAME: function () {
          return Q;
        },
        DEFAULT_CACHE_DURATION: function () {
          return $;
        },
        DEFAULT_CODE_CHALLENGE_METHOD: function () {
          return fe;
        },
        DEFAULT_MAX_CLOCK_SKEW: function () {
          return W;
        },
        DEFAULT_POLLING_DELAY: function () {
          return G;
        },
        EVENT_ADDED: function () {
          return Dn;
        },
        EVENT_ERROR: function () {
          return qn;
        },
        EVENT_EXPIRED: function () {
          return Nn;
        },
        EVENT_REMOVED: function () {
          return Bn;
        },
        EVENT_RENEWED: function () {
          return Ln;
        },
        IDX_API_VERSION: function () {
          return le;
        },
        IDX_RESPONSE_STORAGE_NAME: function () {
          return re;
        },
        ID_TOKEN_STORAGE_KEY: function () {
          return ie;
        },
        INITIAL_AUTH_STATE: function () {
          return $n;
        },
        IdxFeature: function () {
          return vt;
        },
        IdxStatus: function () {
          return ht;
        },
        MAX_VERIFIER_LENGTH: function () {
          return ce;
        },
        MIN_VERIFIER_LENGTH: function () {
          return se;
        },
        OAuthError: function () {
          return k;
        },
        ORIGINAL_URI_STORAGE_NAME: function () {
          return ne;
        },
        OktaAuth: function () {
          return Yo;
        },
        PKCE_STORAGE_NAME: function () {
          return Z;
        },
        REDIRECT_NONCE_COOKIE_NAME: function () {
          return Y;
        },
        REDIRECT_OAUTH_PARAMS_NAME: function () {
          return z;
        },
        REDIRECT_STATE_COOKIE_NAME: function () {
          return J;
        },
        REFERRER_PATH_STORAGE_KEY: function () {
          return ue;
        },
        REFRESH_TOKEN_STORAGE_KEY: function () {
          return ae;
        },
        SHARED_TRANSACTION_STORAGE_NAME: function () {
          return te;
        },
        STATE_TOKEN_KEY_NAME: function () {
          return V;
        },
        TOKEN_STORAGE_NAME: function () {
          return X;
        },
        TRANSACTION_STORAGE_NAME: function () {
          return ee;
        },
        TokenManager: function () {
          return Hn;
        },
        TransactionState: function () {
          return Be;
        },
        addListener: function () {
          return nt;
        },
        addPostMessageListener: function () {
          return at;
        },
        addStateToken: function () {
          return Ae;
        },
        bind: function () {
          return I;
        },
        buildAuthorizeParams: function () {
          return Je;
        },
        clone: function () {
          return U;
        },
        convertTokenParamsToOAuthParams: function () {
          return ze;
        },
        crypto: function () {
          return e;
        },
        decodeToken: function () {
          return tn;
        },
        delay: function () {
          return Pe;
        },
        deprecate: function () {
          return Tn;
        },
        deprecateWrap: function () {
          return On;
        },
        exchangeCodeForTokens: function () {
          return rn;
        },
        extend: function () {
          return C;
        },
        find: function () {
          return N;
        },
        genRandomString: function () {
          return Re;
        },
        generateNonce: function () {
          return st;
        },
        generateState: function () {
          return ut;
        },
        getConsole: function () {
          return xn;
        },
        getDefaultTokenParams: function () {
          return Et;
        },
        getHashOrSearch: function () {
          return Ft;
        },
        getKey: function () {
          return tt;
        },
        getLink: function () {
          return L;
        },
        getNativeConsole: function () {
          return wn;
        },
        getOAuthBaseUrl: function () {
          return ft;
        },
        getOAuthDomain: function () {
          return lt;
        },
        getOAuthUrls: function () {
          return pt;
        },
        getPollFn: function () {
          return je;
        },
        getStateToken: function () {
          return Ee;
        },
        getToken: function () {
          return un;
        },
        getUserInfo: function () {
          return dn;
        },
        getWellKnown: function () {
          return et;
        },
        getWithPopup: function () {
          return vn;
        },
        getWithRedirect: function () {
          return gn;
        },
        getWithoutPrompt: function () {
          return sn;
        },
        handleOAuthResponse: function () {
          return an;
        },
        hasAuthorizationCode: function () {
          return jt;
        },
        hasErrorInUrl: function () {
          return Ct;
        },
        hasInteractionCode: function () {
          return It;
        },
        hasTokensInHash: function () {
          return Pt;
        },
        introspect: function () {
          return Ne;
        },
        isAbsoluteUrl: function () {
          return me;
        },
        isAccessToken: function () {
          return Xt;
        },
        isAuthApiError: function () {
          return w;
        },
        isAuthorizationCodeError: function () {
          return Rt;
        },
        isCodeFlow: function () {
          return Ut;
        },
        isCustomAuthTransactionMeta: function () {
          return zt;
        },
        isEmailVerifyCallback: function () {
          return Rn;
        },
        isFunction: function () {
          return ge;
        },
        isIDToken: function () {
          return Qt;
        },
        isIdxTransactionMeta: function () {
          return $t;
        },
        isInteractionRequired: function () {
          return Lt;
        },
        isInteractionRequiredError: function () {
          return _t;
        },
        isLoginRedirect: function () {
          return Nt;
        },
        isNumber: function () {
          return ve;
        },
        isOAuthTransactionMeta: function () {
          return Gt;
        },
        isObject: function () {
          return de;
        },
        isPKCETransactionMeta: function () {
          return Wt;
        },
        isPromise: function () {
          return ye;
        },
        isRedirectUri: function () {
          return Mt;
        },
        isRefreshToken: function () {
          return Zt;
        },
        isRefreshTokenError: function () {
          return qt;
        },
        isSameRefreshToken: function () {
          return Bt;
        },
        isString: function () {
          return he;
        },
        isToken: function () {
          return Yt;
        },
        isTransactionMeta: function () {
          return Jt;
        },
        isoToUTCString: function () {
          return _e;
        },
        loadFrame: function () {
          return ot;
        },
        loadPopup: function () {
          return it;
        },
        omit: function () {
          return F;
        },
        parseEmailVerifyCallback: function () {
          return Pn;
        },
        parseFromUrl: function () {
          return kn;
        },
        pkce: function () {
          return He;
        },
        postRefreshToken: function () {
          return Ze;
        },
        postToTokenEndpoint: function () {
          return Qe;
        },
        postToTransaction: function () {
          return De;
        },
        prepareTokenParams: function () {
          return Dt;
        },
        removeListener: function () {
          return rt;
        },
        removeNils: function () {
          return M;
        },
        removeTrailingSlash: function () {
          return xe;
        },
        renewToken: function () {
          return pn;
        },
        renewTokens: function () {
          return hn;
        },
        renewTokensWithRefresh: function () {
          return cn;
        },
        resumeTransaction: function () {
          return Fe;
        },
        revokeToken: function () {
          return nn;
        },
        toAbsoluteUrl: function () {
          return be;
        },
        toQueryString: function () {
          return we;
        },
        toRelativeUrl: function () {
          return ke;
        },
        transactionExists: function () {
          return Le;
        },
        transactionStatus: function () {
          return Ue;
        },
        urlParamsToObject: function () {
          return Ht;
        },
        validateClaims: function () {
          return Kt;
        },
        validateToken: function () {
          return en;
        },
        verifyToken: function () {
          return on;
        },
        warn: function () {
          return Sn;
        }
      });
      var e = {};
      n.r(e), n.d(e, {
        atob: function () {
          return x;
        },
        base64ToBase64Url: function () {
          return A;
        },
        base64UrlDecode: function () {
          return P;
        },
        base64UrlToBase64: function () {
          return E;
        },
        base64UrlToString: function () {
          return _;
        },
        btoa: function () {
          return S;
        },
        getOidcHash: function () {
          return j;
        },
        stringToBase64Url: function () {
          return O;
        },
        stringToBuffer: function () {
          return R;
        },
        verifyToken: function () {
          return D;
        },
        webcrypto: function () {
          return T;
        }
      });
      var t = {};
      n.r(t), n.d(t, {
        ACCESS_TOKEN_STORAGE_KEY: function () {
          return oe;
        },
        CACHE_STORAGE_NAME: function () {
          return Q;
        },
        DEFAULT_CACHE_DURATION: function () {
          return $;
        },
        DEFAULT_CODE_CHALLENGE_METHOD: function () {
          return fe;
        },
        DEFAULT_MAX_CLOCK_SKEW: function () {
          return W;
        },
        DEFAULT_POLLING_DELAY: function () {
          return G;
        },
        IDX_API_VERSION: function () {
          return le;
        },
        IDX_RESPONSE_STORAGE_NAME: function () {
          return re;
        },
        ID_TOKEN_STORAGE_KEY: function () {
          return ie;
        },
        MAX_VERIFIER_LENGTH: function () {
          return ce;
        },
        MIN_VERIFIER_LENGTH: function () {
          return se;
        },
        ORIGINAL_URI_STORAGE_NAME: function () {
          return ne;
        },
        PKCE_STORAGE_NAME: function () {
          return Z;
        },
        REDIRECT_NONCE_COOKIE_NAME: function () {
          return Y;
        },
        REDIRECT_OAUTH_PARAMS_NAME: function () {
          return z;
        },
        REDIRECT_STATE_COOKIE_NAME: function () {
          return J;
        },
        REFERRER_PATH_STORAGE_KEY: function () {
          return ue;
        },
        REFRESH_TOKEN_STORAGE_KEY: function () {
          return ae;
        },
        SHARED_TRANSACTION_STORAGE_NAME: function () {
          return te;
        },
        STATE_TOKEN_KEY_NAME: function () {
          return V;
        },
        TOKEN_STORAGE_NAME: function () {
          return X;
        },
        TRANSACTION_STORAGE_NAME: function () {
          return ee;
        }
      });
      var o = {};
      n.r(o), n.d(o, {
        getUserAgent: function () {
          return bt;
        },
        hasTextEncoder: function () {
          return St;
        },
        isBrowser: function () {
          return yt;
        },
        isFingerprintSupported: function () {
          return kt;
        },
        isHTTPS: function () {
          return Ot;
        },
        isIE11OrLess: function () {
          return mt;
        },
        isLocalhost: function () {
          return At;
        },
        isPKCESupported: function () {
          return Tt;
        },
        isPopupPostMessageSupported: function () {
          return wt;
        },
        isTokenVerifySupported: function () {
          return xt;
        }
      });
      var i = {};
      function a(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function u(e, t) {
        return u = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, u(e, t);
      }
      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && u(e, t);
      }
      function c(e) {
        return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, c(e);
      }
      function f(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function l(e, t) {
        return !t || "object" !== c(t) && "function" != typeof t ? f(e) : t;
      }
      function p(e) {
        return p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, p(e);
      }
      function h() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      function d(e, t, n) {
        return d = h() ? Reflect.construct : function (e, t, n) {
          var r = [null];
          r.push.apply(r, t);
          var o = new (Function.bind.apply(e, r))();
          return n && u(o, n.prototype), o;
        }, d.apply(null, arguments);
      }
      function v(e) {
        var t = "function" == typeof Map ? new Map() : void 0;
        return v = function (e) {
          if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
          var n;
          if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
          if (void 0 !== t) {
            if (t.has(e)) return t.get(e);
            t.set(e, r);
          }
          function r() {
            return d(e, arguments, p(this).constructor);
          }
          return r.prototype = Object.create(e.prototype, {
            constructor: {
              value: r,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), u(r, e);
        }, v(e);
      }
      n.r(i), n.d(i, {
        AuthenticatorEnrollmentData: function () {
          return fo;
        },
        AuthenticatorVerificationData: function () {
          return co;
        },
        ChallengeAuthenticator: function () {
          return zr;
        },
        ChallengePoll: function () {
          return Jr;
        },
        EnrollAuthenticator: function () {
          return Gr;
        },
        EnrollPoll: function () {
          return $r;
        },
        EnrollProfile: function () {
          return Xr;
        },
        Identify: function () {
          return Qr;
        },
        ReEnrollAuthenticator: function () {
          return Zr;
        },
        RedirectIdp: function () {
          return eo;
        },
        Remediator: function () {
          return Fr;
        },
        ResetAuthenticator: function () {
          return Yr;
        },
        SelectAuthenticatorAuthenticate: function () {
          return io;
        },
        SelectAuthenticatorEnroll: function () {
          return ao;
        },
        SelectEnrollProfile: function () {
          return uo;
        },
        Skip: function () {
          return lo;
        }
      });
      var g = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o(e) {
          var t;
          return a(this, o), t = r.call(this, e), Object.setPrototypeOf(f(t), (this instanceof o ? this.constructor : void 0).prototype), t;
        }
        return o;
      }(v(Error));
      var y = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o(e, t) {
          var n;
          a(this, o);
          var i = e.errorSummary;
          return (n = r.call(this, i)).name = "AuthApiError", n.errorSummary = e.errorSummary, n.errorCode = e.errorCode, n.errorLink = e.errorLink, n.errorId = e.errorId, n.errorCauses = e.errorCauses, t && (n.xhr = t), n;
        }
        return o;
      }(g);
      var m = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.call(this, "The poll was stopped by the sdk");
        }
        return o;
      }(g);
      var b = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o(e, t) {
          var n;
          return a(this, o), (n = r.call(this, e)).name = "AuthSdkError", n.errorCode = "INTERNAL", n.errorSummary = e, n.errorLink = "INTERNAL", n.errorId = "INTERNAL", n.errorCauses = [], t && (n.xhr = t), n;
        }
        return o;
      }(g);
      var k = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o(e, t) {
          var n;
          return a(this, o), (n = r.call(this, t)).name = "OAuthError", n.errorCode = e, n.errorSummary = t, n;
        }
        return o;
      }(g);
      function w(e) {
        return e instanceof y;
      }
      var x = function (e) {
          return atob(e);
        },
        S = function (e) {
          return btoa(e);
        },
        T = "undefined" == typeof crypto ? null : crypto;
      function O(e) {
        return A(S(e));
      }
      function A(e) {
        return e.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
      }
      function E(e) {
        return e.replace(/-/g, "+").replace(/_/g, "/");
      }
      function _(e) {
        var t = E(e);
        switch (t.length % 4) {
          case 0:
            break;
          case 2:
            t += "==";
            break;
          case 3:
            t += "=";
            break;
          default:
            throw new b("Not a valid Base64Url");
        }
        var n = x(t);
        try {
          return decodeURIComponent(escape(n));
        } catch (e) {
          return n;
        }
      }
      function R(e) {
        for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
        return t;
      }
      function P(e) {
        return x(E(e));
      }
      function j(e) {
        var t = new TextEncoder().encode(e);
        return T.subtle.digest("SHA-256", t).then(function (e) {
          var t = new Uint8Array(e).slice(0, 16);
          return O(String.fromCharCode.apply(null, t));
        });
      }
      function I(e, t) {
        var n = Array.prototype.slice.call(arguments, 2);
        return function () {
          var r = Array.prototype.slice.call(arguments);
          return r = n.concat(r), e.apply(t, r);
        };
      }
      function C() {
        var e = arguments[0],
          t = [].slice.call(arguments, 1);
        return t.forEach(function (t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e[n] = t[n]);
        }), e;
      }
      function M(e) {
        var t = {};
        for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
          var r = e[n];
          null != r && (t[n] = r);
        }
        return t;
      }
      function U(e) {
        if (e) {
          var t = JSON.stringify(e);
          if (t) return JSON.parse(t);
        }
        return e;
      }
      function F(e) {
        for (var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
        for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && -1 == r.indexOf(i) && (t[i] = e[i]);
        return U(t);
      }
      function N(e, t) {
        for (var n = e.length; n--;) {
          var r = e[n],
            o = !0;
          for (var i in t) if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
            o = !1;
            break;
          }
          if (o) return r;
        }
      }
      function L(e, t, n) {
        if (e && e._links) {
          var r = U(e._links[t]);
          return r && r.name && n ? r.name === n ? r : void 0 : r;
        }
      }
      function D(e, t) {
        t = U(t);
        var n = {
          name: "RSASSA-PKCS1-v1_5",
          hash: {
            name: "SHA-256"
          }
        };
        return delete t.use, T.subtle.importKey("jwk", t, n, !0, ["verify"]).then(function (t) {
          var r = e.split("."),
            o = R(r[0] + "." + r[1]),
            i = R(P(r[2]));
          return T.subtle.verify(n, t, i, o);
        });
      }
      function B(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function q(e, t, n) {
        return t && B(e.prototype, t), n && B(e, n), e;
      }
      var H = n(7757),
        K = n.n(H),
        V = "oktaStateToken",
        G = 500,
        W = 300,
        $ = 86400,
        z = "okta-oauth-redirect-params",
        J = "okta-oauth-state",
        Y = "okta-oauth-nonce",
        X = "okta-token-storage",
        Q = "okta-cache-storage",
        Z = "okta-pkce-storage",
        ee = "okta-transaction-storage",
        te = "okta-shared-transaction-storage",
        ne = "okta-original-uri-storage",
        re = "okta-idx-response-storage",
        oe = "accessToken",
        ie = "idToken",
        ae = "refreshToken",
        ue = "referrerPath",
        se = 43,
        ce = 128,
        fe = "S256",
        le = "1.0.0";
      function pe(e, t, n) {
        e.options.headers = e.options.headers || {}, e.options.headers[t] = n;
      }
      function he(e) {
        return "[object String]" === Object.prototype.toString.call(e);
      }
      function de(e) {
        return "[object Object]" === Object.prototype.toString.call(e);
      }
      function ve(e) {
        return "[object Number]" === Object.prototype.toString.call(e);
      }
      function ge(e) {
        return !!e && "[object Function]" === {}.toString.call(e);
      }
      function ye(e) {
        return e && e.finally && "function" == typeof e.finally;
      }
      function me(e) {
        return /^(?:[a-z]+:)?\/\//i.test(e);
      }
      function be() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = arguments.length > 1 ? arguments[1] : void 0;
        return me(e) ? e : (t = xe(t), "/" === e[0] ? "".concat(t).concat(e) : "".concat(t, "/").concat(e));
      }
      function ke() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = arguments.length > 1 ? arguments[1] : void 0;
        return me(e) && (e = e.substring(t.length)), "/" === e[0] ? e : "/".concat(e);
      }
      function we(e) {
        var t = [];
        if (null !== e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && void 0 !== e[n] && null !== e[n] && t.push(n + "=" + encodeURIComponent(e[n]));
        return t.length ? "?" + t.join("&") : "";
      }
      function xe(e) {
        if (e) {
          var t = e.replace(/^\s+|\s+$/gm, "");
          return t.replace(/\/+$/, "");
        }
      }
      function Se(e, t) {
        var n = (t = t || {}).url,
          r = t.method,
          o = t.args,
          i = t.saveAuthnState,
          a = t.accessToken,
          u = !0 === t.withCredentials,
          s = e.options.storageUtil.storage,
          f = e.storageManager.getHttpCache(e.options.cookies);
        if (t.cacheResponse) {
          var l = f.getStorage()[n];
          if (l && Date.now() / 1e3 < l.expiresAt) return Promise.resolve(l.response);
        }
        var p = e._oktaUserAgent.getHttpHeader(),
          h = Object.assign({
            Accept: "application/json",
            "Content-Type": "application/json"
          }, p);
        Object.assign(h, e.options.headers, t.headers), h = M(h), a && he(a) && (h.Authorization = "Bearer " + a);
        var d,
          v,
          g = {
            headers: h,
            data: o || void 0,
            withCredentials: u
          };
        return e.options.httpRequestClient(r, n, g).then(function (r) {
          return (v = r.responseText) && he(v) && (v = JSON.parse(v)) && "object" === c(v) && !v.headers && (v.headers = r.headers), i && (v.stateToken || s.delete(V)), v && v.stateToken && v.expiresAt && s.set(V, v.stateToken, v.expiresAt, e.options.cookies), v && t.cacheResponse && f.updateStorage(n, {
            expiresAt: Math.floor(Date.now() / 1e3) + $,
            response: v
          }), v;
        }).catch(function (t) {
          var n = t.responseText || {};
          if (he(n)) try {
            n = JSON.parse(n);
          } catch (e) {
            n = {
              errorSummary: "Unknown error"
            };
          }
          throw t.status >= 500 && (n.errorSummary = "Unknown error"), e.options.transformErrorXHR && (t = e.options.transformErrorXHR(U(t))), "E0000011" === (d = new y(n, t)).errorCode && s.delete(V), d;
        });
      }
      function Te(e, t, n) {
        var r = {
          url: t = me(t) ? t : e.getIssuerOrigin() + t,
          method: "GET"
        };
        return Object.assign(r, n), Se(e, r);
      }
      function Oe(e, t, n, r) {
        var o = {
          url: t = me(t) ? t : e.getIssuerOrigin() + t,
          method: "POST",
          args: n,
          saveAuthnState: !0
        };
        return Object.assign(o, r), Se(e, o);
      }
      function Ae(e, t) {
        var n = {};
        return Object.assign(n, t), !n.stateToken && e.stateToken && (n.stateToken = e.stateToken), n;
      }
      function Ee(e) {
        return Ae(e);
      }
      function _e(e) {
        var t = e.match(/\d+/g),
          n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
        return new Date(n).toUTCString();
      }
      function Re(e) {
        for (var t = "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", n = "", r = 0, o = t.length; r < e; ++r) n += t[Math.floor(Math.random() * o)];
        return n;
      }
      function Pe(e) {
        return new Promise(function (t) {
          setTimeout(t, e);
        });
      }
      function je(e, t, n) {
        return function (r) {
          var o, i, a, u;
          ve(r) ? o = r : de(r) && (o = (r = r).delay, i = r.rememberDevice, a = r.autoPush, u = r.transactionCallBack), o || 0 === o || (o = G);
          var s = L(t, "next", "poll");
          n.isPolling = !0;
          var c = 0;
          return function r() {
            return n.isPolling ? function () {
              var n = {};
              if ("function" == typeof a) try {
                n.autoPush = !!a();
              } catch (e) {
                return Promise.reject(new b("AutoPush resulted in an error."));
              } else null != a && (n.autoPush = !!a);
              if ("function" == typeof i) try {
                n.rememberDevice = !!i();
              } catch (e) {
                return Promise.reject(new b("RememberDevice resulted in an error."));
              } else null != i && (n.rememberDevice = !!i);
              var r = s.href + we(n);
              return Oe(e, r, Ee(t), {
                saveAuthnState: !1,
                withCredentials: !0
              });
            }().then(function (t) {
              if (c = 0, t.factorResult && "WAITING" === t.factorResult) {
                if (!n.isPolling) throw new m();
                return "function" == typeof u && u(t), Pe(o).then(r);
              }
              return n.isPolling = !1, new Ie(e, t);
            }).catch(function (e) {
              if (e.xhr && (0 === e.xhr.status || 429 === e.xhr.status) && c <= 4) {
                var t = 1e3 * Math.pow(2, c);
                return c++, Pe(t).then(r);
              }
              throw e;
            }) : Promise.reject(new m());
          }().catch(function (e) {
            throw n.isPolling = !1, e;
          });
        };
      }
      var Ie = function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        if (a(this, e), n) {
          if (this.data = n, this.data.interactionHandle) return void (this.status = n.status);
          Object.assign(this, Me(t, n, n, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== n.status || n._links || (this.cancel = function () {
            return Promise.resolve(new e(t));
          });
        }
      };
      function Ce(e, t, n, r, o) {
        if (Array.isArray(r)) return function (i, a) {
          if (!i) throw new b("Must provide a link name");
          var u = N(r, {
            name: i
          });
          if (!u) throw new b("No link found for that name");
          return Ce(e, t, n, u, o)(a);
        };
        if (r.hints && r.hints.allow && 1 === r.hints.allow.length) switch (r.hints.allow[0]) {
          case "GET":
            return function () {
              return Te(e, r.href, {
                withCredentials: !0
              });
            };
          case "POST":
            return function (i) {
              o && o.isPolling && (o.isPolling = !1);
              var a = Ae(t, i);
              "MFA_ENROLL" !== t.status && "FACTOR_ENROLL" !== t.status || Object.assign(a, {
                factorType: n.factorType,
                provider: n.provider
              });
              var u = {},
                s = a.autoPush;
              if (void 0 !== s) {
                if ("function" == typeof s) try {
                  u.autoPush = !!s();
                } catch (e) {
                  return Promise.reject(new b("AutoPush resulted in an error."));
                } else null !== s && (u.autoPush = !!s);
                a = F(a, "autoPush");
              }
              var c = a.rememberDevice;
              if (void 0 !== c) {
                if ("function" == typeof c) try {
                  u.rememberDevice = !!c();
                } catch (e) {
                  return Promise.reject(new b("RememberDevice resulted in an error."));
                } else null !== c && (u.rememberDevice = !!c);
                a = F(a, "rememberDevice");
              } else a.profile && void 0 !== a.profile.updatePhone && (a.profile.updatePhone && (u.updatePhone = !0), a.profile = F(a.profile, "updatePhone"));
              var f = r.href + we(u);
              return De(e, f, a);
            };
        }
      }
      function Me(e, t, n, r) {
        if (n = U(n = n || t), Array.isArray(n)) {
          for (var o = [], i = 0, a = n.length; i < a; i++) o.push(Me(e, t, n[i], r));
          return o;
        }
        var u = n._embedded || {};
        for (var s in u) Object.prototype.hasOwnProperty.call(u, s) && (de(u[s]) || Array.isArray(u[s])) && (u[s] = Me(e, t, u[s], r));
        var c = function (e, t, n, r) {
          var o = {};
          for (var i in n._links) if (Object.prototype.hasOwnProperty.call(n._links, i)) {
            var a = n._links[i];
            if ("next" === i && (i = a.name), a.type) o[i] = a;else if ("poll" === i) o.poll = je(e, t, r);else {
              var u = Ce(e, t, n, a, r);
              u && (o[i] = u);
            }
          }
          return o;
        }(e, t, n, r);
        return Object.assign(u, c), n = F(n, "_embedded", "_links"), Object.assign(n, u), n;
      }
      function Ue(e, t) {
        return t = Ae(e, t), Oe(e, e.getIssuerOrigin() + "/api/v1/authn", t, {
          withCredentials: !0
        });
      }
      function Fe(e, t) {
        if (!t || !t.stateToken) {
          var n = e.tx.exists._get(V);
          if (!n) return Promise.reject(new b("No transaction to resume"));
          t = {
            stateToken: n
          };
        }
        return e.tx.status(t).then(function (t) {
          return new Ie(e, t);
        });
      }
      function Ne(e, t) {
        if (!t || !t.stateToken) {
          var n = e.tx.exists._get(V);
          if (!n) return Promise.reject(new b("No transaction to evaluate"));
          t = {
            stateToken: n
          };
        }
        return function (e, t) {
          return t = Ae(e, t), Oe(e, e.getIssuerOrigin() + "/api/v1/authn/introspect", t, {
            withCredentials: !0
          });
        }(e, t).then(function (t) {
          return new Ie(e, t);
        });
      }
      function Le(e) {
        return !!e.tx.exists._get(V);
      }
      function De(e, t, n, r) {
        return r = Object.assign({
          withCredentials: !0
        }, r), Oe(e, t, n, r).then(function (t) {
          return new Ie(e, t);
        });
      }
      var Be = function e() {
        a(this, e);
      };
      function qe(e) {
        return ("0" + e.toString(16)).substr(-2);
      }
      var He = {
        DEFAULT_CODE_CHALLENGE_METHOD: fe,
        generateVerifier: function (e) {
          var t = e || "";
          return t.length < se && (t += function (e) {
            var t = new Uint8Array(Math.ceil(e / 2));
            return T.getRandomValues(t), Array.from(t, qe).join("").slice(0, e);
          }(se - t.length)), encodeURIComponent(t).slice(0, ce);
        },
        computeChallenge: function (e) {
          var t = new TextEncoder().encode(e);
          return T.subtle.digest("SHA-256", t).then(function (e) {
            return O(String.fromCharCode.apply(null, new Uint8Array(e)));
          });
        }
      };
      function Ke(e) {
        return e.session.get().then(function (e) {
          return "ACTIVE" === e.status;
        }).catch(function () {
          return !1;
        });
      }
      function Ve(e) {
        return Te(e, "/api/v1/sessions/me", {
          withCredentials: !0
        }).then(function (t) {
          var n = F(t, "_links");
          return n.refresh = function () {
            return Oe(e, L(t, "refresh").href, {}, {
              withCredentials: !0
            });
          }, n.user = function () {
            return Te(e, L(t, "user").href, {
              withCredentials: !0
            });
          }, n;
        }).catch(function () {
          return {
            status: "INACTIVE"
          };
        });
      }
      function Ge(e) {
        return Se(e, {
          url: e.getIssuerOrigin() + "/api/v1/sessions/me",
          method: "DELETE",
          withCredentials: !0
        });
      }
      function We(e) {
        return Oe(e, "/api/v1/sessions/me/lifecycle/refresh", {}, {
          withCredentials: !0
        });
      }
      function $e(e, t, n) {
        n = n || window.location.href, window.location.assign(e.getIssuerOrigin() + "/login/sessionCookieRedirect" + we({
          checkAccountSetupComplete: !0,
          token: t,
          redirectUrl: n
        }));
      }
      function ze(e) {
        if (!e.clientId) throw new b("A clientId must be specified in the OktaAuth constructor to get a token");
        if (he(e.responseType) && -1 !== e.responseType.indexOf(" ")) throw new b("Multiple OAuth responseTypes must be defined as an array");
        var t = {
          client_id: e.clientId,
          code_challenge: e.codeChallenge,
          code_challenge_method: e.codeChallengeMethod,
          display: e.display,
          idp: e.idp,
          idp_scope: e.idpScope,
          login_hint: e.loginHint,
          max_age: e.maxAge,
          nonce: e.nonce,
          prompt: e.prompt,
          redirect_uri: e.redirectUri,
          response_mode: e.responseMode,
          response_type: e.responseType,
          sessionToken: e.sessionToken,
          state: e.state
        };
        if (t = M(t), ["idp_scope", "response_type"].forEach(function (e) {
          Array.isArray(t[e]) && (t[e] = t[e].join(" "));
        }), -1 !== e.responseType.indexOf("id_token") && -1 === e.scopes.indexOf("openid")) throw new b("openid scope must be specified in the scopes argument when requesting an id_token");
        return t.scope = e.scopes.join(" "), t;
      }
      function Je(e) {
        var t = ze(e);
        return we(Object.assign(Object.assign({}, t), e.extraParams && Object.assign({}, e.extraParams)));
      }
      function Ye(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function Xe(e, t) {
        if (e) {
          if ("string" == typeof e) return Ye(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ye(e, t) : void 0;
        }
      }
      function Qe(e, t, n) {
        !function (e) {
          if (!e.clientId) throw new b("A clientId must be specified in the OktaAuth constructor to get a token");
          if (!e.redirectUri) throw new b("The redirectUri passed to /authorize must also be passed to /token");
          if (!e.authorizationCode && !e.interactionCode) throw new b("An authorization code (returned from /authorize) must be passed to /token");
          if (!e.codeVerifier) throw new b('The "codeVerifier" (generated and saved by your app) must be passed to /token');
        }(t);
        var r = function (e, t) {
          var n = M({
            client_id: t.clientId,
            redirect_uri: t.redirectUri,
            grant_type: t.interactionCode ? "interaction_code" : "authorization_code",
            code_verifier: t.codeVerifier
          });
          t.interactionCode ? n.interaction_code = t.interactionCode : t.authorizationCode && (n.code = t.authorizationCode);
          var r = e.options.clientSecret;
          return r && (n.client_secret = r), we(n).slice(1);
        }(e, t);
        return Se(e, {
          url: n.tokenUrl,
          method: "POST",
          args: r,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
      }
      function Ze(e, t, n) {
        return Se(e, {
          url: n.tokenUrl,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          args: Object.entries({
            client_id: t.clientId,
            grant_type: "refresh_token",
            scope: n.scopes.join(" "),
            refresh_token: n.refreshToken
          }).map(function (e) {
            var t,
              n,
              r = (n = 2, function (e) {
                if (Array.isArray(e)) return e;
              }(t = e) || function (e, t) {
                var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != n) {
                  var r,
                    o,
                    i = [],
                    a = !0,
                    u = !1;
                  try {
                    for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
                  } catch (e) {
                    u = !0, o = e;
                  } finally {
                    try {
                      a || null == n.return || n.return();
                    } finally {
                      if (u) throw o;
                    }
                  }
                  return i;
                }
              }(t, n) || Xe(t, n) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }()),
              o = r[0],
              i = r[1];
            return o + "=" + encodeURIComponent(i);
          }).join("&")
        });
      }
      function et(e, t) {
        return Te(e, (t || e.options.issuer) + "/.well-known/openid-configuration", {
          cacheResponse: !0
        });
      }
      function tt(e, t, n) {
        var r = e.storageManager.getHttpCache(e.options.cookies);
        return et(e, t).then(function (t) {
          var o = t.jwks_uri,
            i = r.getStorage()[o];
          if (i && Date.now() / 1e3 < i.expiresAt) {
            var a = N(i.response.keys, {
              kid: n
            });
            if (a) return a;
          }
          return r.clearStorage(o), Te(e, o, {
            cacheResponse: !0
          }).then(function (e) {
            var t = N(e.keys, {
              kid: n
            });
            if (t) return t;
            throw new b("The key id, " + n + ", was not found in the server's keys");
          });
        });
      }
      function nt(e, t, n) {
        e.addEventListener ? e.addEventListener(t, n) : e.attachEvent("on" + t, n);
      }
      function rt(e, t, n) {
        e.removeEventListener ? e.removeEventListener(t, n) : e.detachEvent("on" + t, n);
      }
      function ot(e) {
        var t = document.createElement("iframe");
        return t.style.display = "none", t.src = e, document.body.appendChild(t);
      }
      function it(e, t) {
        var n = t.popupTitle || "External Identity Provider User Authentication";
        return window.open(e, n, "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600");
      }
      function at(e, t, n) {
        var r, o;
        return new Promise(function (i, a) {
          r = function (t) {
            if (t.data && t.data.state === n) return t.origin !== e.getIssuerOrigin() ? a(new b("The request does not match client configuration")) : void i(t.data);
          }, nt(window, "message", r), o = setTimeout(function () {
            a(new b("OAuth flow timed out"));
          }, t || 12e4);
        }).finally(function () {
          clearTimeout(o), rt(window, "message", r);
        });
      }
      function ut() {
        return Re(64);
      }
      function st() {
        return Re(64);
      }
      function ct(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = xe(t.issuer) || e.options.issuer;
        return n;
      }
      function ft(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = ct(e, t),
          r = n.indexOf("/oauth2") > 0 ? n : n + "/oauth2";
        return r;
      }
      function lt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = ct(e, t),
          r = n.split("/oauth2")[0];
        return r;
      }
      function pt(e, t) {
        if (arguments.length > 2) throw new b('As of version 3.0, "getOAuthUrls" takes only a single set of options');
        var n = xe((t = t || {}).authorizeUrl) || e.options.authorizeUrl,
          r = ct(e, t),
          o = xe(t.userinfoUrl) || e.options.userinfoUrl,
          i = xe(t.tokenUrl) || e.options.tokenUrl,
          a = xe(t.logoutUrl) || e.options.logoutUrl,
          u = xe(t.revokeUrl) || e.options.revokeUrl,
          s = ft(e, t);
        return {
          issuer: r,
          authorizeUrl: n = n || s + "/v1/authorize",
          userinfoUrl: o = o || s + "/v1/userinfo",
          tokenUrl: i = i || s + "/v1/token",
          revokeUrl: u = u || s + "/v1/revoke",
          logoutUrl: a = a || s + "/v1/logout"
        };
      }
      var ht,
        dt,
        vt,
        gt = /windows phone|iemobile|wpdesktop/i;
      function yt() {
        return "undefined" != typeof document && "undefined" != typeof window;
      }
      function mt() {
        return yt() && !!document.documentMode && document.documentMode <= 11;
      }
      function bt() {
        return navigator.userAgent;
      }
      function kt() {
        var e = bt();
        return e && !gt.test(e);
      }
      function wt() {
        if (!yt()) return !1;
        var e = document.documentMode && document.documentMode < 10;
        return !(!window.postMessage || e);
      }
      function xt() {
        return null != T && void 0 !== T.subtle && "undefined" != typeof Uint8Array;
      }
      function St() {
        return "undefined" != typeof TextEncoder;
      }
      function Tt() {
        return xt() && St();
      }
      function Ot() {
        return !!yt() && "https:" === window.location.protocol;
      }
      function At() {
        return yt() && "localhost" === window.location.hostname;
      }
      function Et(e) {
        var t = e.options,
          n = t.pkce,
          r = t.clientId,
          o = t.redirectUri,
          i = t.responseType,
          a = t.responseMode,
          u = t.scopes,
          s = t.state,
          c = t.ignoreSignature,
          f = yt() ? window.location.href : void 0;
        return M({
          pkce: n,
          clientId: r,
          redirectUri: o || f,
          responseType: i || ["token", "id_token"],
          responseMode: a,
          state: s || ut(),
          nonce: st(),
          scopes: u || ["openid", "email"],
          ignoreSignature: c
        });
      }
      function _t(e) {
        return "OAuthError" === e.name && "interaction_required" === e.errorCode;
      }
      function Rt(e, t) {
        if ("AuthApiError" !== t.name) return !1;
        var n = t.xhr,
          r = null == n ? void 0 : n.responseJSON;
        return e.options.pkce && "invalid_grant" === (null == r ? void 0 : r.error);
      }
      function Pt(e) {
        return /((id|access)_token=)/i.test(e);
      }
      function jt(e) {
        return /(code=)/i.test(e);
      }
      function It(e) {
        return /(interaction_code=)/i.test(e);
      }
      function Ct(e) {
        return /(error=)/i.test(e) || /(error_description)/i.test(e);
      }
      function Mt(e, t) {
        var n = t.options;
        return e && 0 === e.indexOf(n.redirectUri);
      }
      function Ut(e) {
        return e.pkce || "code" === e.responseType || "query" === e.responseMode;
      }
      function Ft(e) {
        return Ut(e) && "fragment" !== e.responseMode ? window.location.search : window.location.hash;
      }
      function Nt(e) {
        if (!Mt(window.location.href, e)) return !1;
        var t = Ut(e.options),
          n = Ft(e.options);
        return !!Ct(n) || (t ? jt(n) || It(n) : Pt(window.location.hash));
      }
      function Lt(e, t) {
        if (!t) {
          if (!Nt(e)) return !1;
          t = Ft(e.options);
        }
        return /(error=interaction_required)/i.test(t);
      }
      function Dt(e, t) {
        var n = Et(e);
        if (!1 === (t = Object.assign({}, n, U(t))).pkce) return Promise.resolve(t);
        if (!e.features.isPKCESupported()) {
          var r = "PKCE requires a modern browser with encryption support running in a secure context.";
          return e.features.isHTTPS() || (r += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e.features.hasTextEncoder() || (r += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), Promise.reject(new b(r));
        }
        return t.codeChallengeMethod || (t.codeChallengeMethod = fe), t.responseType = "code", et(e, null).then(function (e) {
          if (-1 === (e.code_challenge_methods_supported || []).indexOf(t.codeChallengeMethod)) throw new b("Invalid code_challenge_method");
        }).then(function () {
          return t.codeVerifier || (t.codeVerifier = He.generateVerifier()), He.computeChallenge(t.codeVerifier);
        }).then(function (e) {
          var n = U(t) || {};
          return Object.assign(n, t, {
            codeChallenge: e
          }), n;
        });
      }
      function Bt(e, t) {
        return e.refreshToken === t.refreshToken;
      }
      function qt(e) {
        return !(!w(e) || !e.xhr || !e.xhr.responseJSON || "invalid_grant" !== e.xhr.responseJSON.error);
      }
      function Ht(e) {
        var t = /\+/g,
          n = /([^&=]+)=?([^&]*)/g,
          r = e || "";
        "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));
        for (var o, i = {}; o = n.exec(r);) {
          var a = o[1],
            u = o[2];
          i[a] = "id_token" === a || "access_token" === a || "code" === a ? u : decodeURIComponent(u.replace(t, " "));
        }
        return i;
      }
      function Kt(e, t, n) {
        var r = n.clientId,
          o = n.issuer,
          i = n.nonce;
        if (!t || !o || !r) throw new b("The jwt, iss, and aud arguments are all required");
        if (i && t.nonce !== i) throw new b("OAuth flow response nonce doesn't match request nonce");
        var a = Math.floor(Date.now() / 1e3);
        if (t.iss !== o) throw new b("The issuer [" + t.iss + "] does not match [" + o + "]");
        if (t.aud !== r) throw new b("The audience [" + t.aud + "] does not match [" + r + "]");
        if (t.iat > t.exp) throw new b("The JWT expired before it was issued");
        if (!e.options.ignoreLifetime) {
          if (a - e.options.maxClockSkew > t.exp) throw new b("The JWT expired and is no longer valid");
          if (t.iat > a + e.options.maxClockSkew) throw new b("The JWT was issued in the future");
        }
      }
      function Vt(e) {
        return !(!e || "object" !== c(e) || 0 === Object.values(e).length);
      }
      function Gt(e) {
        return !(!Vt(e) || !e.redirectUri && !e.responseType);
      }
      function Wt(e) {
        return !!Gt(e) && !!e.codeVerifier;
      }
      function $t(e) {
        return !!Wt(e) && !!e.interactionHandle;
      }
      function zt(e) {
        return !!Vt(e) && void 0 === Object.values(e).find(function (e) {
          return "string" != typeof e;
        });
      }
      function Jt(e) {
        return !(!Gt(e) && !zt(e));
      }
      function Yt(e) {
        return !!(e && (e.accessToken || e.idToken || e.refreshToken) && Array.isArray(e.scopes));
      }
      function Xt(e) {
        return e && e.accessToken;
      }
      function Qt(e) {
        return e && e.idToken;
      }
      function Zt(e) {
        return e && e.refreshToken;
      }
      function en(e, t) {
        if (!Qt(e) && !Xt(e) && !Zt(e)) throw new b("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
        if ("accessToken" === t && !Xt(e)) throw new b("invalid accessToken");
        if ("idToken" === t && !Qt(e)) throw new b("invalid idToken");
        if ("refreshToken" === t && !Zt(e)) throw new b("invalid refreshToken");
      }
      function tn(e) {
        var t,
          n = e.split(".");
        try {
          t = {
            header: JSON.parse(_(n[0])),
            payload: JSON.parse(_(n[1])),
            signature: n[2]
          };
        } catch (e) {
          throw new b("Malformed token");
        }
        return t;
      }
      function nn(e, t) {
        return Promise.resolve().then(function () {
          var n, r;
          if (t && (n = t.accessToken, r = t.refreshToken), !n && !r) throw new b("A valid access or refresh token object is required");
          var o = e.options.clientId,
            i = e.options.clientSecret;
          if (!o) throw new b("A clientId must be specified in the OktaAuth constructor to revoke a token");
          var a = pt(e).revokeUrl,
            u = we({
              token_type_hint: r ? "refresh_token" : "access_token",
              token: r || n
            }).slice(1),
            s = S(i ? "".concat(o, ":").concat(i) : o);
          return Oe(e, a, u, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: "Basic " + s
            }
          });
        });
      }
      function rn(e, t, n) {
        n = n || pt(e, t);
        var r = t = Object.assign({}, Et(e), U(t)),
          o = r.authorizationCode,
          i = r.interactionCode,
          a = r.codeVerifier,
          u = r.clientId,
          s = r.redirectUri,
          c = r.scopes,
          f = r.ignoreSignature,
          l = r.state;
        return Qe(e, {
          clientId: u,
          redirectUri: s,
          authorizationCode: o,
          interactionCode: i,
          codeVerifier: a
        }, n).then(function (t) {
          var r = ["token"];
          return -1 !== c.indexOf("openid") && r.push("id_token"), an(e, {
            clientId: u,
            redirectUri: s,
            scopes: c,
            responseType: r,
            ignoreSignature: f
          }, t, n).then(function (e) {
            return e.code = o, e.state = l, e;
          });
        }).finally(function () {
          e.transactionManager.clear();
        });
      }
      !function (e) {
        e.SUCCESS = "SUCCESS", e.PENDING = "PENDING", e.FAILURE = "FAILURE", e.TERMINAL = "TERMINAL", e.CANCELED = "CANCELED";
      }(ht || (ht = {})), function (e) {
        e.OKTA_PASSWORD = "okta_password", e.OKTA_EMAIL = "okta_email", e.PHONE_NUMBER = "phone_number", e.GOOGLE_AUTHENTICATOR = "google_otp", e.SECURITY_QUESTION = "security_question", e.OKTA_VERIFY = "okta_verify";
      }(dt || (dt = {})), function (e) {
        e[e.PASSWORD_RECOVERY = 0] = "PASSWORD_RECOVERY", e[e.REGISTRATION = 1] = "REGISTRATION", e[e.SOCIAL_IDP = 2] = "SOCIAL_IDP";
      }(vt || (vt = {}));
      function on(e, t, n) {
        return r = this, o = void 0, i = void 0, a = K().mark(function r() {
          var o, i, a, u, s, c;
          return K().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                if (t && t.idToken) {
                  r.next = 2;
                  break;
                }
                throw new b("Only idTokens may be verified");
              case 2:
                return o = tn(t.idToken), i = (null == n ? void 0 : n.issuer) || e.options.issuer, r.next = 6, et(e, i);
              case 6:
                if (a = r.sent, u = a.issuer, s = Object.assign({
                  clientId: e.options.clientId,
                  ignoreSignature: e.options.ignoreSignature
                }, n, {
                  issuer: u
                }), Kt(e, o.payload, s), 1 != s.ignoreSignature && e.features.isTokenVerifySupported()) {
                  r.next = 12;
                  break;
                }
                return r.abrupt("return", t);
              case 12:
                return r.next = 14, tt(e, t.issuer, o.header.kid);
              case 14:
                return c = r.sent, r.next = 17, D(t.idToken, c);
              case 17:
                if (r.sent) {
                  r.next = 20;
                  break;
                }
                throw new b("The token signature is not valid");
              case 20:
                if (!(n && n.accessToken && t.claims.at_hash)) {
                  r.next = 26;
                  break;
                }
                return r.next = 23, j(n.accessToken);
              case 23:
                if (r.sent === t.claims.at_hash) {
                  r.next = 26;
                  break;
                }
                throw new b("Token hash verification failed");
              case 26:
                return r.abrupt("return", t);
              case 27:
              case "end":
                return r.stop();
            }
          }, r);
        }), new (i || (i = Promise))(function (e, t) {
          function n(e) {
            try {
              s(a.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(a.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var r;
            t.done ? e(t.value) : (r = t.value, r instanceof i ? r : new i(function (e) {
              e(r);
            })).then(n, u);
          }
          s((a = a.apply(r, o || [])).next());
        });
        var r, o, i, a;
      }
      function an(e, t, n, r) {
        if (!1 !== e.options.pkce && (n.code || n.interaction_code)) return rn(e, Object.assign({}, t, {
          authorizationCode: n.code,
          interactionCode: n.interaction_code
        }), r);
        t = t || Et(e), r = r || pt(e, t);
        var o,
          i = t.responseType;
        Array.isArray(i) || (i = [i]), o = n.scope ? n.scope.split(" ") : U(t.scopes);
        var a = t.clientId || e.options.clientId;
        return Promise.resolve().then(function () {
          !function (e, t) {
            if (e.error || e.error_description) throw new k(e.error, e.error_description);
            if (e.state !== t.state) throw new b("OAuth flow response state doesn't match request state");
          }(n, t);
        }).then(function () {
          var i = {},
            u = n.expires_in,
            s = n.token_type,
            c = n.access_token,
            f = n.id_token,
            l = n.refresh_token,
            p = Math.floor(Date.now() / 1e3);
          if (c) {
            var h = e.token.decode(c);
            i.accessToken = {
              accessToken: c,
              claims: h.payload,
              expiresAt: Number(u) + p,
              tokenType: s,
              scopes: o,
              authorizeUrl: r.authorizeUrl,
              userinfoUrl: r.userinfoUrl
            };
          }
          if (l && (i.refreshToken = {
            refreshToken: l,
            expiresAt: Number(u) + p,
            scopes: o,
            tokenUrl: r.tokenUrl,
            authorizeUrl: r.authorizeUrl,
            issuer: r.issuer
          }), f) {
            var d = e.token.decode(f),
              v = {
                idToken: f,
                claims: d.payload,
                expiresAt: d.payload.exp - d.payload.iat + p,
                scopes: o,
                authorizeUrl: r.authorizeUrl,
                issuer: r.issuer,
                clientId: a
              },
              g = {
                clientId: a,
                issuer: r.issuer,
                nonce: t.nonce,
                accessToken: c
              };
            return void 0 !== t.ignoreSignature && (g.ignoreSignature = t.ignoreSignature), on(e, v, g).then(function () {
              return i.idToken = v, i;
            });
          }
          return i;
        }).then(function (e) {
          if (-1 !== i.indexOf("token") && !e.accessToken) throw new b('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
          if (-1 !== i.indexOf("id_token") && !e.idToken) throw new b('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
          return {
            tokens: e,
            state: n.state,
            code: n.code
          };
        });
      }
      function un(e, t) {
        if (arguments.length > 2) return Promise.reject(new b('As of version 3.0, "getToken" takes only a single set of options'));
        var n = (t = t || {}).popupWindow;
        return t.popupWindow = void 0, Dt(e, t).then(function (r) {
          var o, i;
          switch (t.sessionToken ? Object.assign(r, {
            prompt: "none",
            responseMode: "okta_post_message",
            display: null
          }) : t.idp && Object.assign(r, {
            display: "popup"
          }), i = pt(e, r), o = (t.codeVerifier ? i.tokenUrl : i.authorizeUrl) + Je(r), r.sessionToken || null === r.display ? "IFRAME" : "popup" === r.display ? "POPUP" : "IMPLICIT") {
            case "IFRAME":
              var a = at(e, t.timeout, r.state),
                u = ot(o);
              return a.then(function (t) {
                return an(e, r, t, i);
              }).finally(function () {
                document.body.contains(u) && u.parentElement.removeChild(u);
              });
            case "POPUP":
              var s;
              if ("okta_post_message" === r.responseMode) {
                if (!e.features.isPopupPostMessageSupported()) throw new b("This browser doesn't have full postMessage support");
                s = at(e, t.timeout, r.state);
              }
              return n && n.location.assign(o), new Promise(function (e, t) {
                var r = setInterval(function () {
                  n && !n.closed || (clearInterval(r), t(new b("Unable to parse OAuth flow response")));
                }, 100);
                s.then(function (t) {
                  clearInterval(r), e(t);
                }).catch(function (e) {
                  clearInterval(r), t(e);
                });
              }).then(function (t) {
                return an(e, r, t, i);
              }).finally(function () {
                n && !n.closed && n.close();
              });
            default:
              throw new b("The full page redirect flow is not supported");
          }
        });
      }
      function sn(e, t) {
        return arguments.length > 2 ? Promise.reject(new b('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = U(t) || {}, Object.assign(t, {
          prompt: "none",
          responseMode: "okta_post_message",
          display: null
        }), un(e, t));
      }
      function cn(e, t, n) {
        return r = this, o = void 0, i = void 0, a = K().mark(function r() {
          var o, i, a, u, s, c, f;
          return K().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                if (o = e.options.clientId) {
                  r.next = 3;
                  break;
                }
                throw new b("A clientId must be specified in the OktaAuth constructor to renew tokens");
              case 3:
                return i = Object.assign({}, t, {
                  clientId: o
                }), r.next = 6, Ze(e, i, n);
              case 6:
                return a = r.sent, u = pt(e, t), r.next = 10, an(e, i, a, u);
              case 10:
                return s = r.sent, c = s.tokens, (f = c.refreshToken) && !Bt(f, n) && e.tokenManager.updateRefreshToken(f), r.abrupt("return", c);
              case 15:
              case "end":
                return r.stop();
            }
          }, r);
        }), new (i || (i = Promise))(function (e, t) {
          function n(e) {
            try {
              s(a.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(a.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var r;
            t.done ? e(t.value) : (r = t.value, r instanceof i ? r : new i(function (e) {
              e(r);
            })).then(n, u);
          }
          s((a = a.apply(r, o || [])).next());
        });
        var r, o, i, a;
      }
      function fn() {
        throw new b("Renew must be passed a token with an array of scopes and an accessToken or idToken");
      }
      function ln(e, t) {
        return Qt(e) ? t.idToken : Xt(e) ? t.accessToken : void fn();
      }
      function pn(e, t) {
        return n = this, r = void 0, o = void 0, i = K().mark(function n() {
          var r, o, i, a, u, s;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                if (Qt(t) || Xt(t) || fn(), !(r = e.tokenManager.getTokensSync()).refreshToken) {
                  n.next = 7;
                  break;
                }
                return n.next = 5, cn(e, {
                  scopes: t.scopes
                }, r.refreshToken);
              case 5:
                return r = n.sent, n.abrupt("return", ln(t, r));
              case 7:
                return o = e.options.pkce ? "code" : Xt(t) ? "token" : "id_token", i = t.scopes, a = t.authorizeUrl, u = t.userinfoUrl, s = t.issuer, n.abrupt("return", sn(e, {
                  responseType: o,
                  scopes: i,
                  authorizeUrl: a,
                  userinfoUrl: u,
                  issuer: s
                }).then(function (e) {
                  return ln(t, e.tokens);
                }));
              case 10:
              case "end":
                return n.stop();
            }
          }, n);
        }), new (o || (o = Promise))(function (e, t) {
          function a(e) {
            try {
              s(i.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(i.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function (e) {
              e(n);
            })).then(a, u);
          }
          s((i = i.apply(n, r || [])).next());
        });
        var n, r, o, i;
      }
      function hn(e, t) {
        return n = this, r = void 0, o = void 0, i = K().mark(function n() {
          var r, o, i, a, u, s, c, f, l;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                if (!(r = e.tokenManager.getTokensSync()).refreshToken) {
                  n.next = 3;
                  break;
                }
                return n.abrupt("return", cn(e, t, r.refreshToken));
              case 3:
                if (r.accessToken || r.idToken) {
                  n.next = 5;
                  break;
                }
                throw new b("renewTokens() was called but there is no existing token");
              case 5:
                if (o = r.accessToken || {}, i = r.idToken || {}, a = o.scopes || i.scopes) {
                  n.next = 10;
                  break;
                }
                throw new b("renewTokens: invalid tokens: could not read scopes");
              case 10:
                if (u = o.authorizeUrl || i.authorizeUrl) {
                  n.next = 13;
                  break;
                }
                throw new b("renewTokens: invalid tokens: could not read authorizeUrl");
              case 13:
                return s = o.userinfoUrl || e.options.userinfoUrl, c = i.issuer || e.options.issuer, t = Object.assign({
                  scopes: a,
                  authorizeUrl: u,
                  userinfoUrl: s,
                  issuer: c
                }, t), e.options.pkce ? t.responseType = "code" : (f = Et(e), l = f.responseType, t.responseType = l), n.abrupt("return", sn(e, t).then(function (e) {
                  return e.tokens;
                }));
              case 18:
              case "end":
                return n.stop();
            }
          }, n);
        }), new (o || (o = Promise))(function (e, t) {
          function a(e) {
            try {
              s(i.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(i.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function (e) {
              e(n);
            })).then(a, u);
          }
          s((i = i.apply(n, r || [])).next());
        });
        var n, r, o, i;
      }
      function dn(e, t, n) {
        return r = this, o = void 0, i = void 0, a = K().mark(function r() {
          return K().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                if (t) {
                  r.next = 4;
                  break;
                }
                return r.next = 3, e.tokenManager.getTokens();
              case 3:
                t = r.sent.accessToken;
              case 4:
                if (n) {
                  r.next = 8;
                  break;
                }
                return r.next = 7, e.tokenManager.getTokens();
              case 7:
                n = r.sent.idToken;
              case 8:
                if (t && Xt(t)) {
                  r.next = 10;
                  break;
                }
                return r.abrupt("return", Promise.reject(new b("getUserInfo requires an access token object")));
              case 10:
                if (n && Qt(n)) {
                  r.next = 12;
                  break;
                }
                return r.abrupt("return", Promise.reject(new b("getUserInfo requires an ID token object")));
              case 12:
                return r.abrupt("return", Se(e, {
                  url: t.userinfoUrl,
                  method: "GET",
                  accessToken: t.accessToken
                }).then(function (e) {
                  return e.sub === n.claims.sub ? e : Promise.reject(new b("getUserInfo request was rejected due to token mismatch"));
                }).catch(function (e) {
                  var t;
                  if (e.xhr && (401 === e.xhr.status || 403 === e.xhr.status) && (e.xhr.headers && ge(e.xhr.headers.get) && e.xhr.headers.get("WWW-Authenticate") ? t = e.xhr.headers.get("WWW-Authenticate") : ge(e.xhr.getResponseHeader) && (t = e.xhr.getResponseHeader("WWW-Authenticate")), t)) {
                    var n = t.match(/error="(.*?)"/) || [],
                      r = t.match(/error_description="(.*?)"/) || [],
                      o = n[1],
                      i = r[1];
                    o && i && (e = new k(o, i));
                  }
                  throw e;
                }));
              case 13:
              case "end":
                return r.stop();
            }
          }, r);
        }), new (i || (i = Promise))(function (e, t) {
          function n(e) {
            try {
              s(a.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(a.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var r;
            t.done ? e(t.value) : (r = t.value, r instanceof i ? r : new i(function (e) {
              e(r);
            })).then(n, u);
          }
          s((a = a.apply(r, o || [])).next());
        });
        var r, o, i, a;
      }
      function vn(e, t) {
        if (arguments.length > 2) return Promise.reject(new b('As of version 3.0, "getWithPopup" takes only a single set of options'));
        var n = it("/", t);
        return t = U(t) || {}, Object.assign(t, {
          display: "popup",
          responseMode: "okta_post_message",
          popupWindow: n
        }), un(e, t);
      }
      function gn(e, t) {
        return arguments.length > 2 ? Promise.reject(new b('As of version 3.0, "getWithRedirect" takes only a single set of options')) : (t = U(t) || {}, Dt(e, t).then(function (n) {
          var r = pt(e, t),
            o = r.authorizeUrl + Je(n),
            i = {
              issuer: e.options.issuer,
              responseType: n.responseType,
              state: n.state,
              nonce: n.nonce,
              scopes: n.scopes,
              clientId: n.clientId,
              urls: r,
              ignoreSignature: n.ignoreSignature,
              redirectUri: n.redirectUri,
              codeVerifier: n.codeVerifier,
              codeChallenge: n.codeChallenge,
              codeChallengeMethod: n.codeChallengeMethod
            };
          e.transactionManager.save(i, {
            oauth: !0
          }), e.token.getWithRedirect._setLocation(o);
        }));
      }
      function yn(e) {
        var t = e.options.pkce ? "query" : "fragment";
        return e.options.responseMode || t;
      }
      function mn(e, t) {
        var n,
          r = (t = he(t = t || {}) ? {
            url: t
          } : t).url,
          o = t.responseMode || yn(e),
          i = e.token.parseFromUrl._getLocation();
        if (!(n = "query" === o ? r ? r.substring(r.indexOf("?")) : i.search : r ? r.substring(r.indexOf("#")) : i.hash)) throw new b("Unable to parse a token from the url");
        return Ht(n);
      }
      function bn(e, t) {
        "query" === (t.responseMode || yn(e)) ? function (e) {
          var t = e.token.parseFromUrl._getHistory(),
            n = e.token.parseFromUrl._getDocument(),
            r = e.token.parseFromUrl._getLocation();
          t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
        }(e) : function (e) {
          var t = e.token.parseFromUrl._getHistory(),
            n = e.token.parseFromUrl._getDocument(),
            r = e.token.parseFromUrl._getLocation();
          t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
        }(e);
      }
      function kn(e, t) {
        return n = this, r = void 0, o = void 0, i = K().mark(function n() {
          var r, o, i, a;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                if (t = he(t = t || {}) ? {
                  url: t
                } : t, r = mn(e, t), o = r.state, i = e.transactionManager.load({
                  oauth: !0,
                  pkce: e.options.pkce,
                  state: o
                })) {
                  n.next = 7;
                  break;
                }
                return n.abrupt("return", Promise.reject(new b("Unable to retrieve OAuth redirect params from storage")));
              case 7:
                return a = i.urls, delete i.urls, t.url || bn(e, t), n.abrupt("return", an(e, i, r, a).catch(function (t) {
                  throw _t(t) || e.transactionManager.clear({
                    state: o
                  }), t;
                }).then(function (t) {
                  return e.transactionManager.clear({
                    state: o
                  }), t;
                }));
              case 11:
              case "end":
                return n.stop();
            }
          }, n);
        }), new (o || (o = Promise))(function (e, t) {
          function a(e) {
            try {
              s(i.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(i.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function (e) {
              e(n);
            })).then(a, u);
          }
          s((i = i.apply(n, r || [])).next());
        });
        var n, r, o, i;
      }
      function wn() {
        return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
      }
      function xn() {
        var e = wn();
        return e && e.log ? e : {
          log: function () {},
          warn: function () {},
          group: function () {},
          groupEnd: function () {}
        };
      }
      function Sn(e) {
        xn().warn("[okta-auth-sdk] WARN: " + e);
      }
      function Tn(e) {
        xn().warn("[okta-auth-sdk] DEPRECATION: " + e);
      }
      function On(e, t) {
        return function () {
          return Tn(e), t.apply(null, arguments);
        };
      }
      var An = n(6808),
        En = {
          getHttpCache: function () {
            return null;
          },
          getPKCEStorage: function () {
            return null;
          },
          browserHasLocalStorage: function () {
            try {
              var e = En.getLocalStorage();
              return En.testStorage(e);
            } catch (e) {
              return !1;
            }
          },
          browserHasSessionStorage: function () {
            try {
              var e = En.getSessionStorage();
              return En.testStorage(e);
            } catch (e) {
              return !1;
            }
          },
          testStorageType: function (e) {
            var t = !1;
            switch (e) {
              case "sessionStorage":
                t = En.browserHasSessionStorage();
                break;
              case "localStorage":
                t = En.browserHasLocalStorage();
                break;
              case "cookie":
              case "memory":
                t = !0;
                break;
              default:
                t = !1;
            }
            return t;
          },
          getStorageByType: function (e, t) {
            var n = null;
            switch (e) {
              case "sessionStorage":
                n = En.getSessionStorage();
                break;
              case "localStorage":
                n = En.getLocalStorage();
                break;
              case "cookie":
                n = En.getCookieStorage(t);
                break;
              case "memory":
                n = En.getInMemoryStorage();
                break;
              default:
                throw new b("Unrecognized storage option: ".concat(e));
            }
            return n;
          },
          findStorageType: function (e) {
            var t, n;
            return t = (e = e.slice()).shift(), (n = e.length ? e[0] : null) ? En.testStorageType(t) ? t : (Sn("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), En.findStorageType(e)) : t;
          },
          getLocalStorage: function () {
            return localStorage;
          },
          getSessionStorage: function () {
            return sessionStorage;
          },
          getCookieStorage: function (e) {
            var t = e.secure,
              n = e.sameSite,
              r = e.sessionCookie;
            if (void 0 === t || void 0 === n) throw new b('getCookieStorage: "secure" and "sameSite" options must be provided');
            var o = {
              getItem: En.storage.get,
              setItem: function (e, o) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "2200-01-01T00:00:00.000Z";
                i = r ? null : i, En.storage.set(e, o, i, {
                  secure: t,
                  sameSite: n
                });
              },
              removeItem: function (e) {
                En.storage.delete(e);
              }
            };
            return e.useMultipleCookies ? {
              getItem: function (e) {
                var t = o.getItem(),
                  n = {};
                return Object.keys(t).forEach(function (r) {
                  0 === r.indexOf(e) && (n[r.replace("".concat(e, "_"), "")] = JSON.parse(t[r]));
                }), JSON.stringify(n);
              },
              setItem: function (e, t) {
                var n = JSON.parse(this.getItem(e));
                t = JSON.parse(t), Object.keys(t).forEach(function (r) {
                  var i = e + "_" + r,
                    a = JSON.stringify(t[r]);
                  o.setItem(i, a), delete n[r];
                }), Object.keys(n).forEach(function (t) {
                  o.removeItem(e + "_" + t);
                });
              },
              removeItem: function (e) {
                var t = JSON.parse(this.getItem(e));
                Object.keys(t).forEach(function (t) {
                  o.removeItem(e + "_" + t);
                });
              }
            } : o;
          },
          inMemoryStore: {},
          getInMemoryStorage: function () {
            var e = this;
            return {
              getItem: function (t) {
                return e.inMemoryStore[t];
              },
              setItem: function (t, n) {
                e.inMemoryStore[t] = n;
              }
            };
          },
          testStorage: function (e) {
            var t = "okta-test-storage";
            try {
              return e.setItem(t, t), e.removeItem(t), !0;
            } catch (e) {
              return !1;
            }
          },
          storage: {
            set: function (e, t, n, r) {
              var o = r.sameSite,
                i = r.secure;
              if (void 0 === i || void 0 === o) throw new b('storage.set: "secure" and "sameSite" options must be provided');
              var a = {
                path: r.path || "/",
                secure: i,
                sameSite: o
              };
              return Date.parse(n) && (a.expires = new Date(n)), An.set(e, t, a), En.storage.get(e);
            },
            get: function (e) {
              return An.get(e);
            },
            delete: function (e) {
              return An.remove(e, {
                path: "/"
              });
            }
          }
        },
        _n = En;
      function Rn(e) {
        return /(stateTokenExternalId=)/i.test(e) && /(state=)/i.test(e);
      }
      function Pn(e) {
        return Ht(e);
      }
      function jn(e) {
        var t = (e = e || {}).scopes;
        if (t && !Array.isArray(t)) throw new b('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
        var n = e.issuer;
        if (!n) throw new b('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
        if (!new RegExp("^http?s?://.+").test(e.issuer)) throw new b('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
        if (-1 !== n.indexOf("-admin.")) throw new b('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
      }
      function In(e, t) {
        var n = e.userAgent || {};
        return n.value ? n.value : n.template ? n.template.replace("$OKTA_AUTH_JS", t) : t;
      }
      var Cn = function () {
          function e(t) {
            a(this, e), this.localOffset = parseInt(t || 0);
          }
          return q(e, [{
            key: "now",
            value: function () {
              return (Date.now() + this.localOffset) / 1e3;
            }
          }], [{
            key: "create",
            value: function () {
              return new e(0);
            }
          }]), e;
        }(),
        Mn = function () {
          function e(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            a(this, e), this.tokenManager = t, this.options = n;
          }
          return q(e, [{
            key: "start",
            value: function () {
              var e = this,
                t = [];
              this.onTokenExpiredHandler = function (n) {
                if (e.options.autoRenew) {
                  if (function (e) {
                    var t = !1;
                    if (e.push(Date.now()), e.length >= 10) {
                      var n = e.shift();
                      t = e[e.length - 1] - n < 3e4;
                    }
                    return t;
                  }(t)) {
                    var r = new b("Too many token renew requests");
                    e.tokenManager.emitError(r);
                  } else e.tokenManager.renew(n).catch(function () {});
                } else e.options.autoRemove && e.tokenManager.remove(n);
              }, this.tokenManager.on(Nn, this.onTokenExpiredHandler), this.tokenManager.setExpireEventTimeoutAll(), this.options.syncStorage && yt() && (this.storageListener = function (t) {
                var n = t.key,
                  r = t.newValue,
                  o = t.oldValue;
                (!n || n === e.options.storageKey && r !== o) && (e.syncTimeout = setTimeout(function () {
                  return e.tokenManager.resetExpireEventTimeoutAll(), void e.tokenManager.emitEventsForCrossTabsStorageUpdate(r, o);
                }, e.options._storageEventDelay));
              }, window.addEventListener("storage", this.storageListener));
            }
          }, {
            key: "stop",
            value: function () {
              this.tokenManager.clearExpireEventTimeoutAll(), this.tokenManager.off(Nn, this.onTokenExpiredHandler), this.options.syncStorage && yt() && (window.removeEventListener("storage", this.storageListener), clearTimeout(this.syncTimeout));
            }
          }]), e;
        }(),
        Un = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                s(r.next(e));
              } catch (e) {
                i(e);
              }
            }
            function u(e) {
              try {
                s(r.throw(e));
              } catch (e) {
                i(e);
              }
            }
            function s(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, u);
            }
            s((r = r.apply(e, t || [])).next());
          });
        },
        Fn = {
          autoRenew: !0,
          autoRemove: !0,
          clearPendingRemoveTokens: !0,
          storage: void 0,
          expireEarlySeconds: 30,
          storageKey: X,
          syncStorage: !0,
          _storageEventDelay: 0
        },
        Nn = "expired",
        Ln = "renewed",
        Dn = "added",
        Bn = "removed",
        qn = "error",
        Hn = function () {
          function e(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (a(this, e), this.sdk = t, this.emitter = t.emitter, !this.emitter) throw new b("Emitter should be initialized before TokenManager");
            n = Object.assign({}, Fn, M(n)), mt() && (n._storageEventDelay = n._storageEventDelay || 1e3), At() || (n.expireEarlySeconds = Fn.expireEarlySeconds), this.options = n;
            var r = M({
              storageKey: n.storageKey,
              secure: n.secure
            });
            "object" === c(n.storage) ? r.storageProvider = n.storage : n.storage && (r.storageType = n.storage), this.storage = t.storageManager.getTokenStorage(r), this.clock = Cn.create(), this.state = {
              expireTimeouts: {},
              renewPromise: null
            }, this.on = this.emitter.on.bind(this.emitter), this.off = this.emitter.off.bind(this.emitter);
          }
          return q(e, [{
            key: "start",
            value: function () {
              this.service && this.stop(), this.options.clearPendingRemoveTokens && this.clearPendingRemoveTokens(), this.service = new Mn(this, this.getOptions()), this.service.start();
            }
          }, {
            key: "stop",
            value: function () {
              this.service && (this.service.stop(), this.service = null);
            }
          }, {
            key: "getOptions",
            value: function () {
              return U(this.options);
            }
          }, {
            key: "getExpireTime",
            value: function (e) {
              return e.expiresAt - this.options.expireEarlySeconds;
            }
          }, {
            key: "hasExpired",
            value: function (e) {
              return this.getExpireTime(e) <= this.clock.now();
            }
          }, {
            key: "emitExpired",
            value: function (e, t) {
              this.emitter.emit(Nn, e, t);
            }
          }, {
            key: "emitRenewed",
            value: function (e, t, n) {
              this.emitter.emit(Ln, e, t, n);
            }
          }, {
            key: "emitAdded",
            value: function (e, t) {
              this.emitter.emit(Dn, e, t);
            }
          }, {
            key: "emitRemoved",
            value: function (e, t) {
              this.emitter.emit(Bn, e, t);
            }
          }, {
            key: "emitError",
            value: function (e) {
              this.emitter.emit(qn, e);
            }
          }, {
            key: "emitEventsForCrossTabsStorageUpdate",
            value: function (e, t) {
              var n = this,
                r = this.getTokensFromStorageValue(t),
                o = this.getTokensFromStorageValue(e);
              Object.keys(o).forEach(function (e) {
                var t = r[e],
                  i = o[e];
                JSON.stringify(t) !== JSON.stringify(i) && n.emitAdded(e, i);
              }), Object.keys(r).forEach(function (e) {
                var t = r[e];
                o[e] || n.emitRemoved(e, t);
              });
            }
          }, {
            key: "clearExpireEventTimeout",
            value: function (e) {
              clearTimeout(this.state.expireTimeouts[e]), delete this.state.expireTimeouts[e], this.state.renewPromise = null;
            }
          }, {
            key: "clearExpireEventTimeoutAll",
            value: function () {
              var e = this.state.expireTimeouts;
              for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && this.clearExpireEventTimeout(t);
            }
          }, {
            key: "setExpireEventTimeout",
            value: function (e, t) {
              var n = this;
              if (!Zt(t)) {
                var r = this.getExpireTime(t),
                  o = 1e3 * Math.max(r - this.clock.now(), 0);
                this.clearExpireEventTimeout(e);
                var i = setTimeout(function () {
                  n.emitExpired(e, t);
                }, o);
                this.state.expireTimeouts[e] = i;
              }
            }
          }, {
            key: "setExpireEventTimeoutAll",
            value: function () {
              var e = this.storage.getStorage();
              for (var t in e) if (Object.prototype.hasOwnProperty.call(e, t)) {
                var n = e[t];
                this.setExpireEventTimeout(t, n);
              }
            }
          }, {
            key: "resetExpireEventTimeoutAll",
            value: function () {
              this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
            }
          }, {
            key: "add",
            value: function (e, t) {
              var n = this.storage.getStorage();
              en(t), n[e] = t, this.storage.setStorage(n), this.emitAdded(e, t), this.setExpireEventTimeout(e, t);
            }
          }, {
            key: "getSync",
            value: function (e) {
              return this.storage.getStorage()[e];
            }
          }, {
            key: "get",
            value: function (e) {
              return Un(this, void 0, void 0, K().mark(function t() {
                return K().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return t.abrupt("return", this.getSync(e));
                    case 1:
                    case "end":
                      return t.stop();
                  }
                }, t, this);
              }));
            }
          }, {
            key: "getTokensSync",
            value: function () {
              var e = {},
                t = this.storage.getStorage();
              return Object.keys(t).forEach(function (n) {
                var r = t[n];
                Xt(r) ? e.accessToken = r : Qt(r) ? e.idToken = r : Zt(r) && (e.refreshToken = r);
              }), e;
            }
          }, {
            key: "getTokens",
            value: function () {
              return Un(this, void 0, void 0, K().mark(function e() {
                return K().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", this.getTokensSync());
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }, e, this);
              }));
            }
          }, {
            key: "getStorageKeyByType",
            value: function (e) {
              var t = this.storage.getStorage();
              return Object.keys(t).filter(function (n) {
                var r = t[n];
                return Xt(r) && "accessToken" === e || Qt(r) && "idToken" === e || Zt(r) && "refreshToken" === e;
              })[0];
            }
          }, {
            key: "getTokenType",
            value: function (e) {
              if (Xt(e)) return "accessToken";
              if (Qt(e)) return "idToken";
              if (Zt(e)) return "refreshToken";
              throw new b("Unknown token type");
            }
          }, {
            key: "setTokens",
            value: function (e, t, n, r) {
              var o = this,
                i = function (e, i) {
                  var a = o.getTokenType(i);
                  "accessToken" === a ? t && t(e, i) : "idToken" === a ? n && n(e, i) : "refreshToken" === a && r && r(e, i);
                },
                a = function (e, t) {
                  o.emitAdded(e, t), o.setExpireEventTimeout(e, t), i(e, t);
                },
                u = function (e, t) {
                  o.clearExpireEventTimeout(e), o.emitRemoved(e, t), i(e, t);
                },
                s = ["idToken", "accessToken", "refreshToken"],
                c = this.getTokensSync();
              s.forEach(function (t) {
                var n = e[t];
                n && en(n, t);
              });
              var f = s.reduce(function (t, n) {
                var r = e[n];
                return r && (t[o.getStorageKeyByType(n) || n] = r), t;
              }, {});
              this.storage.setStorage(f), s.forEach(function (t) {
                var n,
                  r,
                  s,
                  f = e[t],
                  l = c[t],
                  p = o.getStorageKeyByType(t) || t;
                f && l ? (u(p, l), a(p, f), n = p, r = f, s = l, o.emitRenewed(n, r, s), o.clearExpireEventTimeout(n), o.setExpireEventTimeout(n, r), i(n, r)) : f ? a(p, f) : l && u(p, l);
              });
            }
          }, {
            key: "remove",
            value: function (e) {
              this.clearExpireEventTimeout(e);
              var t = this.storage.getStorage(),
                n = t[e];
              delete t[e], this.storage.setStorage(t), this.emitRemoved(e, n);
            }
          }, {
            key: "renewToken",
            value: function (e) {
              return Un(this, void 0, void 0, K().mark(function t() {
                return K().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return t.abrupt("return", this.sdk.token.renew(e));
                    case 1:
                    case "end":
                      return t.stop();
                  }
                }, t, this);
              }));
            }
          }, {
            key: "validateToken",
            value: function (e) {
              return en(e);
            }
          }, {
            key: "renew",
            value: function (e) {
              var t = this;
              if (this.state.renewPromise) return this.state.renewPromise;
              try {
                var n = this.getSync(e);
                if (!n) throw new b("The tokenManager has no token for the key: " + e);
              } catch (e) {
                return Promise.reject(e);
              }
              return this.clearExpireEventTimeout(e), this.state.renewPromise = this.sdk.token.renewTokens().then(function (e) {
                return t.setTokens(e), e[t.getTokenType(n)];
              }).catch(function (n) {
                throw (qt(n) || "OAuthError" === n.name || "AuthSdkError" === n.name) && t.remove(e), n.tokenKey = e, t.emitError(n), n;
              }).finally(function () {
                t.state.renewPromise = null;
              }), this.state.renewPromise;
            }
          }, {
            key: "clear",
            value: function () {
              this.clearExpireEventTimeoutAll(), this.storage.clearStorage();
            }
          }, {
            key: "clearPendingRemoveTokens",
            value: function () {
              var e = this,
                t = this.getTokensSync();
              Object.keys(t).forEach(function (n) {
                t[n].pendingRemove && e.remove(n);
              });
            }
          }, {
            key: "getTokensFromStorageValue",
            value: function (e) {
              var t;
              try {
                t = JSON.parse(e) || {};
              } catch (e) {
                t = {};
              }
              return t;
            }
          }, {
            key: "updateRefreshToken",
            value: function (e) {
              var t = this.getStorageKeyByType("refreshToken") || ae,
                n = this.storage.getStorage();
              en(e), n[t] = e, this.storage.setStorage(n);
            }
          }, {
            key: "addPendingRemoveFlags",
            value: function () {
              var e = this.getTokensSync();
              Object.keys(e).forEach(function (t) {
                e[t].pendingRemove = !0;
              }), this.setTokens(e);
            }
          }]), e;
        }(),
        Kn = function () {
          function e() {
            a(this, e), this.queue = [], this.running = !1;
          }
          return q(e, [{
            key: "push",
            value: function (e, t) {
              for (var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) o[i - 2] = arguments[i];
              return new Promise(function (r, i) {
                n.queue.push({
                  method: e,
                  thisObject: t,
                  args: o,
                  resolve: r,
                  reject: i
                }), n.run();
              });
            }
          }, {
            key: "run",
            value: function () {
              var e = this;
              if (!this.running && 0 !== this.queue.length) {
                this.running = !0;
                var t = this.queue.shift(),
                  n = t.method.apply(t.thisObject, t.args);
                ye(n) ? n.then(t.resolve, t.reject).finally(function () {
                  e.running = !1, e.run();
                }) : (t.resolve(n), this.running = !1, this.run());
              }
            }
          }]), e;
        }(),
        Vn = Kn;
      function Gn(e, t) {
        return t = t || {}, kt() ? new Promise(function (i, a) {
          (r = document.createElement("iframe")).style.display = "none", o = function (t) {
            if (t && t.data && t.origin === e.getIssuerOrigin()) {
              try {
                var n = JSON.parse(t.data);
              } catch (e) {
                return;
              }
              if (n) return "FingerprintAvailable" === n.type ? i(n.fingerprint) : void ("FingerprintServiceReady" === n.type && t.source.postMessage(JSON.stringify({
                type: "GetFingerprint"
              }), t.origin));
            }
          }, nt(window, "message", o), r.src = e.getIssuerOrigin() + "/auth/services/devicefingerprint", document.body.appendChild(r), n = setTimeout(function () {
            a(new b("Fingerprinting timed out"));
          }, t.timeout || 15e3);
        }).finally(function () {
          clearTimeout(n), rt(window, "message", o), document.body.contains(r) && r.parentElement.removeChild(r);
        }) : Promise.reject(new b("Fingerprinting is not supported on this device"));
        var n, r, o;
      }
      var Wn = n(3615),
        $n = null,
        zn = {
          updateAuthStatePromise: null,
          canceledTimes: 0
        },
        Jn = "authStateChange",
        Yn = function () {
          function e(t) {
            var n = this;
            if (a(this, e), !t.emitter) throw new b("Emitter should be initialized before AuthStateManager");
            this._sdk = t, this._pending = Object.assign({}, zn), this._authState = $n, this._logOptions = {}, t.tokenManager.on(Dn, function (e, t) {
              n._setLogOptions({
                event: Dn,
                key: e,
                token: t
              }), n.updateAuthState();
            }), t.tokenManager.on(Bn, function (e, t) {
              n._setLogOptions({
                event: Bn,
                key: e,
                token: t
              }), n.updateAuthState();
            });
          }
          return q(e, [{
            key: "_setLogOptions",
            value: function (e) {
              this._logOptions = e;
            }
          }, {
            key: "getAuthState",
            value: function () {
              return this._authState;
            }
          }, {
            key: "getPreviousAuthState",
            value: function () {
              return this._prevAuthState;
            }
          }, {
            key: "updateAuthState",
            value: function () {
              return e = this, t = void 0, n = void 0, r = K().mark(function e() {
                var t,
                  n,
                  r,
                  o,
                  i,
                  a,
                  u,
                  s = this;
                return K().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (t = this._sdk.options, n = t.transformAuthState, r = t.devMode, o = function (e) {
                        var t = s._logOptions,
                          n = t.event,
                          r = t.key,
                          o = t.token;
                        xn().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n, " Status:").concat(e)), xn().log(r, o), xn().log("Current authState", s._authState), xn().groupEnd(), s._logOptions = {};
                      }, i = function (e) {
                        var t, n;
                        n = e, (t = s._authState) && t.isAuthenticated === n.isAuthenticated && JSON.stringify(t.idToken) === JSON.stringify(n.idToken) && JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) && t.error === n.error ? r && o("unchanged") : (s._prevAuthState = s._authState, s._authState = e, s._sdk.emitter.emit(Jn, Object.assign({}, e)), r && o("emitted"));
                      }, a = function e(t) {
                        return s._pending.updateAuthStatePromise.then(function () {
                          var n = s._pending.updateAuthStatePromise;
                          return n && n !== t ? e(n) : s.getAuthState();
                        });
                      }, !this._pending.updateAuthStatePromise) {
                        e.next = 11;
                        break;
                      }
                      if (!(this._pending.canceledTimes >= 10)) {
                        e.next = 10;
                        break;
                      }
                      return r && o("terminated"), e.abrupt("return", a(this._pending.updateAuthStatePromise));
                    case 10:
                      this._pending.updateAuthStatePromise.cancel();
                    case 11:
                      return u = new Wn(function (e, t, a) {
                        a.shouldReject = !1, a(function () {
                          s._pending.updateAuthStatePromise = null, s._pending.canceledTimes = s._pending.canceledTimes + 1, r && o("canceled");
                        });
                        var c = function (t) {
                          u.isCanceled ? e() : (i(t), e(), s._pending = Object.assign({}, zn));
                        };
                        s._sdk.isAuthenticated().then(function () {
                          if (u.isCanceled) e();else {
                            var t = s._sdk.tokenManager.getTokensSync(),
                              r = t.accessToken,
                              o = t.idToken,
                              i = t.refreshToken,
                              a = {
                                accessToken: r,
                                idToken: o,
                                refreshToken: i,
                                isAuthenticated: !(!r || !o)
                              };
                            (n ? n(s._sdk, a) : Promise.resolve(a)).then(function (e) {
                              return c(e);
                            }).catch(function (e) {
                              return c({
                                accessToken: r,
                                idToken: o,
                                refreshToken: i,
                                isAuthenticated: !1,
                                error: e
                              });
                            });
                          }
                        });
                      }), this._pending.updateAuthStatePromise = u, e.abrupt("return", a(u));
                    case 14:
                    case "end":
                      return e.stop();
                  }
                }, e, this);
              }), new (n || (n = Promise))(function (o, i) {
                function a(e) {
                  try {
                    s(r.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function u(e) {
                  try {
                    s(r.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function s(e) {
                  var t;
                  e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                    e(t);
                  })).then(a, u);
                }
                s((r = r.apply(e, t || [])).next());
              });
              var e, t, n, r;
            }
          }, {
            key: "subscribe",
            value: function (e) {
              this._sdk.emitter.on(Jn, e);
            }
          }, {
            key: "unsubscribe",
            value: function (e) {
              this._sdk.emitter.off(Jn, e);
            }
          }]), e;
        }(),
        Xn = function () {
          function e(t, n) {
            if (a(this, e), !t) throw new b('"storage" is required');
            if ("string" != typeof n || !n.length) throw new b('"storageName" is required');
            this.storageName = n, this.storageProvider = t;
          }
          return q(e, [{
            key: "getItem",
            value: function (e) {
              return this.getStorage()[e];
            }
          }, {
            key: "setItem",
            value: function (e, t) {
              return this.updateStorage(e, t);
            }
          }, {
            key: "removeItem",
            value: function (e) {
              return this.clearStorage(e);
            }
          }, {
            key: "getStorage",
            value: function () {
              var e = this.storageProvider.getItem(this.storageName);
              e = e || "{}";
              try {
                return JSON.parse(e);
              } catch (e) {
                throw new b("Unable to parse storage string: " + this.storageName);
              }
            }
          }, {
            key: "setStorage",
            value: function (e) {
              try {
                var t = e ? JSON.stringify(e) : "{}";
                this.storageProvider.setItem(this.storageName, t);
              } catch (e) {
                throw new b("Unable to set storage: " + this.storageName);
              }
            }
          }, {
            key: "clearStorage",
            value: function (e) {
              if (e) {
                var t = this.getStorage();
                delete t[e], this.setStorage(t);
              } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
            }
          }, {
            key: "updateStorage",
            value: function (e, t) {
              var n = this.getStorage();
              n[e] = t, this.setStorage(n);
            }
          }]), e;
        }();
      function Qn(e) {
        yt() || e.storageProvider || e.storageProvider || Sn("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.");
      }
      var Zn = function () {
        function e(t, n, r) {
          a(this, e), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = r;
        }
        return q(e, [{
          key: "getOptionsForSection",
          value: function (e, t) {
            return Object.assign({}, this.storageManagerOptions[e], t);
          }
        }, {
          key: "getStorage",
          value: function (e) {
            if ((e = Object.assign({}, this.cookieOptions, e)).storageProvider) return e.storageProvider;
            var t = e,
              n = t.storageType,
              r = t.storageTypes;
            if ("sessionStorage" === n && (e.sessionCookie = !0), n && r) {
              var o = r.indexOf(n);
              o >= 0 && (r = r.slice(o), n = null);
            }
            return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e);
          }
        }, {
          key: "getTransactionStorage",
          value: function (e) {
            Qn(e = this.getOptionsForSection("transaction", e));
            var t = this.getStorage(e),
              n = e.storageKey || ee;
            return new Xn(t, n);
          }
        }, {
          key: "getSharedTansactionStorage",
          value: function (e) {
            Qn(e = this.getOptionsForSection("shared-transaction", e));
            var t = this.getStorage(e),
              n = e.storageKey || te;
            return new Xn(t, n);
          }
        }, {
          key: "getOriginalUriStorage",
          value: function (e) {
            Qn(e = this.getOptionsForSection("original-uri", e));
            var t = this.getStorage(e),
              n = e.storageKey || ne;
            return new Xn(t, n);
          }
        }, {
          key: "getIdxResponseStorage",
          value: function (e) {
            var t;
            if (yt()) try {
              t = this.storageUtil.getStorageByType("memory", e);
            } catch (e) {
              Sn("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic");
            } else {
              var n = this.getTransactionStorage(e);
              n && (t = {
                getItem: function (e) {
                  var t = n.getStorage();
                  return t && t[e] ? t[e] : null;
                },
                setItem: function (e, t) {
                  var r = n.getStorage();
                  if (!r) throw new b("Transaction has been cleared, failed to save idxState");
                  r[e] = t, n.setStorage(r);
                },
                removeItem: function (e) {
                  var t = n.getStorage();
                  t && (delete t[e], n.setStorage(t));
                }
              });
            }
            return t ? new Xn(t, re) : null;
          }
        }, {
          key: "getTokenStorage",
          value: function (e) {
            Qn(e = this.getOptionsForSection("token", e));
            var t = this.getStorage(e),
              n = e.storageKey || X;
            return new Xn(t, n);
          }
        }, {
          key: "getHttpCache",
          value: function (e) {
            e = this.getOptionsForSection("cache", e);
            var t = this.getStorage(e),
              n = e.storageKey || Q;
            return new Xn(t, n);
          }
        }, {
          key: "getLegacyPKCEStorage",
          value: function (e) {
            e = this.getOptionsForSection("legacy-pkce", e);
            var t = this.getStorage(e),
              n = e.storageKey || Z;
            return new Xn(t, n);
          }
        }, {
          key: "getLegacyOAuthParamsStorage",
          value: function (e) {
            e = this.getOptionsForSection("legacy-oauth-params", e);
            var t = this.getStorage(e),
              n = e.storageKey || z;
            return new Xn(t, n);
          }
        }]), e;
      }();
      function er(e) {
        return e && e.version;
      }
      function tr(e) {
        var t = e.getSharedTansactionStorage(),
          n = t.getStorage();
        Object.keys(n).forEach(function (e) {
          var t = n[e];
          Date.now() - t.dateCreated > 18e5 && delete n[e];
        }), t.setStorage(n);
      }
      function nr(e, t, n) {
        var r = e.getSharedTansactionStorage(),
          o = r.getStorage();
        o[t] = {
          dateCreated: Date.now(),
          transaction: n
        }, r.setStorage(o);
      }
      function rr(e, t) {
        var n = e.getSharedTansactionStorage().getStorage()[t];
        return n && n.transaction && Jt(n.transaction) ? n.transaction : null;
      }
      function or(e, t) {
        var n = e.getSharedTansactionStorage(),
          r = n.getStorage();
        delete r[t], n.setStorage(r);
      }
      var ir = function () {
          function e(t) {
            a(this, e), this.storageManager = t.storageManager, this.legacyWidgetSupport = !1 !== t.legacyWidgetSupport, this.saveNonceCookie = !1 !== t.saveNonceCookie, this.saveStateCookie = !1 !== t.saveStateCookie, this.saveParamsCookie = !1 !== t.saveParamsCookie, this.enableSharedStorage = !1 !== t.enableSharedStorage, this.options = t;
          }
          return q(e, [{
            key: "clear",
            value: function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = this.storageManager.getTransactionStorage(),
                n = t.getStorage();
              if (t.clearStorage(), this.clearIdxResponse(), this.enableSharedStorage && e.clearSharedStorage) {
                var r = e.state || (null == n ? void 0 : n.state);
                r && or(this.storageManager, r);
              }
              this.legacyWidgetSupport && (e.oauth && this.clearLegacyOAuthParams(), e.pkce && this.clearLegacyPKCE());
            }
          }, {
            key: "save",
            value: function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = this.storageManager.getTransactionStorage(),
                r = n.getStorage();
              if (Jt(r) && !t.muteWarning && Sn("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e), this.enableSharedStorage && e.state && nr(this.storageManager, e.state, e), t.oauth && (this.saveNonceCookie || this.saveStateCookie || this.saveParamsCookie)) {
                var o = this.storageManager.getStorage({
                  storageType: "cookie"
                });
                if (this.saveParamsCookie) {
                  var i = e.responseType,
                    a = e.state,
                    u = e.nonce,
                    s = e.scopes,
                    c = e.clientId,
                    f = e.urls,
                    l = e.ignoreSignature,
                    p = {
                      responseType: i,
                      state: a,
                      nonce: u,
                      scopes: s,
                      clientId: c,
                      urls: f,
                      ignoreSignature: l
                    };
                  o.setItem(z, JSON.stringify(p), null);
                }
                this.saveNonceCookie && e.nonce && o.setItem(Y, e.nonce, null), this.saveStateCookie && e.state && o.setItem(J, e.state, null);
              }
            }
          }, {
            key: "exists",
            value: function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              try {
                var t = this.load(e);
                return !!t;
              } catch (e) {
                return !1;
              }
            }
          }, {
            key: "load",
            value: function () {
              var e,
                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              if (this.enableSharedStorage && t.state && (tr(this.storageManager), Jt(e = rr(this.storageManager, t.state)))) return e;
              var n = this.storageManager.getTransactionStorage();
              if (Jt(e = n.getStorage())) return e;
              if (!this.legacyWidgetSupport) return null;
              if (t.oauth) try {
                var r = this.loadLegacyOAuthParams();
                Object.assign(e, r);
              } finally {
                this.clearLegacyOAuthParams();
              }
              if (t.pkce) try {
                var o = this.loadLegacyPKCE();
                Object.assign(e, o);
              } finally {
                this.clearLegacyPKCE();
              }
              return Jt(e) ? e : null;
            }
          }, {
            key: "clearLegacyPKCE",
            value: function () {
              this.storageManager.storageUtil.testStorageType("localStorage") && this.storageManager.getLegacyPKCEStorage({
                storageType: "localStorage"
              }).clearStorage(), this.storageManager.storageUtil.testStorageType("sessionStorage") && this.storageManager.getLegacyPKCEStorage({
                storageType: "sessionStorage"
              }).clearStorage();
            }
          }, {
            key: "loadLegacyPKCE",
            value: function () {
              var e;
              if (this.storageManager.storageUtil.testStorageType("localStorage") && (e = this.storageManager.getLegacyPKCEStorage({
                storageType: "localStorage"
              }).getStorage()) && e.codeVerifier) return e;
              if (this.storageManager.storageUtil.testStorageType("sessionStorage") && (e = this.storageManager.getLegacyPKCEStorage({
                storageType: "sessionStorage"
              }).getStorage()) && e.codeVerifier) return e;
              throw new b("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", null);
            }
          }, {
            key: "clearLegacyOAuthParams",
            value: function () {
              this.storageManager.storageUtil.testStorageType("sessionStorage") && this.storageManager.getLegacyOAuthParamsStorage({
                storageType: "sessionStorage"
              }).clearStorage(), this.storageManager.storageUtil.testStorageType("cookie") && this.storageManager.getLegacyOAuthParamsStorage({
                storageType: "cookie"
              }).clearStorage();
            }
          }, {
            key: "loadLegacyOAuthParams",
            value: function () {
              var e;
              if (this.storageManager.storageUtil.testStorageType("sessionStorage") && (e = this.storageManager.getLegacyOAuthParamsStorage({
                storageType: "sessionStorage"
              }).getStorage()), Gt(e)) return e;
              if (this.storageManager.storageUtil.testStorageType("cookie") && (e = this.storageManager.getLegacyOAuthParamsStorage({
                storageType: "cookie"
              }).getStorage()), Gt(e)) return e;
              throw new b("Unable to retrieve OAuth redirect params from storage");
            }
          }, {
            key: "saveIdxResponse",
            value: function (e) {
              var t = this.storageManager.getIdxResponseStorage();
              t && t.setStorage(e);
            }
          }, {
            key: "loadIdxResponse",
            value: function () {
              var e = this.storageManager.getIdxResponseStorage();
              if (!e) return null;
              var t = e.getStorage();
              return er(t) ? t : null;
            }
          }, {
            key: "clearIdxResponse",
            value: function () {
              var e = this.storageManager.getIdxResponseStorage();
              null == e || e.clearStorage();
            }
          }]), e;
        }(),
        ar = n(4098),
        ur = n.n(ar);
      function sr(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      var cr = function (e, t, r) {
          var o = r.data,
            i = r.headers || {};
          "application/json" === (i["Content-Type"] || i["content-type"] || "") && o && "string" != typeof o && (o = JSON.stringify(o));
          var a = (n.g.fetch || ur())(t, {
            method: e,
            headers: r.headers,
            body: o,
            credentials: r.withCredentials ? "include" : "omit"
          });
          return a.finally || (a = Promise.resolve(a)), a.then(function (e) {
            var t = !e.ok,
              n = e.status;
            return function (e) {
              return e.headers.get("Content-Type") && e.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e.json().catch(function (e) {
                return {
                  error: e,
                  errorSummary: "Could not parse server response"
                };
              }) : e.text();
            }(e).then(function (t) {
              return function (e, t, n) {
                var r,
                  o = "object" === c(t),
                  i = {},
                  a = function (e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                      if (Array.isArray(e) || (n = function (e, t) {
                        if (e) {
                          if ("string" == typeof e) return sr(e, t);
                          var n = Object.prototype.toString.call(e).slice(8, -1);
                          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? sr(e, t) : void 0;
                        }
                      }(e)) || t && e && "number" == typeof e.length) {
                        n && (e = n);
                        var r = 0,
                          o = function () {};
                        return {
                          s: o,
                          n: function () {
                            return r >= e.length ? {
                              done: !0
                            } : {
                              done: !1,
                              value: e[r++]
                            };
                          },
                          e: function (e) {
                            throw e;
                          },
                          f: o
                        };
                      }
                      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i,
                      a = !0,
                      u = !1;
                    return {
                      s: function () {
                        n = n.call(e);
                      },
                      n: function () {
                        var e = n.next();
                        return a = e.done, e;
                      },
                      e: function (e) {
                        u = !0, i = e;
                      },
                      f: function () {
                        try {
                          a || null == n.return || n.return();
                        } finally {
                          if (u) throw i;
                        }
                      }
                    };
                  }(n.headers.entries());
                try {
                  for (a.s(); !(r = a.n()).done;) {
                    var u = r.value;
                    i[u[0]] = u[1];
                  }
                } catch (e) {
                  a.e(e);
                } finally {
                  a.f();
                }
                var s = {
                  responseText: o ? JSON.stringify(t) : t,
                  status: e,
                  headers: i
                };
                return o && (s.responseType = "json", s.responseJSON = t), s;
              }(n, t, e);
            }).then(function (e) {
              var n;
              if (t || (null === (n = e.responseJSON) || void 0 === n ? void 0 : n.error)) throw e;
              return e;
            });
          });
        },
        fr = n(9148),
        lr = "function" == typeof fr ? new fr() : null,
        pr = function () {
          function e(t) {
            a(this, e), this.nodeCache = t;
          }
          return q(e, [{
            key: "set",
            value: function (e, t, n) {
              if (Date.parse(n)) {
                var r = (Date.parse(n) - Date.now()) / 1e3;
                this.nodeCache.set(e, t, r);
              } else this.nodeCache.set(e, t);
              return this.get(e);
            }
          }, {
            key: "get",
            value: function (e) {
              return this.nodeCache.get(e);
            }
          }, {
            key: "delete",
            value: function (e) {
              return this.nodeCache.del(e);
            }
          }]), e;
        }(),
        hr = new (function () {
          function e(t) {
            a(this, e), this.nodeCache = t, this.storage = new pr(t);
          }
          return q(e, [{
            key: "testStorageType",
            value: function (e) {
              var t = !1;
              return "memory" === e && (t = !0), t;
            }
          }, {
            key: "getStorageByType",
            value: function (e) {
              if ("memory" !== e) throw new b("Unrecognized storage option: ".concat(e));
              return this.getStorage();
            }
          }, {
            key: "findStorageType",
            value: function () {
              return "memory";
            }
          }, {
            key: "getHttpCache",
            value: function () {
              return null;
            }
          }, {
            key: "getStorage",
            value: function () {
              var e = this;
              return {
                getItem: this.nodeCache.get,
                setItem: function (t, n) {
                  e.nodeCache.set(t, n, "2200-01-01T00:00:00.000Z");
                }
              };
            }
          }]), e;
        }())(lr),
        dr = {
          token: {
            storageTypes: ["localStorage", "sessionStorage", "cookie"],
            useMultipleCookies: !0
          },
          cache: {
            storageTypes: ["localStorage", "sessionStorage", "cookie"]
          },
          transaction: {
            storageTypes: ["sessionStorage", "localStorage", "cookie"]
          },
          "shared-transaction": {
            storageTypes: ["localStorage"]
          },
          "original-uri": {
            storageTypes: ["localStorage"]
          }
        },
        vr = {
          token: {
            storageTypes: ["memory"]
          },
          cache: {
            storageTypes: ["memory"]
          },
          transaction: {
            storageTypes: ["memory"]
          }
        };
      function gr() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length > 1 ? arguments[1] : void 0,
          n = e.cookies || {};
        return void 0 === n.secure && (n.secure = t), void 0 === n.sameSite && (n.sameSite = n.secure ? "none" : "lax"), n.secure && !t && (Sn('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), n.secure = !1), "none" !== n.sameSite || n.secure || (n.sameSite = "lax"), n;
      }
      function yr() {
        var e = yt() ? _n : hr,
          t = yt() ? dr : vr,
          n = !!yt();
        return {
          devMode: !1,
          httpRequestClient: cr,
          storageUtil: e,
          storageManager: t,
          transactionManager: {
            enableSharedStorage: n
          }
        };
      }
      function mr(e, t) {
        return Object.assign({}, e, M(t), {
          storageManager: Object.assign({}, e.storageManager, t.storageManager),
          transactionManager: Object.assign({}, e.transactionManager, t.transactionManager)
        });
      }
      var br = n(6760),
        kr = n.n(br),
        wr = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                s(r.next(e));
              } catch (e) {
                i(e);
              }
            }
            function u(e) {
              try {
                s(r.throw(e));
              } catch (e) {
                i(e);
              }
            }
            function s(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, u);
            }
            s((r = r.apply(e, t || [])).next());
          });
        };
      function xr(e, t) {
        return wr(this, void 0, void 0, K().mark(function n() {
          var r, o, i, a, u, s, c, f, l, p, h, d, v, g, y, m, b;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, e.token.prepareTokenParams(t);
              case 2:
                return r = n.sent, o = r.pkce, i = r.clientId, a = r.redirectUri, u = r.responseType, s = r.responseMode, c = r.scopes, f = r.state, l = r.nonce, p = r.ignoreSignature, h = r.codeVerifier, d = r.codeChallengeMethod, v = r.codeChallenge, g = pt(e, r), y = e.idx.getFlow() || "default", m = e.options.issuer, b = {
                  flow: y,
                  issuer: m,
                  pkce: o,
                  clientId: i,
                  redirectUri: a,
                  responseType: u,
                  responseMode: s,
                  scopes: c,
                  state: f,
                  nonce: l,
                  urls: g,
                  ignoreSignature: p,
                  codeVerifier: h,
                  codeChallengeMethod: d,
                  codeChallenge: v
                }, n.abrupt("return", b);
              case 9:
              case "end":
                return n.stop();
            }
          }, n);
        }));
      }
      function Sr(e, t) {
        if (e.transactionManager.exists(t)) {
          var n = e.transactionManager.load(t);
          if (Er(e, n) && n.interactionHandle) return !0;
        }
        return !1;
      }
      function Tr(e, t) {
        var n = (null == t ? void 0 : t.state) || e.options.state,
          r = e.transactionManager.load({
            state: n
          });
        if (r && Er(e, r)) return r;
      }
      function Or(e, t) {
        return wr(this, void 0, void 0, K().mark(function n() {
          var r;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                if (!e.transactionManager.exists(t)) {
                  n.next = 5;
                  break;
                }
                if (!(r = Tr(e, t))) {
                  n.next = 4;
                  break;
                }
                return n.abrupt("return", r);
              case 4:
                Sn("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
              case 5:
                return n.abrupt("return", xr(e, t));
              case 6:
              case "end":
                return n.stop();
            }
          }, n);
        }));
      }
      function Ar(e, t) {
        e.transactionManager.save(t, {
          muteWarning: !0
        });
      }
      function Er(e, t) {
        if (["issuer", "clientId", "redirectUri"].some(function (n) {
          return e.options[n] !== t[n];
        })) return !1;
        var n = e.options,
          r = n.flow,
          o = n.state;
        return !(o && o !== t.state || r && "default" !== r && "proceed" !== r && r !== t.flow);
      }
      var _r = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, u);
          }
          s((r = r.apply(e, t || [])).next());
        });
      };
      function Rr(e) {
        return {
          meta: e,
          interactionHandle: e.interactionHandle,
          state: e.state
        };
      }
      function Pr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return _r(this, void 0, void 0, K().mark(function n() {
          var r, o, i, a, u, s, c, f, l, p;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return r = t.state || e.options.state, n.next = 3, Or(e, {
                  state: r
                });
              case 3:
                if (!(o = n.sent).interactionHandle) {
                  n.next = 6;
                  break;
                }
                return n.abrupt("return", Rr(o));
              case 6:
                return i = o.codeChallenge, a = o.codeChallengeMethod, u = e.options, s = u.clientId, c = u.redirectUri, r = r || o.state, f = t.scopes || e.options.scopes || o.scopes, l = t.activationToken, p = ft(e), n.abrupt("return", kr().interact({
                  clientId: s,
                  baseUrl: p,
                  scopes: f,
                  state: r,
                  redirectUri: c,
                  codeChallenge: i,
                  codeChallengeMethod: a,
                  activationToken: l
                }).then(function (t) {
                  var n = Object.assign(Object.assign({}, o), {
                    interactionHandle: t,
                    state: r,
                    scopes: f
                  });
                  return Ar(e, n), Rr(n);
                }));
              case 13:
              case "end":
                return n.stop();
            }
          }, n);
        }));
      }
      function jr(e, t) {
        return n = this, r = void 0, o = void 0, i = K().mark(function n() {
          var r, o, i;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                if (!t.stateTokenExternalId && (r = e.transactionManager.loadIdxResponse()), r) {
                  n.next = 18;
                  break;
                }
                return o = le, i = lt(e), n.prev = 5, n.next = 8, kr().introspect(Object.assign({
                  domain: i,
                  version: o
                }, t));
              case 8:
                r = n.sent, n.next = 18;
                break;
              case 11:
                if (n.prev = 11, n.t0 = n.catch(5), !er(n.t0)) {
                  n.next = 17;
                  break;
                }
                r = n.t0, n.next = 18;
                break;
              case 17:
                throw n.t0;
              case 18:
                return n.abrupt("return", kr().makeIdxState(r));
              case 19:
              case "end":
                return n.stop();
            }
          }, n, null, [[5, 11]]);
        }), new (o || (o = Promise))(function (e, t) {
          function a(e) {
            try {
              s(i.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(i.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function (e) {
              e(n);
            })).then(a, u);
          }
          s((i = i.apply(n, r || [])).next());
        });
        var n, r, o, i;
      }
      function Ir(e) {
        return function (e) {
          if (Array.isArray(e)) return Ye(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || Xe(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function Cr(e) {
        return e.charAt(0).toUpperCase() + e.substring(1);
      }
      function Mr(e) {
        return e.value.find(function (e) {
          return "authenticator" === e.name;
        });
      }
      function Ur(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      var Fr = function () {
          function e(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            a(this, e), this.values = Object.assign({}, n), this.formatAuthenticators(), this.remediation = t;
          }
          return q(e, [{
            key: "formatAuthenticators",
            value: function () {
              var e = this;
              this.values.authenticators = this.values.authenticators || [], this.values.authenticator && (this.values.authenticators.some(function (t) {
                return "string" == typeof t ? t === e.values.authenticator : t.key === e.values.authenticator;
              }) || this.values.authenticators.push({
                key: this.values.authenticator
              })), this.values.authenticators = this.values.authenticators.map(function (e) {
                return "string" == typeof e ? {
                  key: e
                } : e;
              }), this.values.authenticatorsData = this.values.authenticators.reduce(function (e, t) {
                return "object" === c(t) && Object.keys(t).length > 1 && e.push(t), e;
              }, this.values.authenticatorsData || []);
            }
          }, {
            key: "getName",
            value: function () {
              return this.remediation.name;
            }
          }, {
            key: "canRemediate",
            value: function () {
              var e = this;
              return !!this.map && !this.remediation.value.reduce(function (e, t) {
                return t.required && e.push(t.name), e;
              }, []).find(function (t) {
                return !e.hasData(t);
              });
            }
          }, {
            key: "getData",
            value: function (e) {
              var t = this;
              if (!e) {
                var n = this.remediation.value.map(function (e) {
                  return e.name;
                }).reduce(function (e, n) {
                  return e[n] = t.getData(n), e;
                }, {});
                return n;
              }
              if ("function" == typeof this["map".concat(Cr(e))]) return this["map".concat(Cr(e))](this.remediation.value.find(function (t) {
                return t.name === e;
              }));
              if (!this.map) return this.values[e];
              var r = this.map[e];
              if (!r) return this.values[e];
              for (var o = 0; o < r.length; o++) {
                var i = this.values[r[o]];
                if (i) return i;
              }
            }
          }, {
            key: "hasData",
            value: function (e) {
              var t = this.getData(e);
              return "object" === c(t) ? !!Object.keys(t).find(function (e) {
                return !!t[e];
              }) : !!t;
            }
          }, {
            key: "getNextStep",
            value: function (e) {
              var t = this.getName(),
                n = this.getInputs(),
                r = this.getAuthenticator(),
                o = null == r ? void 0 : r.type;
              return Object.assign(Object.assign({
                name: t,
                inputs: n
              }, o && {
                type: o
              }), r && {
                authenticator: r
              });
            }
          }, {
            key: "getInputs",
            value: function () {
              var e = this;
              return this.map ? Object.keys(this.map).reduce(function (t, n) {
                var r,
                  o = e.remediation.value.find(function (e) {
                    return e.name === n;
                  });
                if (!o) return t;
                var i = e.map[n],
                  a = o.type;
                if ("function" == typeof e["getInput".concat(Cr(n))]) r = e["getInput".concat(Cr(n))](o);else if ("object" !== a) {
                  var u;
                  (u = 1 === i.length ? i[0] : i.find(function (t) {
                    return Object.keys(e.values).includes(t);
                  })) && (r = Object.assign(Object.assign({}, o), {
                    name: u
                  }));
                }
                if (!r) throw new b("Missing custom getInput".concat(Cr(n), " method in Remediator: ").concat(e.getName()));
                return Array.isArray(r) ? r.forEach(function (e) {
                  return t.push(e);
                }) : t.push(r), t;
              }, []) : [];
            }
          }, {
            key: "getValuesAfterProceed",
            value: function () {
              var e,
                t = function (e, t) {
                  var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                  if (!n) {
                    if (Array.isArray(e) || (n = function (e, t) {
                      if (e) {
                        if ("string" == typeof e) return Ur(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ur(e, t) : void 0;
                      }
                    }(e)) || t && e && "number" == typeof e.length) {
                      n && (e = n);
                      var r = 0,
                        o = function () {};
                      return {
                        s: o,
                        n: function () {
                          return r >= e.length ? {
                            done: !0
                          } : {
                            done: !1,
                            value: e[r++]
                          };
                        },
                        e: function (e) {
                          throw e;
                        },
                        f: o
                      };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }
                  var i,
                    a = !0,
                    u = !1;
                  return {
                    s: function () {
                      n = n.call(e);
                    },
                    n: function () {
                      var e = n.next();
                      return a = e.done, e;
                    },
                    e: function (e) {
                      u = !0, i = e;
                    },
                    f: function () {
                      try {
                        a || null == n.return || n.return();
                      } finally {
                        if (u) throw i;
                      }
                    }
                  };
                }(this.getInputs());
              try {
                for (t.s(); !(e = t.n()).done;) {
                  var n = e.value;
                  delete this.values[n.name];
                }
              } catch (e) {
                t.e(e);
              } finally {
                t.f();
              }
              return this.values;
            }
          }, {
            key: "getAuthenticator",
            value: function () {
              var e;
              return null === (e = this.remediation.relatesTo) || void 0 === e ? void 0 : e.value;
            }
          }], [{
            key: "getMessages",
            value: function (e) {
              var t, n;
              if (e.value) return null === (n = null === (t = e.value[0]) || void 0 === t ? void 0 : t.form) || void 0 === n ? void 0 : n.value.reduce(function (e, t) {
                return t.messages && (e = [].concat(Ir(e), Ir(t.messages.value))), e;
              }, []);
            }
          }]), e;
        }(),
        Nr = function e(t) {
          a(this, e), this.meta = t;
        };
      var Lr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "canVerify",
          value: function (e) {
            return !!e.verificationCode;
          }
        }, {
          key: "mapCredentials",
          value: function (e) {
            return {
              passcode: e.verificationCode
            };
          }
        }, {
          key: "getInputs",
          value: function (e) {
            var t;
            return Object.assign(Object.assign({}, null === (t = e.form) || void 0 === t ? void 0 : t.value[0]), {
              name: "verificationCode",
              type: "string",
              required: e.required
            });
          }
        }]), o;
      }(Nr);
      var Dr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "mapCredentials",
          value: function (e) {
            return {
              totp: e.verificationCode
            };
          }
        }]), o;
      }(Lr);
      var Br = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "canVerify",
          value: function (e) {
            return !!e.password;
          }
        }, {
          key: "mapCredentials",
          value: function (e) {
            return {
              passcode: e.password
            };
          }
        }, {
          key: "getInputs",
          value: function (e) {
            var t;
            return Object.assign(Object.assign({}, null === (t = e.form) || void 0 === t ? void 0 : t.value[0]), {
              name: "password",
              type: "string",
              required: e.required
            });
          }
        }]), o;
      }(Nr);
      var qr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "canVerify",
          value: function (e) {
            var t = e.questionKey,
              n = e.question,
              r = e.answer;
            return t && r || n && r;
          }
        }, {
          key: "mapCredentials",
          value: function (e) {
            var t = e.questionKey,
              n = e.question;
            return {
              questionKey: n ? "custom" : t,
              question: n,
              answer: e.answer
            };
          }
        }, {
          key: "getInputs",
          value: function () {
            return [{
              name: "questionKey",
              type: "string",
              require: !0
            }, {
              name: "question",
              type: "string",
              label: "Create a security question"
            }, {
              name: "answer",
              type: "string",
              label: "Answer",
              required: !0
            }];
          }
        }]), o;
      }(Nr);
      var Hr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "canVerify",
          value: function (e) {
            return e.answer;
          }
        }, {
          key: "mapCredentials",
          value: function (e) {
            return {
              questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
              answer: e.answer
            };
          }
        }, {
          key: "getInputs",
          value: function () {
            return [{
              name: "answer",
              type: "string",
              label: "Answer",
              required: !0
            }];
          }
        }]), o;
      }(Nr);
      function Kr(e) {
        var t = e.relatesTo,
          n = (t = void 0 === t ? {} : t).value;
        switch (n.key) {
          case dt.OKTA_PASSWORD:
            return new Br(n);
          case dt.SECURITY_QUESTION:
            return n.contextualData.enrolledQuestion ? new Hr(n) : new qr(n);
          case dt.OKTA_VERIFY:
            return new Dr(n);
          default:
            return new Lr(n);
        }
      }
      var Vr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o(e) {
          var t,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return a(this, o), (t = r.call(this, e, n)).map = {
            credentials: []
          }, t.authenticator = Kr(e), t;
        }
        return q(o, [{
          key: "canRemediate",
          value: function () {
            return this.authenticator.canVerify(this.values);
          }
        }, {
          key: "mapCredentials",
          value: function () {
            return this.authenticator.mapCredentials(this.values);
          }
        }, {
          key: "getInputCredentials",
          value: function (e) {
            return this.authenticator.getInputs(e);
          }
        }]), o;
      }(Fr);
      var Gr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return o;
      }(Vr);
      function Wr(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      Gr.remediationName = "enroll-authenticator";
      var $r = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "canRemediate",
          value: function () {
            return Boolean(this.values.startPolling);
          }
        }, {
          key: "getNextStep",
          value: function (e) {
            var t = this.getName(),
              n = this.getAuthenticator();
            return !n && (null == e ? void 0 : e.currentAuthenticator) && (n = e.currentAuthenticator.value), {
              name: t,
              authenticator: n,
              poll: {
                required: !0,
                refresh: this.remediation.refresh
              }
            };
          }
        }, {
          key: "getValuesAfterProceed",
          value: function () {
            var e = this;
            return Object.keys(this.values).filter(function (e) {
              return "startPolling" !== e;
            }).reduce(function (t, n) {
              return Object.assign(Object.assign({}, t), Wr({}, n, e.values[n]));
            }, {});
          }
        }]), o;
      }(Fr);
      $r.remediationName = "enroll-poll";
      var zr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return o;
      }(Vr);
      zr.remediationName = "challenge-authenticator";
      var Jr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return o;
      }($r);
      Jr.remediationName = "challenge-poll";
      var Yr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return o;
      }(Vr);
      Yr.remediationName = "reset-authenticator";
      var Xr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          var e;
          return a(this, o), (e = r.apply(this, arguments)).map = {
            userProfile: []
          }, e;
        }
        return q(o, [{
          key: "canRemediate",
          value: function () {
            var e = this.getData().userProfile;
            return this.remediation.value.find(function (e) {
              return "userProfile" === e.name;
            }).form.value.reduce(function (t, n) {
              return n.required && (t = t && !!e[n.name]), t;
            }, !0);
          }
        }, {
          key: "mapUserProfile",
          value: function (e) {
            var t = this;
            return e.form.value.map(function (e) {
              return e.name;
            }).reduce(function (e, n) {
              return t.values[n] ? Object.assign(Object.assign({}, e), Wr({}, n, t.values[n])) : e;
            }, {});
          }
        }, {
          key: "getInputUserProfile",
          value: function (e) {
            return Ir(e.form.value);
          }
        }, {
          key: "getErrorMessages",
          value: function (e) {
            return e.value[0].form.value.reduce(function (e, t) {
              return t.messages && e.push(t.messages.value[0].message), e;
            }, []);
          }
        }]), o;
      }(Fr);
      Xr.remediationName = "enroll-profile";
      var Qr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          var e;
          return a(this, o), (e = r.apply(this, arguments)).map = {
            identifier: ["username"],
            credentials: [],
            rememberMe: ["rememberMe"]
          }, e;
        }
        return q(o, [{
          key: "canRemediate",
          value: function () {
            return !!this.getData().identifier;
          }
        }, {
          key: "mapCredentials",
          value: function () {
            return {
              passcode: this.values.password
            };
          }
        }, {
          key: "getInputCredentials",
          value: function (e) {
            return Object.assign(Object.assign({}, e.form.value[0]), {
              name: "password",
              required: e.required
            });
          }
        }]), o;
      }(Fr);
      Qr.remediationName = "identify";
      var Zr = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          var e;
          return a(this, o), (e = r.apply(this, arguments)).map = {
            credentials: []
          }, e;
        }
        return q(o, [{
          key: "mapCredentials",
          value: function () {
            return {
              passcode: this.values.newPassword
            };
          }
        }, {
          key: "getInputCredentials",
          value: function (e) {
            var t = "password" === this.getAuthenticator().type ? "newPassword" : "verificationCode";
            return Object.assign(Object.assign({}, e.form.value[0]), {
              name: t
            });
          }
        }]), o;
      }(Fr);
      Zr.remediationName = "reenroll-authenticator";
      var eo = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "canRemediate",
          value: function () {
            return !1;
          }
        }, {
          key: "getNextStep",
          value: function () {
            var e = this.remediation;
            return {
              name: e.name,
              type: e.type,
              idp: e.idp,
              href: e.href
            };
          }
        }]), o;
      }(Fr);
      function to(e, t, n) {
        return to = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
          var r = function (e, t) {
            for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = p(e)););
            return e;
          }(e, t);
          if (r) {
            var o = Object.getOwnPropertyDescriptor(r, t);
            return o.get ? o.get.call(n) : o.value;
          }
        }, to(e, t, n || e);
      }
      function no(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function ro(e, t) {
        var n,
          r,
          o = function (e, t) {
            var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (!n) {
              if (Array.isArray(e) || (n = function (e, t) {
                if (e) {
                  if ("string" == typeof e) return no(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? no(e, t) : void 0;
                }
              }(e)) || t && e && "number" == typeof e.length) {
                n && (e = n);
                var r = 0,
                  o = function () {};
                return {
                  s: o,
                  n: function () {
                    return r >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[r++]
                    };
                  },
                  e: function (e) {
                    throw e;
                  },
                  f: o
                };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i,
              a = !0,
              u = !1;
            return {
              s: function () {
                n = n.call(e);
              },
              n: function () {
                var e = n.next();
                return a = e.done, e;
              },
              e: function (e) {
                u = !0, i = e;
              },
              f: function () {
                try {
                  a || null == n.return || n.return();
                } finally {
                  if (u) throw i;
                }
              }
            };
          }(e);
        try {
          var i = function () {
            var e = r.value;
            if (n = t.find(function (t) {
              return t.relatesTo.key === e.key;
            })) return "break";
          };
          for (o.s(); !(r = o.n()).done && "break" !== i(););
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        return n;
      }
      eo.remediationName = "redirect-idp";
      var oo = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          var e;
          return a(this, o), (e = r.apply(this, arguments)).map = {
            authenticator: []
          }, e;
        }
        return q(o, [{
          key: "canRemediate",
          value: function () {
            var e = this.values.authenticators,
              t = Mr(this.remediation).options;
            return !(!e || !e.length || !ro(e, t));
          }
        }, {
          key: "getNextStep",
          value: function () {
            var e = to(p(o.prototype), "getNextStep", this).call(this),
              t = Mr(this.remediation).options.map(function (e) {
                return {
                  label: e.label,
                  value: e.relatesTo.key
                };
              });
            return Object.assign(Object.assign({}, e), {
              options: t
            });
          }
        }, {
          key: "mapAuthenticator",
          value: function (e) {
            var t = ro(this.values.authenticators, e.options);
            return this.selectedAuthenticator = t.relatesTo, {
              id: null == t ? void 0 : t.value.form.value.find(function (e) {
                return "id" === e.name;
              }).value
            };
          }
        }, {
          key: "getInputAuthenticator",
          value: function () {
            return {
              name: "authenticator",
              key: "string"
            };
          }
        }, {
          key: "getValuesAfterProceed",
          value: function () {
            var e = this;
            this.values = to(p(o.prototype), "getValuesAfterProceed", this).call(this);
            var t = this.values.authenticators.filter(function (t) {
              return t.key !== e.selectedAuthenticator.key;
            });
            return Object.assign(Object.assign({}, this.values), {
              authenticators: t
            });
          }
        }]), o;
      }(Fr);
      var io = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o(e) {
          var t,
            n,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          a(this, o), t = r.call(this, e, i);
          var u = null === (n = Mr(e).options) || void 0 === n ? void 0 : n.some(function (e) {
            return e.relatesTo.key === dt.OKTA_PASSWORD;
          });
          return u && ("recoverPassword" === t.values.flow || t.values.password) && (t.values.authenticators = [].concat(Ir(t.values.authenticators), [{
            key: dt.OKTA_PASSWORD
          }])), t;
        }
        return o;
      }(oo);
      io.remediationName = "select-authenticator-authenticate";
      var ao = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return o;
      }(oo);
      ao.remediationName = "select-authenticator-enroll";
      var uo = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "canRemediate",
          value: function () {
            return !0;
          }
        }]), o;
      }(Fr);
      uo.remediationName = "select-enroll-profile";
      var so = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o(e) {
          var t,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return a(this, o), (t = r.call(this, e, n)).map = {
            authenticator: []
          }, t.authenticator = t.getAuthenticator(), t.formatAuthenticatorData(), t;
        }
        return q(o, [{
          key: "formatAuthenticatorData",
          value: function () {
            var e = this;
            if (this.getAuthenticatorData()) this.values.authenticatorsData = this.values.authenticatorsData.map(function (t) {
              return t.key === e.authenticator.key ? e.mapAuthenticatorDataFromValues(t) : t;
            });else {
              var t = this.mapAuthenticatorDataFromValues();
              t && this.values.authenticatorsData.push(t);
            }
          }
        }, {
          key: "getAuthenticatorData",
          value: function () {
            var e = this;
            return this.values.authenticatorsData.find(function (t) {
              return t.key === e.authenticator.key;
            });
          }
        }, {
          key: "canRemediate",
          value: function () {
            var e = this;
            return this.values.authenticatorsData.some(function (t) {
              return t.key === e.authenticator.key;
            });
          }
        }, {
          key: "getNextStep",
          value: function () {
            var e = to(p(o.prototype), "getNextStep", this).call(this),
              t = this.getMethodTypes();
            return Object.assign(Object.assign({}, e), t && {
              options: t
            });
          }
        }, {
          key: "mapAuthenticatorDataFromValues",
          value: function (e) {
            var t = this.values.methodType,
              n = Object.assign(Object.assign({
                key: this.authenticator.key
              }, e && e), t && {
                methodType: t
              });
            return n.methodType ? n : null;
          }
        }, {
          key: "getAuthenticatorFromRemediation",
          value: function () {
            return this.remediation.value.find(function (e) {
              return "authenticator" === e.name;
            });
          }
        }, {
          key: "getMethodTypes",
          value: function () {
            var e;
            return null === (e = this.getAuthenticatorFromRemediation().form.value.find(function (e) {
              return "methodType" === e.name;
            })) || void 0 === e ? void 0 : e.options;
          }
        }, {
          key: "getValuesAfterProceed",
          value: function () {
            var e = this;
            this.values = to(p(o.prototype), "getValuesAfterProceed", this).call(this);
            var t = this.values.authenticatorsData.filter(function (t) {
              return t.key !== e.authenticator.key;
            });
            return Object.assign(Object.assign({}, this.values), {
              authenticatorsData: t
            });
          }
        }]), o;
      }(Fr);
      var co = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "mapAuthenticator",
          value: function () {
            var e,
              t = this.getAuthenticatorData(),
              n = this.getAuthenticatorFromRemediation();
            return {
              id: n.form.value.find(function (e) {
                return "id" === e.name;
              }).value,
              enrollmentId: null === (e = n.form.value.find(function (e) {
                return "enrollmentId" === e.name;
              })) || void 0 === e ? void 0 : e.value,
              methodType: t.methodType
            };
          }
        }, {
          key: "getInputAuthenticator",
          value: function () {
            var e = this.getAuthenticatorFromRemediation(),
              t = e.form.value.find(function (e) {
                return "methodType" === e.name;
              });
            return t && t.options ? {
              name: "methodType",
              type: "string",
              required: !0
            } : Ir(e.form.value);
          }
        }]), o;
      }(so);
      co.remediationName = "authenticator-verification-data";
      var fo = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          return a(this, o), r.apply(this, arguments);
        }
        return q(o, [{
          key: "mapAuthenticator",
          value: function () {
            var e = this.getAuthenticatorData();
            return {
              id: Mr(this.remediation).form.value.find(function (e) {
                return "id" === e.name;
              }).value,
              methodType: e.methodType,
              phoneNumber: e.phoneNumber
            };
          }
        }, {
          key: "getInputAuthenticator",
          value: function () {
            return [{
              name: "methodType",
              type: "string",
              required: !0
            }, {
              name: "phoneNumber",
              type: "string",
              required: !0,
              label: "Phone Number"
            }];
          }
        }, {
          key: "mapAuthenticatorDataFromValues",
          value: function (e) {
            e = to(p(o.prototype), "mapAuthenticatorDataFromValues", this).call(this, e);
            var t = this.values.phoneNumber;
            return (e = Object.assign(Object.assign({}, e && e), t && {
              phoneNumber: t
            })).phoneNumber && e.methodType ? e : null;
          }
        }]), o;
      }(so);
      fo.remediationName = "authenticator-enrollment-data";
      var lo = function (e) {
        s(o, e);
        var t,
          n,
          r = (t = o, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              r = p(t);
            if (n) {
              var o = p(this).constructor;
              e = Reflect.construct(r, arguments, o);
            } else e = r.apply(this, arguments);
            return l(this, e);
          });
        function o() {
          var e;
          return a(this, o), (e = r.apply(this, arguments)).map = {
            skip: ["skip"]
          }, e;
        }
        return q(o, [{
          key: "canRemediate",
          value: function () {
            return !!this.values.skip;
          }
        }]), o;
      }(Fr);
      function po(e, t) {
        var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (!n) {
          if (Array.isArray(e) || (n = function (e, t) {
            if (e) {
              if ("string" == typeof e) return ho(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ho(e, t) : void 0;
            }
          }(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var r = 0,
              o = function () {};
            return {
              s: o,
              n: function () {
                return r >= e.length ? {
                  done: !0
                } : {
                  done: !1,
                  value: e[r++]
                };
              },
              e: function (e) {
                throw e;
              },
              f: o
            };
          }
          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var i,
          a = !0,
          u = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return a = e.done, e;
          },
          e: function (e) {
            u = !0, i = e;
          },
          f: function () {
            try {
              a || null == n.return || n.return();
            } finally {
              if (u) throw i;
            }
          }
        };
      }
      function ho(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      lo.remediationName = "skip";
      function vo(e, t, n) {
        var r,
          o,
          i = n.remediators,
          a = [],
          u = po(e);
        try {
          for (u.s(); !(o = u.n()).done;) {
            var s = o.value;
            if (Object.keys(i).includes(s.name)) {
              if ((r = new (0, i[s.name])(s, t)).canRemediate()) return r;
              a.push(r);
            }
          }
        } catch (e) {
          u.e(e);
        } finally {
          u.f();
        }
        return a[0];
      }
      function go(e) {
        var t = e.neededToProceed,
          n = e.interactionCode;
        return !t.length && !n;
      }
      function yo(e) {
        var t,
          n = [],
          r = e.rawIdxState,
          o = e.neededToProceed,
          i = null === (t = r.messages) || void 0 === t ? void 0 : t.value.map(function (e) {
            return e;
          });
        i && (n = [].concat(Ir(n), Ir(i)));
        var a,
          u = po(o);
        try {
          for (u.s(); !(a = u.n()).done;) {
            var s = a.value,
              c = Fr.getMessages(s);
            c && (n = [].concat(Ir(n), Ir(c)));
          }
        } catch (e) {
          u.e(e);
        } finally {
          u.f();
        }
        return n;
      }
      function mo(e, t) {
        var n = e.getNextStep(t.context),
          r = function (e) {
            return e.neededToProceed.some(function (e) {
              return "skip" === e.name;
            });
          }(t),
          o = function (e) {
            return Object.keys(e.actions).some(function (e) {
              return e.includes("resend");
            });
          }(t);
        return Object.assign(Object.assign(Object.assign({}, n), r && {
          canSkip: r
        }), o && {
          canResend: o
        });
      }
      function bo(e, t) {
        var n,
          r = (n = e) && er(n.rawIdxState) ? e : null;
        if (!r) throw e;
        var o = go(r),
          i = yo(r);
        if (o) return {
          terminal: o,
          messages: i
        };
        var a = t && mo(t, r);
        return Object.assign({
          messages: i
        }, a && {
          nextStep: a
        });
      }
      function ko(e, t) {
        return Object.keys(t.actions).find(function (t) {
          return !!e.resend && t.includes("-resend");
        });
      }
      function wo(e) {
        return e.resend = void 0, e;
      }
      function xo(e, t, n) {
        return r = this, o = void 0, i = void 0, a = K().mark(function r() {
          var o, i, a, u, s, c, f, l, p, h, d, v, g, y, m, k, w;
          return K().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                if (i = (o = e).neededToProceed, a = o.interactionCode, u = n.remediators, !a) {
                  r.next = 4;
                  break;
                }
                return r.abrupt("return", {
                  idxResponse: e
                });
              case 4:
                if (s = go(e), c = yo(e), !s) {
                  r.next = 8;
                  break;
                }
                return r.abrupt("return", {
                  terminal: s,
                  messages: c
                });
              case 8:
                if (f = vo(i, t, n)) {
                  r.next = 11;
                  break;
                }
                throw new b("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(i.reduce(function (e, t) {
                  return e ? e + " ," + t.name : t.name;
                }, ""), "]\n    "));
              case 11:
                if (!c.length) {
                  r.next = 14;
                  break;
                }
                return l = mo(f, e), r.abrupt("return", {
                  nextStep: l,
                  messages: c
                });
              case 14:
                if (p = ko(t, e), !(h = [].concat(Ir(n.actions || []), Ir(p && [p] || [])))) {
                  r.next = 46;
                  break;
                }
                d = po(h), r.prev = 18, d.s();
              case 20:
                if ((v = d.n()).done) {
                  r.next = 38;
                  break;
                }
                if (g = v.value, y = wo(t), "function" != typeof e.actions[g]) {
                  r.next = 36;
                  break;
                }
                return r.prev = 24, r.next = 27, e.actions[g]();
              case 27:
                e = r.sent, r.next = 33;
                break;
              case 30:
                return r.prev = 30, r.t0 = r.catch(24), r.abrupt("return", bo(r.t0, u));
              case 33:
                if ("cancel" !== g) {
                  r.next = 35;
                  break;
                }
                return r.abrupt("return", {
                  canceled: !0
                });
              case 35:
                return r.abrupt("return", xo(e, y, n));
              case 36:
                r.next = 20;
                break;
              case 38:
                r.next = 43;
                break;
              case 40:
                r.prev = 40, r.t1 = r.catch(18), d.e(r.t1);
              case 43:
                return r.prev = 43, d.f(), r.finish(43);
              case 46:
                if (f.canRemediate()) {
                  r.next = 49;
                  break;
                }
                return m = mo(f, e), r.abrupt("return", {
                  idxResponse: e,
                  nextStep: m
                });
              case 49:
                return k = f.getName(), w = f.getData(), r.prev = 51, r.next = 54, e.proceed(k, w);
              case 54:
                return e = r.sent, t = f.getValuesAfterProceed(), r.abrupt("return", xo(e, t, n));
              case 59:
                return r.prev = 59, r.t2 = r.catch(51), r.abrupt("return", bo(r.t2, f));
              case 62:
              case "end":
                return r.stop();
            }
          }, r, null, [[18, 40, 43, 46], [24, 30], [51, 59]]);
        }), new (i || (i = Promise))(function (e, t) {
          function n(e) {
            try {
              s(a.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(a.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var r;
            t.done ? e(t.value) : (r = t.value, r instanceof i ? r : new i(function (e) {
              e(r);
            })).then(n, u);
          }
          s((a = a.apply(r, o || [])).next());
        });
        var r, o, i, a;
      }
      function So(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      var To = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, u);
          }
          s((r = r.apply(e, t || [])).next());
        });
      };
      function Oo(e) {
        var t = [],
          n = e.actions,
          r = e.neededToProceed;
        return n["currentAuthenticator-recover"] && t.push(vt.PASSWORD_RECOVERY), r.some(function (e) {
          return "select-enroll-profile" === e.name;
        }) && t.push(vt.REGISTRATION), r.some(function (e) {
          return "redirect-idp" === e.name;
        }) && t.push(vt.SOCIAL_IDP), t;
      }
      function Ao(e) {
        var t,
          n = [],
          r = Object.values(i).reduce(function (e, t) {
            return t.remediationName && (e[t.remediationName] = t), e;
          }, {}),
          o = function (e, t) {
            var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (!n) {
              if (Array.isArray(e) || (n = function (e, t) {
                if (e) {
                  if ("string" == typeof e) return So(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? So(e, t) : void 0;
                }
              }(e)) || t && e && "number" == typeof e.length) {
                n && (e = n);
                var r = 0,
                  o = function () {};
                return {
                  s: o,
                  n: function () {
                    return r >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[r++]
                    };
                  },
                  e: function (e) {
                    throw e;
                  },
                  f: o
                };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i,
              a = !0,
              u = !1;
            return {
              s: function () {
                n = n.call(e);
              },
              n: function () {
                var e = n.next();
                return a = e.done, e;
              },
              e: function (e) {
                u = !0, i = e;
              },
              f: function () {
                try {
                  a || null == n.return || n.return();
                } finally {
                  if (u) throw i;
                }
              }
            };
          }(e);
        try {
          for (o.s(); !(t = o.n()).done;) {
            var a = t.value,
              u = r[a.name];
            if (u) {
              var s = new u(a);
              n.push(s.getNextStep());
            }
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        return n;
      }
      function Eo(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return To(this, void 0, void 0, K().mark(function n() {
          var r, o, i, a, u, s, c, f, l, p, h, d, v, g, y, m, b, k, w, x, S, T, O, A, E, _, R, P, j, I;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                if (f = ht.PENDING, l = !1, n.prev = 2, v = t.flow, g = t.stateTokenExternalId, y = t.state, v && e.idx.setFlow(v), d = Tr(e, {
                  state: y
                }), (h = null == d ? void 0 : d.interactionHandle) || g) {
                  n.next = 14;
                  break;
                }
                return e.transactionManager.clear(), n.next = 11, Pr(e, t);
              case 11:
                m = n.sent, h = m.interactionHandle, d = m.meta;
              case 14:
                return n.next = 16, jr(e, {
                  interactionHandle: h,
                  stateTokenExternalId: g
                });
              case 16:
                if (p = n.sent, t.remediators || t.actions) {
                  n.next = 23;
                  break;
                }
                u = d, s = Oo(p), c = Ao(p.neededToProceed), n.next = 48;
                break;
              case 23:
                return b = Object.assign(Object.assign({}, t), {
                  stateHandle: p.rawIdxState.stateHandle
                }), n.next = 26, xo(p, b, t);
              case 26:
                if (k = n.sent, w = k.idxResponse, x = k.nextStep, S = k.terminal, T = k.canceled, O = k.messages, i = O, (o = x) && w && e.transactionManager.saveIdxResponse(w.rawIdxState), S && (f = ht.TERMINAL, l = !0), !T) {
                  n.next = 41;
                  break;
                }
                f = ht.CANCELED, l = !0, n.next = 48;
                break;
              case 41:
                if (!(null == w ? void 0 : w.interactionCode)) {
                  n.next = 48;
                  break;
                }
                return E = (A = d).clientId, _ = A.codeVerifier, R = A.ignoreSignature, P = A.redirectUri, j = A.urls, I = A.scopes, n.next = 45, e.token.exchangeCodeForTokens({
                  interactionCode: w.interactionCode,
                  clientId: E,
                  codeVerifier: _,
                  ignoreSignature: R,
                  redirectUri: P,
                  scopes: I
                }, j);
              case 45:
                r = n.sent, f = ht.SUCCESS, l = !0;
              case 48:
                n.next = 55;
                break;
              case 50:
                n.prev = 50, n.t0 = n.catch(2), a = n.t0, f = ht.FAILURE, l = !0;
              case 55:
                return l && e.transactionManager.clear(), n.abrupt("return", Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
                  _idxResponse: p,
                  status: f
                }, u && {
                  meta: u
                }), s && {
                  enabledFeatures: s
                }), c && {
                  availableSteps: c
                }), r && {
                  tokens: r.tokens
                }), o && {
                  nextStep: o
                }), i && {
                  messages: i
                }), a && {
                  error: a
                }));
              case 57:
              case "end":
                return n.stop();
            }
          }, n, null, [[2, 50]]);
        }));
      }
      var _o = {
          identify: Qr,
          "select-authenticator-authenticate": io,
          "select-authenticator-enroll": ao,
          "authenticator-enrollment-data": fo,
          "authenticator-verification-data": co,
          "enroll-authenticator": Gr,
          "challenge-authenticator": zr,
          "challenge-poll": Jr,
          "reenroll-authenticator": Zr,
          "enroll-poll": $r,
          "redirect-idp": eo,
          skip: lo
        },
        Ro = {
          identify: Qr,
          "identify-recovery": Qr,
          "select-authenticator-authenticate": io,
          "challenge-authenticator": zr,
          "authenticator-verification-data": co,
          "reset-authenticator": Yr,
          "reenroll-authenticator": Zr
        },
        Po = {
          "select-enroll-profile": uo,
          "enroll-profile": Xr,
          "authenticator-enrollment-data": fo,
          "select-authenticator-enroll": ao,
          "enroll-poll": $r,
          "enroll-authenticator": Gr,
          skip: lo
        };
      function jo(e) {
        var t,
          n,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "proceed";
        switch (r) {
          case "register":
          case "signup":
          case "enrollProfile":
            t = Po;
            break;
          case "recoverPassword":
          case "resetPassword":
            t = Ro, n = ["currentAuthenticator-recover", "currentAuthenticatorEnrollment-recover"];
            break;
          default:
            t = _o;
        }
        return {
          flow: r,
          remediators: t,
          actions: n
        };
      }
      function Io(e, t) {
        return n = this, r = void 0, o = void 0, i = K().mark(function n() {
          var r;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return r = jo(e, "authenticate"), n.abrupt("return", Eo(e, Object.assign(Object.assign({}, t), r)));
              case 2:
              case "end":
                return n.stop();
            }
          }, n);
        }), new (o || (o = Promise))(function (e, t) {
          function a(e) {
            try {
              s(i.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(i.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function (e) {
              e(n);
            })).then(a, u);
          }
          s((i = i.apply(n, r || [])).next());
        });
        var n, r, o, i;
      }
      function Co(e, t) {
        return n = this, r = void 0, o = void 0, i = K().mark(function n() {
          var r, o;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return r = e.transactionManager.load(), o = jo(e, r.flow), n.abrupt("return", Eo(e, Object.assign(Object.assign(Object.assign({}, t), o), {
                  actions: ["cancel"]
                })));
              case 3:
              case "end":
                return n.stop();
            }
          }, n);
        }), new (o || (o = Promise))(function (e, t) {
          function a(e) {
            try {
              s(i.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(i.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function (e) {
              e(n);
            })).then(a, u);
          }
          s((i = i.apply(n, r || [])).next());
        });
        var n, r, o, i;
      }
      var Mo = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, u);
          }
          s((r = r.apply(e, t || [])).next());
        });
      };
      function Uo(e, t) {
        return !!Tr(e, t);
      }
      function Fo(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Mo(this, void 0, void 0, K().mark(function n() {
          var r, o, i, a;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                if (r = t.stateTokenExternalId, o = t.state, (i = Tr(e, {
                  state: o
                })) || r) {
                  n.next = 4;
                  break;
                }
                throw new b("Unable to proceed: saved transaction could not be loaded");
              case 4:
                return a = jo(e, null == i ? void 0 : i.flow), n.abrupt("return", Eo(e, Object.assign(Object.assign({}, t), a)));
              case 6:
              case "end":
                return n.stop();
            }
          }, n);
        }));
      }
      var No = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, u);
          }
          s((r = r.apply(e, t || [])).next());
        });
      };
      function Lo(e) {
        var t,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return No(this, void 0, void 0, K().mark(function r() {
          var o, i, a;
          return K().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, Fo(e, {
                  startPolling: !0
                });
              case 2:
                if (o = r.sent, i = Tr(e), (null == (a = null === (t = null == i ? void 0 : i.remediations) || void 0 === t ? void 0 : t.find(function (e) {
                  return e.includes("poll");
                })) ? void 0 : a.length) || Sn("No polling remediations available at the current IDX flow stage"), !Number.isInteger(n.refresh)) {
                  r.next = 8;
                  break;
                }
                return r.abrupt("return", new Promise(function (t, r) {
                  setTimeout(function () {
                    var n, i;
                    return No(this, void 0, void 0, K().mark(function a() {
                      var u;
                      return K().wrap(function (a) {
                        for (;;) switch (a.prev = a.next) {
                          case 0:
                            try {
                              u = null === (i = null === (n = o.nextStep) || void 0 === n ? void 0 : n.poll) || void 0 === i ? void 0 : i.refresh, t(u ? Lo(e, {
                                refresh: u
                              }) : o);
                            } catch (e) {
                              r(e);
                            }
                          case 1:
                          case "end":
                            return a.stop();
                        }
                      }, a);
                    }));
                  }, n.refresh);
                }));
              case 8:
                return r.abrupt("return", o);
              case 9:
              case "end":
                return r.stop();
            }
          }, r);
        }));
      }
      var Do = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, u);
          }
          s((r = r.apply(e, t || [])).next());
        });
      };
      function Bo(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Do(this, void 0, void 0, K().mark(function n() {
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return e.transactionManager.clear(), n.abrupt("return", Eo(e, t));
              case 2:
              case "end":
                return n.stop();
            }
          }, n);
        }));
      }
      var qo = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, u);
          }
          s((r = r.apply(e, t || [])).next());
        });
      };
      function Ho(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return qo(this, void 0, void 0, K().mark(function n() {
          var r, o, i, a, u, s;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                if (Sr(e)) {
                  n.next = 12;
                  break;
                }
                return n.next = 3, Bo(e, Object.assign({
                  flow: "register"
                }, t));
              case 3:
                if (r = n.sent, o = r.enabledFeatures, i = r.availableSteps, t.activationToken || !o || o.includes(vt.REGISTRATION)) {
                  n.next = 9;
                  break;
                }
                return a = new b("Registration is not supported based on your current org configuration."), n.abrupt("return", {
                  status: ht.FAILURE,
                  error: a
                });
              case 9:
                if (!t.activationToken || !(null == i ? void 0 : i.some(function (e) {
                  return "identify" === e.name;
                }))) {
                  n.next = 12;
                  break;
                }
                return u = new b("activationToken is not supported based on your current org configuration."), n.abrupt("return", {
                  status: ht.FAILURE,
                  error: u
                });
              case 12:
                return s = jo(e, "register"), n.abrupt("return", Eo(e, Object.assign(Object.assign({}, t), s)));
              case 14:
              case "end":
                return n.stop();
            }
          }, n);
        }));
      }
      function Ko(e, t) {
        return n = this, r = void 0, o = void 0, i = K().mark(function n() {
          var r;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return r = jo(e, "recoverPassword"), n.abrupt("return", Eo(e, Object.assign(Object.assign({}, t), r)));
              case 2:
              case "end":
                return n.stop();
            }
          }, n);
        }), new (o || (o = Promise))(function (e, t) {
          function a(e) {
            try {
              s(i.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(i.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function (e) {
              e(n);
            })).then(a, u);
          }
          s((i = i.apply(n, r || [])).next());
        });
        var n, r, o, i;
      }
      function Vo(e, t) {
        return n = this, r = void 0, o = void 0, i = K().mark(function n() {
          var r, o, i, a, u, s, c, f, l, p;
          return K().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                if (r = e.transactionManager.load()) {
                  n.next = 3;
                  break;
                }
                throw new b("No transaction data was found in storage");
              case 3:
                if (o = r.codeVerifier, i = r.state, a = new URL(t), u = a.searchParams, s = u.get("state"), c = u.get("interaction_code"), !(f = u.get("error"))) {
                  n.next = 10;
                  break;
                }
                throw new k(f, u.get("error_description"));
              case 10:
                if (s === i) {
                  n.next = 12;
                  break;
                }
                throw new b("State in redirect uri does not match with transaction state");
              case 12:
                if (c) {
                  n.next = 14;
                  break;
                }
                throw new b("Unable to parse interaction_code from the url");
              case 14:
                return n.next = 16, e.token.exchangeCodeForTokens({
                  interactionCode: c,
                  codeVerifier: o
                });
              case 16:
                l = n.sent, p = l.tokens, e.tokenManager.setTokens(p);
              case 19:
              case "end":
                return n.stop();
            }
          }, n);
        }), new (o || (o = Promise))(function (e, t) {
          function a(e) {
            try {
              s(i.next(e));
            } catch (e) {
              t(e);
            }
          }
          function u(e) {
            try {
              s(i.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function s(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function (e) {
              e(n);
            })).then(a, u);
          }
          s((i = i.apply(n, r || [])).next());
        });
        var n, r, o, i;
      }
      var Go = function () {
          function e() {
            a(this, e), this.environments = ["okta-auth-js/".concat("5.11.0")];
          }
          return q(e, [{
            key: "addEnvironment",
            value: function (e) {
              this.environments.push(e);
            }
          }, {
            key: "getHttpHeader",
            value: function () {
              return this.maybeAddNodeEnvironment(), {
                "X-Okta-User-Agent-Extended": this.environments.join(" ")
              };
            }
          }, {
            key: "getVersion",
            value: function () {
              return "5.11.0";
            }
          }, {
            key: "maybeAddNodeEnvironment",
            value: function () {
              if (!yt() && process && process.versions) {
                var e = process.versions.node;
                this.environments.push("nodejs/".concat(e));
              }
            }
          }]), e;
        }(),
        Wo = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                s(r.next(e));
              } catch (e) {
                i(e);
              }
            }
            function u(e) {
              try {
                s(r.throw(e));
              } catch (e) {
                i(e);
              }
            }
            function s(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, u);
            }
            s((r = r.apply(e, t || [])).next());
          });
        },
        $o = function (e, t) {
          var n = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
          return n;
        },
        zo = n(4279),
        Jo = function () {
          function e(t) {
            var n = this;
            a(this, e);
            var r = this.options = function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              return jn(e), M({
                issuer: xe((e = mr(yr(), e)).issuer),
                tokenUrl: xe(e.tokenUrl),
                authorizeUrl: xe(e.authorizeUrl),
                userinfoUrl: xe(e.userinfoUrl),
                revokeUrl: xe(e.revokeUrl),
                logoutUrl: xe(e.logoutUrl),
                clientId: e.clientId,
                redirectUri: e.redirectUri,
                state: e.state,
                scopes: e.scopes,
                postLogoutRedirectUri: e.postLogoutRedirectUri,
                responseMode: e.responseMode,
                responseType: e.responseType,
                pkce: !1 !== e.pkce,
                useInteractionCodeFlow: e.useInteractionCodeFlow,
                httpRequestClient: e.httpRequestClient,
                transformErrorXHR: e.transformErrorXHR,
                transformAuthState: e.transformAuthState,
                restoreOriginalUri: e.restoreOriginalUri,
                storageUtil: e.storageUtil,
                headers: e.headers,
                devMode: !!e.devMode,
                storageManager: e.storageManager,
                transactionManager: e.transactionManager,
                cookies: yt() ? gr(e, Ot()) : e.cookies,
                ignoreSignature: !!e.ignoreSignature,
                clientSecret: e.clientSecret
              });
            }(t);
            this.storageManager = new Zn(r.storageManager, r.cookies, r.storageUtil), this.transactionManager = new ir(Object.assign({
              storageManager: this.storageManager
            }, r.transactionManager)), this._oktaUserAgent = new Go(), this.tx = {
              status: Ue.bind(null, this),
              resume: Fe.bind(null, this),
              exists: Object.assign(Le.bind(null, this), {
                _get: function (e) {
                  return r.storageUtil.storage.get(e);
                }
              }),
              introspect: Ne.bind(null, this)
            }, this.pkce = {
              DEFAULT_CODE_CHALLENGE_METHOD: He.DEFAULT_CODE_CHALLENGE_METHOD,
              generateVerifier: He.generateVerifier,
              computeChallenge: He.computeChallenge
            }, Object.assign(this.options.storageUtil, {
              getPKCEStorage: this.storageManager.getLegacyPKCEStorage.bind(this.storageManager),
              getHttpCache: this.storageManager.getHttpCache.bind(this.storageManager)
            }), this._pending = {
              handleLogin: !1
            }, yt() ? (this.options = Object.assign(this.options, {
              redirectUri: be(t.redirectUri, window.location.origin)
            }), this.userAgent = In(t, "okta-auth-js/".concat("5.11.0"))) : this.userAgent = In(t, "okta-auth-js-server/".concat("5.11.0")), t.maxClockSkew || 0 === t.maxClockSkew ? this.options.maxClockSkew = t.maxClockSkew : this.options.maxClockSkew = W, this.options.ignoreLifetime = !!t.ignoreLifetime, this.session = {
              close: Ge.bind(null, this),
              exists: Ke.bind(null, this),
              get: Ve.bind(null, this),
              refresh: We.bind(null, this),
              setCookieAndRedirect: $e.bind(null, this)
            }, this._tokenQueue = new Vn(), this.token = {
              prepareTokenParams: Dt.bind(null, this),
              exchangeCodeForTokens: rn.bind(null, this),
              getWithoutPrompt: sn.bind(null, this),
              getWithPopup: vn.bind(null, this),
              getWithRedirect: gn.bind(null, this),
              parseFromUrl: kn.bind(null, this),
              decode: tn,
              revoke: nn.bind(null, this),
              renew: pn.bind(null, this),
              renewTokensWithRefresh: cn.bind(null, this),
              renewTokens: hn.bind(null, this),
              getUserInfo: dn.bind(null, this),
              verify: on.bind(null, this),
              isLoginRedirect: Nt.bind(null, this)
            };
            var o,
              i,
              u = ["decode", "isLoginRedirect"];
            Object.keys(this.token).forEach(function (e) {
              if (!(u.indexOf(e) >= 0)) {
                var t = n.token[e];
                n.token[e] = Vn.prototype.push.bind(n._tokenQueue, t, null);
              }
            }), Object.assign(this.token.getWithRedirect, {
              _setLocation: function (e) {
                window.location = e;
              }
            }), Object.assign(this.token.parseFromUrl, {
              _getHistory: function () {
                return window.history;
              },
              _getLocation: function () {
                return window.location;
              },
              _getDocument: function () {
                return window.document;
              }
            }), this.idx = {
              interact: Pr.bind(null, this),
              introspect: jr.bind(null, this),
              authenticate: Io.bind(null, this),
              register: Ho.bind(null, this),
              poll: Lo.bind(null, this),
              proceed: Fo.bind(null, this),
              cancel: Co.bind(null, this),
              recoverPassword: Ko.bind(null, this),
              handleInteractionCodeRedirect: Vo.bind(null, this),
              startTransaction: Bo.bind(null, this),
              setFlow: function (e) {
                n.options.flow = e;
              },
              getFlow: function () {
                return n.options.flow;
              },
              canProceed: Uo.bind(null, this)
            }, i = this, o = function (e) {
              var t = i._oktaUserAgent.getHttpHeader(),
                n = Object.assign(Object.assign({}, t), i.options.headers);
              Object.keys(n).forEach(function (t) {
                e.headers[t] = n[t];
              });
            }, kr().client.interceptors.request.use(o), this.http = {
              setRequestHeader: pe.bind(null, this)
            }, this.fingerprint = Gn.bind(null, this), this.emitter = new zo(), this.tokenManager = new Hn(this, t.tokenManager), this.authStateManager = new Yn(this);
          }
          return q(e, [{
            key: "start",
            value: function () {
              this.tokenManager.start(), this.token.isLoginRedirect() || this.authStateManager.updateAuthState();
            }
          }, {
            key: "stop",
            value: function () {
              this.tokenManager.stop();
            }
          }, {
            key: "setHeaders",
            value: function (e) {
              this.options.headers = Object.assign({}, this.options.headers, e);
            }
          }, {
            key: "isInteractionRequired",
            value: function (e) {
              return Lt(this, e);
            }
          }, {
            key: "isInteractionRequiredError",
            value: function (e) {
              return _t(e);
            }
          }, {
            key: "isEmailVerifyCallback",
            value: function (e) {
              return Rn(e);
            }
          }, {
            key: "parseEmailVerifyCallback",
            value: function (e) {
              return Pn(e);
            }
          }, {
            key: "signIn",
            value: function (e) {
              return Wo(this, void 0, void 0, K().mark(function t() {
                return K().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return t.abrupt("return", this.signInWithCredentials(e));
                    case 1:
                    case "end":
                      return t.stop();
                  }
                }, t, this);
              }));
            }
          }, {
            key: "signInWithCredentials",
            value: function (e) {
              return Wo(this, void 0, void 0, K().mark(function t() {
                var n,
                  r = this;
                return K().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      if (e = U(e || {}), n = function (t) {
                        return delete e.sendFingerprint, De(r, "/api/v1/authn", e, t);
                      }, e.sendFingerprint) {
                        t.next = 4;
                        break;
                      }
                      return t.abrupt("return", n());
                    case 4:
                      return t.abrupt("return", this.fingerprint().then(function (e) {
                        return n({
                          headers: {
                            "X-Device-Fingerprint": e
                          }
                        });
                      }));
                    case 5:
                    case "end":
                      return t.stop();
                  }
                }, t, this);
              }));
            }
          }, {
            key: "signInWithRedirect",
            value: function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              return Wo(this, void 0, void 0, K().mark(function t() {
                var n, r, o;
                return K().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      if (n = e.originalUri, r = $o(e, ["originalUri"]), !this._pending.handleLogin) {
                        t.next = 3;
                        break;
                      }
                      return t.abrupt("return");
                    case 3:
                      return this._pending.handleLogin = !0, t.prev = 4, n && this.setOriginalUri(n), o = Object.assign({
                        scopes: this.options.scopes || ["openid", "email", "profile"]
                      }, r), t.next = 9, this.token.getWithRedirect(o);
                    case 9:
                      return t.prev = 9, this._pending.handleLogin = !1, t.finish(9);
                    case 12:
                    case "end":
                      return t.stop();
                  }
                }, t, this, [[4,, 9, 12]]);
              }));
            }
          }, {
            key: "closeSession",
            value: function () {
              var e = this;
              return this.session.close().then(function () {
                return Wo(e, void 0, void 0, K().mark(function e() {
                  return K().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        this.tokenManager.clear();
                      case 1:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                }));
              }).catch(function (e) {
                if ("AuthApiError" === e.name && "E0000007" === e.errorCode) return null;
                throw e;
              });
            }
          }, {
            key: "revokeAccessToken",
            value: function (e) {
              return Wo(this, void 0, void 0, K().mark(function t() {
                var n;
                return K().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      if (e) {
                        t.next = 6;
                        break;
                      }
                      return t.next = 3, this.tokenManager.getTokens();
                    case 3:
                      e = t.sent.accessToken, n = this.tokenManager.getStorageKeyByType("accessToken"), this.tokenManager.remove(n);
                    case 6:
                      if (e) {
                        t.next = 8;
                        break;
                      }
                      return t.abrupt("return", Promise.resolve(null));
                    case 8:
                      return t.abrupt("return", this.token.revoke(e));
                    case 9:
                    case "end":
                      return t.stop();
                  }
                }, t, this);
              }));
            }
          }, {
            key: "revokeRefreshToken",
            value: function (e) {
              return Wo(this, void 0, void 0, K().mark(function t() {
                var n;
                return K().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      if (e) {
                        t.next = 6;
                        break;
                      }
                      return t.next = 3, this.tokenManager.getTokens();
                    case 3:
                      e = t.sent.refreshToken, n = this.tokenManager.getStorageKeyByType("refreshToken"), this.tokenManager.remove(n);
                    case 6:
                      if (e) {
                        t.next = 8;
                        break;
                      }
                      return t.abrupt("return", Promise.resolve(null));
                    case 8:
                      return t.abrupt("return", this.token.revoke(e));
                    case 9:
                    case "end":
                      return t.stop();
                  }
                }, t, this);
              }));
            }
          }, {
            key: "getSignOutRedirectUrl",
            value: function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = e.idToken,
                n = e.postLogoutRedirectUri,
                r = e.state;
              if (t || (t = this.tokenManager.getTokensSync().idToken), !t) return "";
              n || (n = this.options.postLogoutRedirectUri);
              var o = pt(this).logoutUrl,
                i = t.idToken,
                a = o + "?id_token_hint=" + encodeURIComponent(i);
              return n && (a += "&post_logout_redirect_uri=" + encodeURIComponent(n)), r && (a += "&state=" + encodeURIComponent(r)), a;
            }
          }, {
            key: "signOut",
            value: function (e) {
              return Wo(this, void 0, void 0, K().mark(function t() {
                var n, r, o, i, a, u, s, c;
                return K().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      if (e = Object.assign({}, e), n = window.location.origin, r = window.location.href, o = e.postLogoutRedirectUri || this.options.postLogoutRedirectUri || n, i = e.accessToken, a = e.refreshToken, u = !1 !== e.revokeAccessToken, (s = !1 !== e.revokeRefreshToken) && void 0 === a && (a = this.tokenManager.getTokensSync().refreshToken), u && void 0 === i && (i = this.tokenManager.getTokensSync().accessToken), e.idToken || (e.idToken = this.tokenManager.getTokensSync().idToken), !s || !a) {
                        t.next = 14;
                        break;
                      }
                      return t.next = 14, this.revokeRefreshToken(a);
                    case 14:
                      if (!u || !i) {
                        t.next = 17;
                        break;
                      }
                      return t.next = 17, this.revokeAccessToken(i);
                    case 17:
                      if (c = this.getSignOutRedirectUrl(Object.assign(Object.assign({}, e), {
                        postLogoutRedirectUri: o
                      }))) {
                        t.next = 22;
                        break;
                      }
                      return t.abrupt("return", this.closeSession().then(function () {
                        o === r ? window.location.reload() : window.location.assign(o);
                      }));
                    case 22:
                      e.clearTokensAfterRedirect ? this.tokenManager.addPendingRemoveFlags() : this.tokenManager.clear(), window.location.assign(c);
                    case 24:
                    case "end":
                      return t.stop();
                  }
                }, t, this);
              }));
            }
          }, {
            key: "webfinger",
            value: function (e) {
              return Te(this, "/.well-known/webfinger" + we(e), {
                headers: {
                  Accept: "application/jrd+json"
                }
              });
            }
          }, {
            key: "isAuthenticated",
            value: function () {
              return Wo(this, void 0, void 0, K().mark(function e() {
                var t, n, r, o, i, a;
                return K().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (t = this.tokenManager.getTokensSync(), n = t.accessToken, r = t.idToken, o = this.tokenManager.getOptions(), i = o.autoRenew, a = o.autoRemove, !n || !this.tokenManager.hasExpired(n)) {
                        e.next = 16;
                        break;
                      }
                      if (n = null, !i) {
                        e.next = 15;
                        break;
                      }
                      return e.prev = 5, e.next = 8, this.tokenManager.renew("accessToken");
                    case 8:
                      n = e.sent, e.next = 13;
                      break;
                    case 11:
                      e.prev = 11, e.t0 = e.catch(5);
                    case 13:
                      e.next = 16;
                      break;
                    case 15:
                      a && this.tokenManager.remove("accessToken");
                    case 16:
                      if (!r || !this.tokenManager.hasExpired(r)) {
                        e.next = 30;
                        break;
                      }
                      if (r = null, !i) {
                        e.next = 29;
                        break;
                      }
                      return e.prev = 19, e.next = 22, this.tokenManager.renew("idToken");
                    case 22:
                      r = e.sent, e.next = 27;
                      break;
                    case 25:
                      e.prev = 25, e.t1 = e.catch(19);
                    case 27:
                      e.next = 30;
                      break;
                    case 29:
                      a && this.tokenManager.remove("idToken");
                    case 30:
                      return e.abrupt("return", !(!n || !r));
                    case 31:
                    case "end":
                      return e.stop();
                  }
                }, e, this, [[5, 11], [19, 25]]);
              }));
            }
          }, {
            key: "getUser",
            value: function () {
              return Wo(this, void 0, void 0, K().mark(function e() {
                var t, n, r;
                return K().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return t = this.tokenManager.getTokensSync(), n = t.idToken, r = t.accessToken, e.abrupt("return", this.token.getUserInfo(r, n));
                    case 2:
                    case "end":
                      return e.stop();
                  }
                }, e, this);
              }));
            }
          }, {
            key: "getIdToken",
            value: function () {
              var e = this.tokenManager.getTokensSync().idToken;
              return e ? e.idToken : void 0;
            }
          }, {
            key: "getAccessToken",
            value: function () {
              var e = this.tokenManager.getTokensSync().accessToken;
              return e ? e.accessToken : void 0;
            }
          }, {
            key: "getRefreshToken",
            value: function () {
              var e = this.tokenManager.getTokensSync().refreshToken;
              return e ? e.refreshToken : void 0;
            }
          }, {
            key: "storeTokensFromRedirect",
            value: function () {
              return Wo(this, void 0, void 0, K().mark(function e() {
                var t, n;
                return K().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, this.token.parseFromUrl();
                    case 2:
                      t = e.sent, n = t.tokens, this.tokenManager.setTokens(n);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e, this);
              }));
            }
          }, {
            key: "setOriginalUri",
            value: function (e, t) {
              _n.getSessionStorage().setItem(ue, e), (t = t || this.options.state) && this.storageManager.getOriginalUriStorage().setItem(t, e);
            }
          }, {
            key: "getOriginalUri",
            value: function (e) {
              if (e = e || this.options.state) {
                var t = this.storageManager.getOriginalUriStorage().getItem(e);
                if (t) return t;
              }
              var n = _n.getSessionStorage();
              return n ? n.getItem(ue) : void 0;
            }
          }, {
            key: "removeOriginalUri",
            value: function (e) {
              _n.getSessionStorage().removeItem(ue), (e = e || this.options.state) && this.storageManager.getOriginalUriStorage().removeItem(e);
            }
          }, {
            key: "isLoginRedirect",
            value: function () {
              return Nt(this);
            }
          }, {
            key: "handleLoginRedirect",
            value: function (e, t) {
              return Wo(this, void 0, void 0, K().mark(function n() {
                var r, o, i;
                return K().wrap(function (n) {
                  for (;;) switch (n.prev = n.next) {
                    case 0:
                      if (r = this.options.state, !e) {
                        n.next = 6;
                        break;
                      }
                      this.tokenManager.setTokens(e), t = t || this.getOriginalUri(this.options.state), n.next = 17;
                      break;
                    case 6:
                      if (!this.isLoginRedirect()) {
                        n.next = 16;
                        break;
                      }
                      return n.next = 9, mn(this, {});
                    case 9:
                      return o = n.sent, r = o.state, t = t || this.getOriginalUri(r), n.next = 14, this.storeTokensFromRedirect();
                    case 14:
                      n.next = 17;
                      break;
                    case 16:
                      return n.abrupt("return");
                    case 17:
                      return n.next = 19, this.authStateManager.updateAuthState();
                    case 19:
                      if (this.removeOriginalUri(r), !(i = this.options.restoreOriginalUri)) {
                        n.next = 26;
                        break;
                      }
                      return n.next = 24, i(this, t);
                    case 24:
                      n.next = 27;
                      break;
                    case 26:
                      window.location.replace(t);
                    case 27:
                    case "end":
                      return n.stop();
                  }
                }, n, this);
              }));
            }
          }, {
            key: "isPKCE",
            value: function () {
              return !!this.options.pkce;
            }
          }, {
            key: "hasResponseType",
            value: function (e) {
              return Array.isArray(this.options.responseType) && this.options.responseType.length ? this.options.responseType.indexOf(e) >= 0 : this.options.responseType === e;
            }
          }, {
            key: "isAuthorizationCodeFlow",
            value: function () {
              return this.hasResponseType("code");
            }
          }, {
            key: "getIssuerOrigin",
            value: function () {
              return this.options.issuer.split("/oauth2/")[0];
            }
          }, {
            key: "forgotPassword",
            value: function (e) {
              return De(this, "/api/v1/authn/recovery/password", e);
            }
          }, {
            key: "unlockAccount",
            value: function (e) {
              return De(this, "/api/v1/authn/recovery/unlock", e);
            }
          }, {
            key: "verifyRecoveryToken",
            value: function (e) {
              return De(this, "/api/v1/authn/recovery/token", e);
            }
          }]), e;
        }();
      Jo.features = Jo.prototype.features = o, Object.assign(Jo, {
        constants: t,
        isInteractionRequiredError: _t
      });
      var Yo = Jo;
    }(), r;
  }();
});